var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaroga(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-88"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-88",
    cx: 250,
    cy: 352.72,
    rx: 240.78,
    ry: 139.01,
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-88",
    d: "M212.07,482.33A24.5,24.5,0,0,1,200,479.27l-152-87.79c-5.2-3-8.31-8-8.31-13.48s3.11-10.47,8.31-13.47L285.1,227.59a25.49,25.49,0,0,1,24.22,0l152,87.79c5.21,3,8.31,8,8.31,13.48s-3.1,10.47-8.31,13.47L224.18,479.27A24.48,24.48,0,0,1,212.07,482.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-88",
    d: "M471,368.46c-16.3-9.41-42.72-9.41-59,0s-16.3,24.66,0,34.07,42.72,9.41,59,0S487.31,377.87,471,368.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-88",
    cx: 48.94,
    cy: 431.32,
    rx: 27.19,
    ry: 15.7,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M477.42,128.09c0-25.69-16.92-56.29-37.79-68.33-11.05-6.38-21-6.28-27.9-1-8.59,3.57-14.09,13.45-14.09,28.09V224.45l75.58,43.64,4.2-2.43Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.22,268.09V130.51c0-25.69-16.92-56.28-37.79-68.33s-37.79-1-37.79,24.7V224.45Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.09,130.51V260.93l-67.31-38.87V86.88c0-12.84,4.51-21.69,12.11-24.49a15.71,15.71,0,0,1,5.51-1c4.3,0,9,1.45,14,4.32C453.07,77.13,469.09,106.18,469.09,130.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.78 222.06 406.05 219.6 469.09 256 469.09 260.93 401.78 222.06",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.09,130.51V256l-63-36.41V84.41c0-10.2,2.86-17.89,7.85-22a15.71,15.71,0,0,1,5.51-1c4.3,0,9,1.45,14,4.32C453.07,77.13,469.09,106.18,469.09,130.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.5 242.69 433.37 240.3 433.37 64.27 437.5 64.27 437.5 242.69",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.63,71.74V240.3l-4.13,2.38V68.44A52.34,52.34,0,0,1,441.63,71.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.78 192.9 433.37 211.14 433.37 215.99 401.78 197.75 401.78 192.9",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.05 190.44 401.78 192.9 433.37 211.14 433.37 206.29 406.05 190.44",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.5 213.52 469.09 231.76 469.08 236.61 437.5 218.38 437.5 213.52",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "441.77 211.06 437.5 213.52 469.09 231.76 469.09 226.91 441.77 211.06",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.78 96.08 433.37 114.32 433.37 119.17 401.78 100.94 401.78 96.08",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.05 93.62 401.78 96.08 433.37 114.32 433.37 109.47 406.05 93.62",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.5 116.7 469.09 134.94 469.08 139.79 437.5 121.56 437.5 116.7",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "441.77 114.24 437.5 116.7 469.09 134.94 469.09 130.09 441.77 114.24",
    style: {
      fill: "#ebebeb"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47,371.23c0,3.88,2.91,8.71,6.49,10.78L205.58,469.8a14.36,14.36,0,0,0,13,0L455.75,332.86c3.59-2.07,6.5-6.9,6.5-10.78s-2.91-8.72-6.5-10.79l-152-87.79a14.36,14.36,0,0,0-13,0L53.53,360.44C49.94,362.51,47,367.34,47,371.23Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.53,367.94l152.05,87.79a14.36,14.36,0,0,0,13,0L455.75,318.79c3.59-2.07,3.59-5.43,0-7.5l-152-87.79a14.36,14.36,0,0,0-13,0L53.53,360.44C49.94,362.51,49.94,365.87,53.53,367.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.08,457.29v14.06a13.21,13.21,0,0,1-6.5-1.55L53.53,382c-3.59-2.07-6.5-6.9-6.5-10.78,0-3.65,2.57-8.12,5.84-10.37-2.91,2.09-2.69,5.15.66,7.08l152.05,87.79A13.22,13.22,0,0,0,212.08,457.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.94,360.67c-3.36-1.94-3.18-5.22-3.18-9.36V165.56a14.34,14.34,0,0,1,6.5-11.25L281.44,17.37c3.58-2.07,8.8-2.09,11.84.33s3.93,4.66,3.93,8.8V212.25a14.34,14.34,0,0,1-6.5,11.25L53.53,360.44C49.94,362.51,44.31,362.61,40.94,360.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.21,26.5c0-4.14-2.91-5.81-6.5-3.75L53.53,159.69a13.13,13.13,0,0,0-4.59,4.86l-9.27-5.39h0a13.4,13.4,0,0,1,4.6-4.86L281.43,17.37c3.59-2.07,8.82-2.11,11.85.33C296.47,20.28,297.21,22.36,297.21,26.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.76,360.83c-3.58,1.68-8.68,1.65-11.82-.16-3.36-1.94-3.18-5.22-3.18-9.36V165.55a13.08,13.08,0,0,1,1.91-6.39l9.27,5.37h0A13.32,13.32,0,0,0,47,170.93V356.69C47,360.53,49.54,362.26,52.76,360.83Z",
    style: {
      fill: "#263238"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57,167.18,285.27,35.44c2.16-1.24,3.9-.24,3.9,2.25V210.43a8.59,8.59,0,0,1-3.9,6.75L57,348.92c-2.15,1.25-3.89.24-3.89-2.25V173.93A8.63,8.63,0,0,1,57,167.18Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57,167.18a8.63,8.63,0,0,0-3.89,6.75V343.66L278.77,213.43a8.63,8.63,0,0,0,3.9-6.75V36.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.59,361.54l218-125.84a6.82,6.82,0,0,1,6.13,0l7.94,4.46c1.69,1,1.69,2.56,0,3.53l-218,125.82a6.74,6.74,0,0,1-6.12,0l-7.91-4.43C71.9,364.1,71.9,362.52,73.59,361.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,374.17,313,248.33a6.22,6.22,0,0,1,5.59-.31l56.73,32.76c1.4.81,1.17,2.25-.53,3.23L157.05,409.68a6.3,6.3,0,0,1-5.6.31l-57-32.6C93.07,376.59,93.31,375.14,95,374.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.86,301.18l6.82-3.94c.3-.16.32-.42.06-.57l-6.52-3.77a1.14,1.14,0,0,0-1,0l-6.82,3.94c-.29.17-.32.43-.06.58l6.53,3.77A1.09,1.09,0,0,0,283.86,301.18Zm-10-13.63-6.83,3.94c-.29.17-.31.42-.06.57l6.53,3.77a1.12,1.12,0,0,0,1,0l6.83-3.94c.29-.17.32-.43.06-.57l-6.53-3.77A1.08,1.08,0,0,0,273.9,287.55Zm-22,12.73L240.3,307c-.29.16-.32.42-.06.57l6.53,3.77a1.09,1.09,0,0,0,1,0l11.55-6.66c.29-.17.32-.43.06-.58l-6.53-3.77A1.12,1.12,0,0,0,251.85,300.28Zm12.07-7-6.82,3.94c-.29.17-.32.42-.06.57l6.53,3.77a1.12,1.12,0,0,0,1,0l6.82-3.94c.29-.17.32-.43.06-.58l-6.53-3.77A1.12,1.12,0,0,0,263.92,293.31Zm-26.77,15.46-6.82,3.93c-.29.17-.32.43-.06.58l6.53,3.77a1.09,1.09,0,0,0,1,0l6.82-3.94c.29-.16.32-.42.06-.57l-6.53-3.77A1.09,1.09,0,0,0,237.15,308.77Zm-10,5.75-6.83,3.94c-.29.17-.31.43-.06.58l6.53,3.77a1.12,1.12,0,0,0,1,0l6.83-3.94c.29-.17.31-.42.06-.57l-6.53-3.77A1.12,1.12,0,0,0,227.18,314.52Zm25.59,15.38,6.82-3.94c.29-.16.32-.42.06-.57l-6.53-3.77a1.09,1.09,0,0,0-1,0l-6.82,3.94c-.29.16-.32.42-.06.57l6.53,3.77A1.09,1.09,0,0,0,252.77,329.9Zm-10,5.76,6.83-3.94c.29-.16.31-.42.06-.57l-6.53-3.77a1.12,1.12,0,0,0-1,0l-6.83,3.94c-.29.17-.31.43-.06.58l6.53,3.77A1.09,1.09,0,0,0,242.79,335.66Zm-10,5.76,6.82-3.94c.29-.17.32-.42.06-.57l-6.53-3.77a1.12,1.12,0,0,0-1,0l-6.82,3.94c-.29.17-.32.43-.06.58l6.53,3.77A1.12,1.12,0,0,0,232.82,341.42Zm-10,5.76,6.82-3.94c.29-.17.32-.42.06-.57l-6.53-3.77a1.08,1.08,0,0,0-1,0l-6.83,3.94c-.29.17-.31.43,0,.57l6.52,3.77A1.1,1.1,0,0,0,222.85,347.18Zm51-40.24,6.82-3.94c.29-.17.32-.42.06-.57l-6.53-3.77a1.12,1.12,0,0,0-1,0l-6.82,3.94c-.29.17-.32.43-.06.58L272.9,307A1.12,1.12,0,0,0,273.89,306.94Zm-11.15,17.21L278,315.36c.29-.17.32-.43.06-.58l-15.85-9.15a1.12,1.12,0,0,0-1,0l-7.88,4.55c-.29.17-.31.42-.06.57l8.4,4.85c.26.15.23.4-.06.57l-6.3,3.64c-.29.17-.32.42-.06.57l6.53,3.77A1.12,1.12,0,0,0,262.74,324.15Zm-45.54-3.87-6.82,3.94c-.29.17-.32.43-.06.57l6.53,3.77a1.08,1.08,0,0,0,1,0l6.82-3.94c.29-.17.32-.42.06-.57l-6.53-3.77A1.08,1.08,0,0,0,217.2,320.28Zm-10,5.76L200.4,330c-.29.17-.31.42-.05.57l6.52,3.77a1.1,1.1,0,0,0,1,0l6.82-3.94c.29-.17.32-.43.06-.57L208.22,326A1.08,1.08,0,0,0,207.23,326ZM152,387.52a1.08,1.08,0,0,0,1,0l6.82-3.94c.29-.17.32-.42.06-.57l-6.53-3.77a1.08,1.08,0,0,0-1,0l-6.82,3.94c-.29.17-.32.42-.06.57Zm-24.6-15.41-6.83,3.94c-.29.17-.31.42-.06.57l6.53,3.77a1.12,1.12,0,0,0,1,0l6.83-3.94c.29-.17.31-.43.06-.58l-6.53-3.76A1.08,1.08,0,0,0,127.44,372.11Zm12.64,11.54a1.1,1.1,0,0,0,1,0l6.82-3.94c.29-.17.32-.42.06-.57l-6.53-3.77a1.08,1.08,0,0,0-1,0l-6.83,3.94c-.29.17-.31.43-.05.57Zm27.52,6.19,6.83-3.94c.29-.16.31-.42.06-.57L168,381.56a1.09,1.09,0,0,0-1,0l-6.83,3.94c-.29.16-.31.42-.06.57l6.53,3.77A1.09,1.09,0,0,0,167.6,389.84Zm-11,5.8a1.12,1.12,0,0,0,1,0l6.82-3.94c.29-.17.32-.42.06-.57L158,387.32a1.12,1.12,0,0,0-1,0l-6.82,3.94c-.29.17-.32.43-.06.58Zm-19.23-29.29-6.82,3.94c-.29.17-.32.42-.06.57l6.53,3.77a1.08,1.08,0,0,0,1,0l6.82-3.94c.29-.17.32-.43.06-.57l-6.53-3.77A1.08,1.08,0,0,0,137.41,366.35Zm49.87-28.79-6.82,3.94c-.29.17-.32.42-.06.57l6.53,3.77a1.12,1.12,0,0,0,1,0l6.82-3.94c.29-.17.32-.43.06-.58l-6.53-3.77A1.12,1.12,0,0,0,187.28,337.56Zm-39.9,23-6.82,3.94c-.29.17-.32.43-.06.57l6.53,3.77a1.08,1.08,0,0,0,1,0l6.83-3.94c.29-.17.31-.42.05-.57l-6.52-3.77A1.11,1.11,0,0,0,147.38,360.59Zm49.87-28.79-6.82,3.94c-.29.17-.32.42-.06.57l6.53,3.77a1.08,1.08,0,0,0,1,0l6.83-3.94c.29-.17.31-.43.06-.58l-6.53-3.76A1.1,1.1,0,0,0,197.25,331.8Zm-19.94,11.52-6.83,3.94c-.29.16-.31.42-.06.57L177,351.6a1.09,1.09,0,0,0,1,0l6.83-3.94c.29-.16.31-.42.06-.57l-6.53-3.77A1.09,1.09,0,0,0,177.31,343.32Zm-10,5.75L160.51,353c-.29.17-.32.43-.06.58l6.53,3.77a1.09,1.09,0,0,0,1,0l6.82-3.94c.29-.16.32-.42.06-.57L168.32,349A1.12,1.12,0,0,0,167.33,349.07Zm-10,5.76-6.83,3.94c-.29.17-.31.43-.05.58l6.52,3.77a1.14,1.14,0,0,0,1,0l6.82-3.94c.29-.17.32-.42.06-.57l-6.53-3.77A1.12,1.12,0,0,0,157.36,354.83Zm45.54,3.87,6.82-3.94c.29-.17.32-.43.06-.58l-6.53-3.76a1.08,1.08,0,0,0-1,0l-6.82,3.94c-.29.17-.32.42-.06.57l6.53,3.77A1.12,1.12,0,0,0,202.9,358.7Zm93-83.88-6.82,3.94c-.29.17-.32.42-.06.57l6.53,3.77a1.08,1.08,0,0,0,1,0l6.83-3.94c.29-.17.31-.43.06-.57l-6.53-3.77A1.11,1.11,0,0,0,295.94,274.82Zm-12.07,7-6.82,3.94c-.29.17-.32.42-.06.57l6.53,3.77a1.08,1.08,0,0,0,1,0l6.82-3.94c.29-.17.32-.42.06-.57l-6.53-3.77A1.08,1.08,0,0,0,283.87,281.79Zm22.05-12.73L299.09,273c-.29.17-.31.43,0,.57l6.52,3.77a1.1,1.1,0,0,0,1,0l6.82-3.94c.29-.17.32-.42.06-.57L306.91,269A1.08,1.08,0,0,0,305.92,269.06Zm-55.13,51.22,6.82-3.94c.29-.17.32-.43.06-.58L251.14,312a1.12,1.12,0,0,0-1,0L243.33,316c-.29.17-.32.42-.06.57l6.53,3.77A1.12,1.12,0,0,0,250.79,320.28Zm66.09-57a1.12,1.12,0,0,0-1,0l-6.82,3.94c-.29.17-.32.43-.06.58l6.53,3.77a1.12,1.12,0,0,0,1,0l6.82-3.94c.29-.17.32-.42.06-.57Zm-104,89.67L219.7,349c.29-.17.31-.43.05-.57l-6.52-3.77a1.1,1.1,0,0,0-1,0l-6.82,3.94c-.29.17-.32.42-.06.57l6.53,3.77A1.08,1.08,0,0,0,212.87,352.94Zm122.31-70.62,6.83-3.94c.29-.17.31-.42.06-.57L335.54,274a1.12,1.12,0,0,0-1,0L327.72,278c-.29.17-.31.43-.06.58l6.53,3.76A1.08,1.08,0,0,0,335.18,282.32Zm-19.3.37,6.83-3.94c.29-.16.31-.42.06-.57l-6.53-3.77a1.09,1.09,0,0,0-1,0l-6.83,3.94c-.29.16-.32.42-.06.57l6.53,3.77A1.09,1.09,0,0,0,315.88,282.69Zm10.33-14a1.12,1.12,0,0,0-1,0l-6.82,3.94c-.29.17-.32.42-.06.57l6.53,3.77a1.12,1.12,0,0,0,1,0l6.82-3.94c.29-.17.32-.43.06-.58Zm2.1-1.21,15.86,9.16a1.09,1.09,0,0,0,1,0l6.82-3.94c.29-.16.32-.42.06-.57l-15.86-9.15a1.08,1.08,0,0,0-1,0l-6.82,3.94C328.08,267,328.05,267.29,328.31,267.44Zm-23,12.77-6.82,3.94c-.29.16-.32.42-.06.57l6.53,3.77a1.09,1.09,0,0,0,1,0l6.82-3.94c.29-.16.32-.42.06-.57l-6.53-3.77A1.09,1.09,0,0,0,305.27,280.21ZM230.2,323.55l-6.82,3.94c-.29.16-.32.42-.06.57l6.53,3.77a1.09,1.09,0,0,0,1,0l6.83-3.94c.29-.16.31-.42.05-.57l-6.52-3.77A1.11,1.11,0,0,0,230.2,323.55Zm94-35.44a1.08,1.08,0,0,0,1,0l6.82-3.94c.29-.17.32-.42.06-.57l-6.53-3.77a1.08,1.08,0,0,0-1,0l-6.82,3.94c-.29.17-.32.43-.06.57Zm-84,29.68-6.83,3.94c-.29.16-.31.42,0,.57l6.52,3.77a1.14,1.14,0,0,0,1,0l6.82-4c.29-.16.32-.42.06-.57l-6.53-3.77A1.09,1.09,0,0,0,240.18,317.79Zm-78.17,64a1.08,1.08,0,0,0,1,0l6.83-3.94c.28-.17.31-.42,0-.57l-6.53-3.77a1.12,1.12,0,0,0-1,0l-6.82,3.94c-.29.17-.32.43-.06.57Zm-11.6-12.15-6.82,3.94c-.29.17-.32.43-.06.58l6.53,3.77a1.12,1.12,0,0,0,1,0l6.82-3.94c.29-.17.32-.42.06-.57l-6.53-3.77A1.12,1.12,0,0,0,150.41,369.61ZM173,376,179.8,372c.29-.17.32-.42.06-.57l-6.53-3.77a1.12,1.12,0,0,0-1,0l-6.83,3.94c-.29.17-.31.43-.06.58L172,376A1.12,1.12,0,0,0,173,376Zm10-5.76,6.82-3.94c.29-.16.32-.42.06-.57l-6.53-3.77a1.09,1.09,0,0,0-1,0l-6.82,3.94c-.29.16-.32.42-.06.57l6.53,3.77A1.09,1.09,0,0,0,183,370.21Zm10-5.75,6.83-3.94c.29-.17.31-.43.06-.58l-6.53-3.77a1.12,1.12,0,0,0-1,0l-6.83,3.94c-.29.16-.31.42-.06.57l6.53,3.77A1.12,1.12,0,0,0,192.92,364.46Zm-32.53-.6-6.83,3.93c-.29.17-.31.43-.06.58l6.53,3.77a1.09,1.09,0,0,0,1,0l6.83-3.94c.29-.16.31-.42.06-.57l-6.53-3.77A1.09,1.09,0,0,0,160.39,363.86Zm10-5.76L163.54,362c-.29.16-.32.42-.06.57l6.53,3.77a1.09,1.09,0,0,0,1,0l6.82-3.94c.29-.16.32-.42.06-.57l-6.53-3.77A1.09,1.09,0,0,0,170.36,358.1Zm39.9-23L203.43,339c-.29.17-.31.43-.06.58l6.53,3.76a1.08,1.08,0,0,0,1,0l6.83-3.94c.29-.17.31-.42.06-.57L211.25,335A1.08,1.08,0,0,0,210.26,335.06Zm-10,5.76-6.82,3.94c-.29.17-.32.43-.06.57l6.53,3.77a1.08,1.08,0,0,0,1,0l6.82-3.94c.29-.17.32-.42.06-.57l-6.53-3.77A1.08,1.08,0,0,0,200.28,340.82Zm19.95-11.52-6.82,3.94c-.29.17-.32.43-.06.58l6.53,3.77a1.12,1.12,0,0,0,1,0l6.82-3.94c.29-.17.32-.42.06-.57l-6.53-3.77A1.12,1.12,0,0,0,220.23,329.3Zm-39.9,23-6.82,3.94c-.29.17-.32.42-.06.57l6.53,3.77a1.12,1.12,0,0,0,1,0l6.83-3.94c.29-.17.31-.43,0-.58l-6.52-3.77A1.14,1.14,0,0,0,180.33,352.34Zm10-5.76-6.83,3.94c-.29.17-.31.42,0,.57l6.52,3.77a1.14,1.14,0,0,0,1,0l6.82-3.94c.29-.17.32-.43.06-.57l-6.53-3.77A1.08,1.08,0,0,0,190.31,346.58Zm-12.73,37.5,6.82-3.94c.29-.16.32-.42.06-.57l-6.53-3.77a1.09,1.09,0,0,0-1,0l-6.82,3.94c-.29.16-.32.42-.06.57l6.53,3.77A1.09,1.09,0,0,0,177.58,384.08ZM125,381.6l-6.53-3.77a1.09,1.09,0,0,0-1,0l-6.82,3.94c-.29.16-.32.42-.06.57l6.53,3.77a1.09,1.09,0,0,0,1,0l6.82-3.93C125.21,382,125.24,381.75,125,381.6Zm13,3.27-6.52-3.77a1.1,1.1,0,0,0-1,0L120,387.19c-.29.17-.32.43-.06.57l6.53,3.77a1.08,1.08,0,0,0,1,0l10.5-6.06C138.22,385.27,138.24,385,138,384.87Zm-22.74-10.71-6.53-3.77a1.08,1.08,0,0,0-1,0l-8.4,4.85c-.29.17-.32.43-.06.57l6.53,3.77a1.08,1.08,0,0,0,1,0l8.4-4.85C115.47,374.56,115.5,374.31,115.24,374.16Zm6.44-3.72a1.12,1.12,0,0,0,1,0l6.82-3.94c.29-.17.32-.43.06-.58L123,362.12a1.12,1.12,0,0,0-1,0l-6.82,3.94c-.29.17-.32.42-.06.57Zm28.26,18.3L143.41,385a1.08,1.08,0,0,0-1,0l-13.13,7.58c-.29.16-.31.42-.06.57l6.53,3.77a1.12,1.12,0,0,0,1,0l13.13-7.58C150.17,389.14,150.19,388.88,149.94,388.74Zm4.6,8.11L148,393.08a1.08,1.08,0,0,0-1,0l-8.4,4.85c-.29.17-.32.43-.06.57l6.53,3.77a1.08,1.08,0,0,0,1,0l8.4-4.85C154.77,397.25,154.8,397,154.54,396.85Zm41.3-69.22a1.12,1.12,0,0,0,1,0l6.82-3.94c.29-.17.32-.42.06-.57l-6.53-3.77a1.12,1.12,0,0,0-1,0l-6.83,3.94c-.29.17-.31.43-.05.58Zm-20,11.51a1.08,1.08,0,0,0,1,0l6.82-3.94c.29-.17.32-.43.06-.57l-6.53-3.77a1.08,1.08,0,0,0-1,0l-6.82,3.94c-.29.17-.32.42-.06.57Zm-44.24,25.54a1.08,1.08,0,0,0,1,0l6.83-3.94c.29-.17.31-.43.06-.57L133,356.37a1.08,1.08,0,0,0-1,0l-6.83,3.94c-.29.17-.32.42-.06.57Zm54.21-31.3a1.08,1.08,0,0,0,1,0l6.83-3.94c.29-.17.31-.42.06-.57l-6.53-3.77a1.08,1.08,0,0,0-1,0L179.39,329c-.29.17-.32.43-.06.57Zm-20,11.52a1.12,1.12,0,0,0,1,0l6.83-3.94c.29-.17.31-.43.06-.58l-6.53-3.76a1.08,1.08,0,0,0-1,0l-6.83,3.94c-.29.17-.31.42-.06.57Zm-6.47,52.35a1.14,1.14,0,0,0-1,0L148,403.35c-.29.16-.32.42-.06.57l6.53,3.77a1.09,1.09,0,0,0,1,0l10.5-6.06c.29-.16.31-.42.05-.57Zm-7.84-44.09a1.08,1.08,0,0,0,1,0l6.82-3.94c.29-.17.32-.42.06-.57l-6.53-3.77a1.12,1.12,0,0,0-1,0l-6.82,3.94c-.29.17-.32.43-.06.58Zm-10,5.76a1.08,1.08,0,0,0,1,0l6.82-3.94c.29-.17.32-.42.06-.57L143,350.61a1.08,1.08,0,0,0-1,0l-6.83,3.94c-.29.17-.31.43-.05.57Zm202.59-68.35a1.08,1.08,0,0,0-1,0l-16.8,9.7c-.29.17-.32.42-.06.57l6.53,3.77a1.08,1.08,0,0,0,1,0l16.8-9.7c.29-.17.31-.42.06-.57ZM322.17,303.3a1.08,1.08,0,0,0-1,0l-6.83,3.94c-.29.17-.31.42-.05.57l6.52,3.77a1.1,1.1,0,0,0,1,0l6.82-3.94c.29-.17.32-.43.06-.57Zm-134.62,75,6.83-3.94c.29-.17.31-.43.05-.58L187.91,370a1.14,1.14,0,0,0-1,0L180.09,374c-.29.17-.32.42-.06.57l6.53,3.77A1.12,1.12,0,0,0,187.55,378.33Zm114.67-63.52a1.12,1.12,0,0,0-1,0l-6.82,3.94c-.29.17-.32.42-.06.57l6.53,3.77a1.12,1.12,0,0,0,1,0l6.82-3.94c.29-.17.32-.43.06-.58Zm52-30a1.12,1.12,0,0,0-1,0l-6.82,3.94c-.29.17-.32.43-.06.57l6.53,3.77a1.08,1.08,0,0,0,1,0l6.82-3.94c.29-.17.32-.42.06-.57Zm16.5-2-15.85-9.15a1.08,1.08,0,0,0-1,0L347,277.64c-.29.17-.31.42-.06.57l15.86,9.16a1.09,1.09,0,0,0,1,0l6.83-3.94C370.93,283.23,371,283,370.69,282.82ZM265,336.33a1.09,1.09,0,0,0-1,0l-8.4,4.85c-.29.16-.32.42-.06.57l6.53,3.77a1.09,1.09,0,0,0,1,0l8.4-4.85c.29-.16.32-.42.06-.57Zm25.2-14.55a1.12,1.12,0,0,0-1,0l-10.5,6.06c-.29.17-.32.42-.06.57l6.53,3.77a1.12,1.12,0,0,0,1,0l10.5-6.06c.29-.17.31-.43.06-.58Zm-48.3,27.89a1.08,1.08,0,0,0-1,0l-56.17,32.43c-.29.17-.31.42-.06.57l6.53,3.77a1.08,1.08,0,0,0,1,0L248.32,354c.29-.17.32-.42.06-.57Zm-59.32,34.25a1.08,1.08,0,0,0-1,0l-8.4,4.85c-.29.17-.31.42-.06.57l6.53,3.77a1.12,1.12,0,0,0,1,0l8.4-4.85c.29-.17.32-.43.06-.57ZM253.4,343a1.12,1.12,0,0,0-1,0l-8.4,4.85c-.29.17-.32.43-.06.58l6.53,3.76a1.08,1.08,0,0,0,1,0l8.4-4.85c.29-.17.32-.42.06-.57ZM171,390.58a1.09,1.09,0,0,0-1,0l-8.4,4.85c-.29.16-.31.42-.05.57l6.52,3.77a1.11,1.11,0,0,0,1,0l8.39-4.84c.29-.17.32-.43.06-.58ZM276.5,329.66a1.12,1.12,0,0,0-1,0l-8.4,4.85c-.29.17-.32.42-.06.57l6.53,3.77a1.12,1.12,0,0,0,1,0L283,334c.29-.17.32-.43.06-.58Zm35.7-20.6a1.1,1.1,0,0,0-1,0L304.38,313c-.29.17-.32.42-.06.57l6.53,3.77a1.12,1.12,0,0,0,1,0l6.83-3.94c.29-.17.31-.43.05-.58Zm22.34-15.6,6.82-3.94c.29-.16.32-.42.06-.57l-6.53-3.77a1.09,1.09,0,0,0-1,0l-6.83,3.94c-.28.16-.31.42-.05.57l6.53,3.77A1.09,1.09,0,0,0,334.54,293.46Zm-40.71,2,6.83-3.94c.29-.16.32-.42.06-.57l-6.53-3.77a1.09,1.09,0,0,0-1,0l-6.83,3.94c-.29.16-.31.42-.05.57l6.52,3.77A1.09,1.09,0,0,0,293.83,295.42Zm-26.49,36.84,20-11.52c.29-.17.32-.42.06-.57l-6.53-3.77a1.12,1.12,0,0,0-1,0L259.88,328c-.29.17-.31.42-.06.57l6.53,3.77A1.08,1.08,0,0,0,267.34,332.26Zm56.23-33a1.09,1.09,0,0,0,1,0l6.83-3.94c.29-.16.31-.42.06-.57l-6.53-3.77a1.12,1.12,0,0,0-1,0l-6.83,3.95c-.29.16-.31.42-.06.57Zm-8.33-5.42,6.82-3.94c.29-.17.32-.43.06-.57l-6.53-3.77a1.08,1.08,0,0,0-1,0l-6.83,3.94c-.29.17-.31.42,0,.57l6.52,3.77A1.1,1.1,0,0,0,315.24,293.84ZM257.37,338l6.82-3.94c.29-.17.32-.43.06-.58l-6.53-3.76a1.08,1.08,0,0,0-1,0l-6.82,3.94c-.29.17-.32.42-.06.57l6.53,3.77A1.12,1.12,0,0,0,257.37,338Zm44.15-26a1.09,1.09,0,0,0,1,0l6.83-3.94c.29-.17.32-.42.06-.57l-6.53-3.77a1.12,1.12,0,0,0-1,0l-6.83,3.94c-.29.17-.31.43-.06.58Zm-94,54.82,6.82-3.94c.29-.17.32-.42.06-.57l-6.53-3.77a1.08,1.08,0,0,0-1,0L200,362.5c-.29.17-.32.43-.06.57l6.53,3.77A1.08,1.08,0,0,0,207.5,366.81Zm10-5.76,6.83-3.94c.29-.17.31-.42.06-.57l-6.53-3.77a1.12,1.12,0,0,0-1,0L210,356.74c-.29.17-.31.43-.06.58l6.53,3.76A1.08,1.08,0,0,0,217.47,361.05Zm-19.94,11.52,6.82-3.94c.29-.17.32-.43.06-.57l-6.53-3.77a1.08,1.08,0,0,0-1,0l-6.83,3.94c-.29.17-.31.42-.05.57l6.52,3.77A1.1,1.1,0,0,0,197.53,372.57Zm39.89-23,6.83-3.94c.29-.16.31-.42.05-.57l-6.52-3.77a1.11,1.11,0,0,0-1,0L230,345.23c-.29.16-.32.42-.06.57l6.53,3.77A1.09,1.09,0,0,0,237.42,349.53Zm-10,5.76,6.82-3.94c.29-.16.32-.42.06-.57L227.8,347a1.12,1.12,0,0,0-1,0L220,351c-.29.17-.32.43-.06.58l6.53,3.77A1.12,1.12,0,0,0,227.45,355.29Zm19.94-11.51,6.83-3.94c.29-.17.32-.43.06-.58l-6.53-3.77a1.12,1.12,0,0,0-1,0l-6.83,3.94c-.29.16-.31.42-.05.57l6.52,3.77A1.12,1.12,0,0,0,247.39,343.78Zm54.43-80.11a1.09,1.09,0,0,0,1,0l6.83-3.94c.29-.16.32-.42.06-.57l-1.74-1a1.08,1.08,0,0,0-1,0l-6.83,3.94c-.29.17-.31.42-.05.57Zm-49.57,31.38a1.08,1.08,0,0,0,1,0l6.83-3.94c.28-.17.31-.42.05-.57l-6.53-3.77a1.12,1.12,0,0,0-1,0l-6.82,3.94c-.29.17-.32.43-.06.58Zm19.95-11.51a1.09,1.09,0,0,0,1,0l6.82-3.94c.29-.16.32-.42.06-.57l-6.53-3.77a1.09,1.09,0,0,0-1,0l-6.82,3.94c-.29.16-.32.42-.06.57Zm-32.13,18.55a1.12,1.12,0,0,0,1,0l6.83-3.94c.29-.16.31-.42.05-.57l-6.52-3.77a1.14,1.14,0,0,0-1,0l-6.82,3.94c-.29.17-.32.43-.06.58Zm22.15-12.79a1.14,1.14,0,0,0,1,0l6.82-3.94c.29-.17.32-.42.06-.57L263.57,281a1.12,1.12,0,0,0-1,0L255.75,285c-.29.17-.31.43-.06.58Zm-42.1,24.3a1.08,1.08,0,0,0,1,0l6.83-3.94c.29-.17.31-.42.06-.57l-6.53-3.77a1.08,1.08,0,0,0-1,0l-6.83,3.94c-.29.17-.31.43-.06.57Zm10-5.76a1.08,1.08,0,0,0,1,0l6.82-3.94c.29-.17.32-.42.06-.57l-6.53-3.77a1.12,1.12,0,0,0-1,0l-6.82,3.94c-.29.17-.32.43-.06.57Zm51.78-32.66a1.08,1.08,0,0,0,1,0l6.82-3.94c.29-.17.32-.42.06-.57l-1.74-1a1.12,1.12,0,0,0-1,0l-6.82,3.94c-.29.17-.32.42-.06.57Zm29.92-17.27a1.09,1.09,0,0,0,1,0l6.82-3.94c.29-.16.32-.42.06-.57l-1.74-1a1.12,1.12,0,0,0-1,0l-6.82,3.94c-.29.17-.32.43-.06.58Zm13.71,7.92a1.09,1.09,0,0,0,1,0l6.83-3.94c.29-.16.31-.42.06-.57l-6.53-3.77a1.12,1.12,0,0,0-1,0L319,261.49c-.29.16-.31.42-.06.57Zm19,21.88,6.82-3.94c.29-.17.32-.43.06-.58l-6.53-3.77a1.12,1.12,0,0,0-1,0l-6.82,3.94c-.29.17-.32.42-.06.57l6.53,3.77A1.12,1.12,0,0,0,344.51,287.71Zm-52.66-18.29a1.08,1.08,0,0,0,1,0l6.83-3.94c.29-.17.31-.42.05-.57l-1.73-1a1.1,1.1,0,0,0-1,0l-6.82,3.94c-.29.17-.32.42-.06.57Zm-81.7,49.94a1.08,1.08,0,0,0,1,0l6.82-3.94c.29-.17.32-.43.06-.57l-6.53-3.77a1.08,1.08,0,0,0-1,0L203.68,315c-.29.17-.32.42-.06.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.72 376.12 240.2 376.98 279.61 399.73 349.7 359.26 351.16 358.43 310.26 334.82 238.72 376.12",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.8 359.78 310.26 337.55 241.1 377.5 279.61 399.73 348.8 359.78",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.29,366.3a4.29,4.29,0,0,1-2,.6,4.93,4.93,0,0,1-2.89-.51,5.35,5.35,0,0,1-2.37-4.27v-157l4.74,2.73v157c0,1.15.57,1.8,1.4,1.8A2.4,2.4,0,0,0,78.29,366.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,230.18a5.56,5.56,0,0,1-2.51,4.37L78.29,366.3c-1.38.8-2.51.15-2.51-1.46V193.6l6.94-4c1.38-.8,3.41-12.19,4.81-13l60.67-35c1.4-.8,4.36,7.71,5.75,6.9L309,58.94V230.18Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308,60.67V230.18a4.59,4.59,0,0,1-2,3.5L77.79,365.44a1.23,1.23,0,0,1-.62.2c-.34,0-.39-.5-.39-.8V194.18l6.44-3.72c1-.55,1.54-2.38,2.86-7.07.6-2.15,1.5-5.37,2-6l60.29-34.81a19.45,19.45,0,0,1,1.84,2.89c1.45,2.56,2.33,4,3.54,4a1.41,1.41,0,0,0,.7-.19L308,60.67m1-1.73L154,148.46a.36.36,0,0,1-.2.06c-1.38,0-4-7-5.35-7a.46.46,0,0,0-.2.05l-60.67,35c-1.4.8-3.43,12.19-4.81,13l-6.94,4V364.84c0,1.14.57,1.8,1.39,1.8a2.28,2.28,0,0,0,1.12-.34L306.44,234.55a5.56,5.56,0,0,0,2.51-4.37V58.94Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.41,201.35a5.4,5.4,0,0,1-2.36-4.27V183.26a5.57,5.57,0,0,1,2.53-4.37L301.71,47.14A4.73,4.73,0,0,1,309,51.32V65.15a5.52,5.52,0,0,1-2.51,4.36L78.29,201.26A5.36,5.36,0,0,1,73.41,201.35Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.93,50.92c-.18-1.31-1.24-1.79-2.49-1.05L78.29,181.62a5.42,5.42,0,0,0-1.78,1.89l-4.72-2.74a5.21,5.21,0,0,1,1.78-1.88L301.71,47.14a4.71,4.71,0,0,1,7.22,3.78Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.51,183.51a5.13,5.13,0,0,0-.73,2.47v21.85L71,205.1V183.26c0-.11,0-.2,0-.31a5.77,5.77,0,0,1,.09-.62,5.84,5.84,0,0,1,.64-1.56Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,51.32v7.62L154,148.46,82.72,189.59l-6.94,4V186a5.59,5.59,0,0,1,2.51-4.36L306.44,49.87C307.82,49.06,309,49.72,309,51.32Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.64,55.57c1-.57,1.8-.1,1.8,1a4,4,0,0,1-1.8,3.1c-1,.58-1.79.11-1.79-1A4,4,0,0,1,302.64,55.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.19,59.3c1-.58,1.79-.11,1.79,1a4,4,0,0,1-1.79,3.11c-1,.57-1.79.1-1.79-1A4,4,0,0,1,296.19,59.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.73,63c1-.58,1.8-.11,1.8,1a4,4,0,0,1-1.8,3.11c-1,.57-1.79.1-1.79-1A4,4,0,0,1,289.73,63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,190.6c.85-.5,1.14-1.25,1.55-2.69l.94-3.24c.34-1.3.69-2.19,1.55-2.68l37.3-21.54c.86-.5,1.53-.55,2.18.53l1.14,2.09c.48.84.73,1.33,1.58.84l29-16.72L309,58.94V73.17L75.78,207.83V193.6l5.18-3",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.78 193.6 75.78 207.83 71.04 205.1 71.04 190.87 75.78 193.6",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.78 193.6 75.78 207.83 71.04 205.1 71.04 190.87 75.78 193.6",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.61,194.84l-2.92,1.68,1.11-2.14a.54.54,0,0,0,0-.52c-.09-.1-.24,0-.33.16l-1.58,3h0a.36.36,0,0,0,0,.11s0,0,0,0a.39.39,0,0,0,0,.15.3.3,0,0,0,0,.14s0,0,0,0,0,.05,0,.06h0l1.58,1.21s.09,0,.15,0a.46.46,0,0,0,.18-.22.47.47,0,0,0,0-.5l-1.11-.85,2.92-1.68a.66.66,0,0,0,.23-.5C84.84,194.86,84.73,194.76,84.61,194.84Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,193.43,90,191.75l-1.11-.85a.46.46,0,0,1,0-.5c.08-.2.23-.3.33-.22l1.58,1.21h0s0,0,0,.06l0,0a.59.59,0,0,1,0,.14.77.77,0,0,1,0,.15l0,0a.36.36,0,0,1,0,.11h0l-1.58,3a.41.41,0,0,1-.16.18.12.12,0,0,1-.17,0,.51.51,0,0,1,0-.52L90,192.47,87,194.15c-.13.08-.24,0-.24-.22A.64.64,0,0,1,87,193.43Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.59,185.05c0-.18-.17-.15-.25,0l-.4,1c-.68-.07-1.5.59-2.06,1.77-.72,1.53-.72,3.33,0,4a1,1,0,0,0,1.31.07,3.57,3.57,0,0,0,1.31-1.58c.09-.2.09-.43,0-.51s-.24,0-.34.19c-.53,1.14-1.41,1.64-2,1.12s-.54-1.86,0-3c.38-.81.94-1.29,1.42-1.32l-.3.73c-.08.19,0,.37.11.29l1.19-.77a.42.42,0,0,0,.13-.33Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.77,164.26l.88-1.87a.56.56,0,0,0,0-.59c-.1-.1-.27,0-.38.22l-.88,1.88-.89-.85c-.11-.11-.28,0-.38.21a.56.56,0,0,0,0,.59l.89.85-.89,1.88a.54.54,0,0,0,0,.58.15.15,0,0,0,.19,0,.48.48,0,0,0,.19-.24l.89-1.87.88.85a.15.15,0,0,0,.19,0,.5.5,0,0,0,.19-.23.54.54,0,0,0,0-.58Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.59,187.31v-3.38a3.68,3.68,0,0,1,1.68-2.9L296.77,69.2c.93-.53,1.68-.1,1.68,1v3.38a3.68,3.68,0,0,1-1.68,2.9L103.27,188.28C102.34,188.81,101.59,188.38,101.59,187.31Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.5,76.71a.33.33,0,0,1-.15,0,.44.44,0,0,1-.25-.51l.16-1.37-.65-.46a.47.47,0,0,1-.17-.38.75.75,0,0,1,.27-.58l1-.76a.56.56,0,0,0,0-.08l.44-1.44a.63.63,0,0,1,.49-.47.39.39,0,0,1,.39.24l.37.78.83-.32a.4.4,0,0,1,.44.1.61.61,0,0,1,0,.68L297,73.44a.2.2,0,0,0,0,.09l.17,1.2a.81.81,0,0,1-.21.61.49.49,0,0,1-.39.15l-.81-.1-.86,1.1A.51.51,0,0,1,294.5,76.71ZM294,73.92l.65.46a.49.49,0,0,1,.17.46l-.11.92.58-.75a.48.48,0,0,1,.44-.21l.8.1s0-.07,0-.09l-.17-1.21a.86.86,0,0,1,.09-.43l.62-1.17-.64.25a.4.4,0,0,1-.51-.2l-.29-.62-.39,1.28a.73.73,0,0,1-.24.37l-1,.76A.12.12,0,0,0,294,73.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M300.42,68.79a.58.58,0,0,1-.29-1.08L304.84,65a.58.58,0,0,1,.79.21.58.58,0,0,1-.21.79l-4.71,2.72A.6.6,0,0,1,300.42,68.79Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M300.42,71.51a.58.58,0,0,1-.29-1.08l4.71-2.72a.58.58,0,0,1,.79.21.58.58,0,0,1-.21.79l-4.71,2.72A.6.6,0,0,1,300.42,71.51Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M300.42,74.23a.58.58,0,0,1-.5-.29.59.59,0,0,1,.21-.8l4.71-2.71a.57.57,0,0,1,.79.21.58.58,0,0,1-.21.79l-4.71,2.72A.6.6,0,0,1,300.42,74.23Z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M119.24,192.8l.58-5a.85.85,0,0,1,.11-.36.59.59,0,0,1,.17-.18l1.18-.68a.12.12,0,0,1,.14,0,.3.3,0,0,1,0,.18.57.57,0,0,1,0,.12l-1.16,9.43a1.24,1.24,0,0,1-.14.44.8.8,0,0,1-.31.34l-.74.43a.26.26,0,0,1-.3,0,.59.59,0,0,1-.15-.27l-.68-2.74-.67,3.52a2.45,2.45,0,0,1-.16.45.79.79,0,0,1-.29.33l-.75.43a.27.27,0,0,1-.31,0,.4.4,0,0,1-.14-.28l-1.16-8.09a.45.45,0,0,1,0-.11.53.53,0,0,1,.06-.24.31.31,0,0,1,.14-.17l1.18-.68a.17.17,0,0,1,.17,0s.09.1.11.23l.57,4.35.53-2.82a1.9,1.9,0,0,1,.08-.29.5.5,0,0,1,.23-.28l.85-.49c.1-.06.18-.06.22,0a.75.75,0,0,1,.08.2Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.87,190.83a.12.12,0,0,1,.17,0,.34.34,0,0,1,.07.22v1.47a.82.82,0,0,1-.07.3.42.42,0,0,1-.17.21l-4.27,2.47a.13.13,0,0,1-.17,0,.3.3,0,0,1-.07-.23v-9a.66.66,0,0,1,.07-.3.46.46,0,0,1,.17-.21l4.19-2.42c.07,0,.13,0,.17,0a.29.29,0,0,1,.08.22v1.47a.67.67,0,0,1-.08.3.34.34,0,0,1-.17.21L124,187.2v1.5l2.57-1.49a.15.15,0,0,1,.18,0,.32.32,0,0,1,.07.22v1.47a.82.82,0,0,1-.07.3.48.48,0,0,1-.18.21L124,190.92v1.55Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.39,192.17a.15.15,0,0,1-.18,0,.32.32,0,0,1-.07-.22v-9a.82.82,0,0,1,.07-.3.48.48,0,0,1,.18-.21l2.89-1.68a2,2,0,0,1,1-.33.92.92,0,0,1,.66.29,1.44,1.44,0,0,1,.36.72,4.37,4.37,0,0,1,.11,1,4.07,4.07,0,0,1-.06.73c0,.22-.09.42-.14.6a4.1,4.1,0,0,1-.17.44c-.06.12-.1.21-.14.28a.92.92,0,0,1,.49.58,3.41,3.41,0,0,1,.14,1.11,5.93,5.93,0,0,1-.11,1.17,5.42,5.42,0,0,1-.35,1.17,5.18,5.18,0,0,1-.64,1,3.54,3.54,0,0,1-1,.81Zm3.36-8.71a.68.68,0,0,0-.14-.49c-.09-.09-.23-.08-.41,0l-1.39.8v1.58l1.39-.8a1,1,0,0,0,.41-.45A1.59,1.59,0,0,0,131.75,183.46Zm-1.94,5.74,1.48-.86a1,1,0,0,0,.43-.49,1.57,1.57,0,0,0,.17-.7.66.66,0,0,0-.17-.51c-.1-.1-.25-.09-.43,0l-1.48.86Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.13,177.31a1.88,1.88,0,0,1,1-.3,1.36,1.36,0,0,1,.71.23,1.55,1.55,0,0,1,.45.56,2,2,0,0,1,.16.69.57.57,0,0,1-.06.25.35.35,0,0,1-.14.17l-.37.22c-.07,0-.12.05-.16,0s-.08-.07-.12-.18a1.51,1.51,0,0,0-.15-.26.78.78,0,0,0-.28-.26.81.81,0,0,0-.43-.1,1.3,1.3,0,0,0-.58.19,2.37,2.37,0,0,0-.48.37,3,3,0,0,0-.41.51,2.63,2.63,0,0,0-.29.61,2.38,2.38,0,0,0-.11.7,1.16,1.16,0,0,0,.11.55.58.58,0,0,0,.33.26,1.75,1.75,0,0,0,.58,0l.85-.12a3,3,0,0,1,.87-.05,1.09,1.09,0,0,1,.58.23,1.05,1.05,0,0,1,.33.53,3,3,0,0,1,.11.86,4.5,4.5,0,0,1-.18,1.25,5.47,5.47,0,0,1-.49,1.17,5.08,5.08,0,0,1-.76,1,4.93,4.93,0,0,1-1,.78,2.26,2.26,0,0,1-1,.32,1.3,1.3,0,0,1-1.25-.72,1.68,1.68,0,0,1-.2-.79.61.61,0,0,1,.06-.25.41.41,0,0,1,.14-.17l.37-.21a.25.25,0,0,1,.16,0,.34.34,0,0,1,.12.18,1,1,0,0,0,.17.33.77.77,0,0,0,.3.26.93.93,0,0,0,.46.07,1.56,1.56,0,0,0,.64-.23,2.55,2.55,0,0,0,.59-.46,3.19,3.19,0,0,0,.5-.6,3.52,3.52,0,0,0,.35-.7,2.27,2.27,0,0,0,.12-.72.89.89,0,0,0-.14-.54.71.71,0,0,0-.42-.22,1.82,1.82,0,0,0-.66,0c-.26,0-.56.08-.89.14a1.78,1.78,0,0,1-.76,0,.94.94,0,0,1-.51-.3,1.28,1.28,0,0,1-.29-.57,3.86,3.86,0,0,1-.08-.82,4.53,4.53,0,0,1,.13-1.07,5,5,0,0,1,.41-1.1,4.22,4.22,0,0,1,.66-1A3.49,3.49,0,0,1,137.13,177.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,184.91a.13.13,0,0,1-.17,0,.29.29,0,0,1-.07-.22v-9a.67.67,0,0,1,.07-.31.46.46,0,0,1,.17-.21l.37-.21a.12.12,0,0,1,.17,0,.29.29,0,0,1,.07.22v9a.7.7,0,0,1-.07.31.46.46,0,0,1-.17.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.06,171.71a.14.14,0,0,1,.17,0,.28.28,0,0,1,.07.22v.5a.66.66,0,0,1-.07.3.54.54,0,0,1-.17.21l-1.69,1V182a.66.66,0,0,1-.07.3.38.38,0,0,1-.17.21l-.37.22a.14.14,0,0,1-.17,0,.3.3,0,0,1-.07-.23v-8.07l-1.68,1a.13.13,0,0,1-.17,0,.3.3,0,0,1-.08-.23v-.5a.67.67,0,0,1,.08-.3.41.41,0,0,1,.17-.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.16,177.22a.13.13,0,0,1,.17,0,.29.29,0,0,1,.07.22v.5a.7.7,0,0,1-.07.31.46.46,0,0,1-.17.21l-3.63,2.1a.15.15,0,0,1-.18,0,.28.28,0,0,1-.07-.22v-9a.66.66,0,0,1,.07-.3.48.48,0,0,1,.18-.21l3.56-2.06a.14.14,0,0,1,.17,0,.29.29,0,0,1,.07.22v.5a.7.7,0,0,1-.07.31.54.54,0,0,1-.17.21l-3,1.7v2.92l2.75-1.59a.13.13,0,0,1,.17,0,.28.28,0,0,1,.07.22v.5a.66.66,0,0,1-.07.3.46.46,0,0,1-.17.21l-2.75,1.59v3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.69,139.29l-15,8.69a2.55,2.55,0,0,0-1.18,2c0,.71.53,1,1.18.6l15-8.7a2.52,2.52,0,0,0,1.18-2C209.87,139.18,209.34,138.91,208.69,139.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.05,126.4l-11.83,6.83a2.49,2.49,0,0,0-1.18,2c0,.7.52,1,1.18.6L231.05,129a2.55,2.55,0,0,0,1.18-2C232.23,126.29,231.7,126,231.05,126.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.39,114.67l-9.82,5.67a2.54,2.54,0,0,0-1.18,2c0,.71.53,1,1.18.6l9.82-5.67a2.55,2.55,0,0,0,1.18-2C252.57,114.56,252,114.29,251.39,114.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.94,99.92l-15,8.69a2.54,2.54,0,0,0-1.18,2c0,.71.53,1,1.18.6l15-8.7a2.49,2.49,0,0,0,1.18-2C278.12,99.81,277.6,99.54,276.94,99.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.78 296.75 308.95 162.13 308.95 91.82 75.78 226.43 75.78 296.75",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.91,215.29,153.26,192c1.2-.69,2.16-.14,2.16,1.25l0,.4a4.8,4.8,0,0,1-2.17,3.75l-40.32,23.27c-1.2.69-2.17.14-2.17-1.25V218C110.75,216.66,111.72,216,112.91,215.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.91,224.67l26.3-15.18c1.2-.69,2.16-.13,2.16,1.25l0,.4a4.78,4.78,0,0,1-2.17,3.75l-26.27,15.17c-1.2.69-2.17.13-2.17-1.25v-1.39C110.75,226,111.72,225.36,112.91,224.67Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.91,224.67l26.3-15.18c1.2-.69,2.16-.13,2.16,1.25l0,.4a4.78,4.78,0,0,1-2.17,3.75l-26.27,15.17c-1.2.69-2.17.13-2.17-1.25v-1.39C110.75,226,111.72,225.36,112.91,224.67Z",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.75,241.72a.39.39,0,0,1-.33-.19.37.37,0,0,1,.14-.51l77.18-44.56a.37.37,0,0,1,.51.13.39.39,0,0,1-.14.52l-77.18,44.56A.41.41,0,0,1,110.75,241.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.75,246.41a.39.39,0,0,1-.33-.19.37.37,0,0,1,.14-.51L139,229.29a.39.39,0,0,1,.52.14.37.37,0,0,1-.14.51l-28.44,16.42A.41.41,0,0,1,110.75,246.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.24,227.65a.37.37,0,0,1-.32-.19.39.39,0,0,1,.13-.52l16.25-9.38a.39.39,0,0,1,.52.14.37.37,0,0,1-.14.51l-16.25,9.39A.41.41,0,0,1,143.24,227.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.5,216a.38.38,0,0,1-.32-.19.37.37,0,0,1,.14-.51l24.42-14.1a.38.38,0,0,1,.51.13.39.39,0,0,1-.14.52l-24.42,14.1A.41.41,0,0,1,163.5,216Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.75,251.1a.39.39,0,0,1-.33-.19.37.37,0,0,1,.14-.51l12.18-7a.39.39,0,0,1,.52.14.37.37,0,0,1-.14.51l-12.19,7A.37.37,0,0,1,110.75,251.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,241.72a.37.37,0,0,1-.18-.7l28.43-16.42a.37.37,0,0,1,.51.14.36.36,0,0,1-.13.51l-28.44,16.42A.41.41,0,0,1,127,241.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.49,223a.38.38,0,0,1-.33-.18.39.39,0,0,1,.14-.52l28.44-16.41a.37.37,0,1,1,.37.65L159.68,222.9A.34.34,0,0,1,159.49,223Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.75,255.79a.39.39,0,0,1-.33-.19.37.37,0,0,1,.14-.51l77.18-44.56a.37.37,0,0,1,.51.14.38.38,0,0,1-.14.51l-77.18,44.56A.41.41,0,0,1,110.75,255.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.75,260.48a.39.39,0,0,1-.33-.19.37.37,0,0,1,.14-.51L139,243.36a.39.39,0,0,1,.52.14.37.37,0,0,1-.14.51l-28.44,16.42A.41.41,0,0,1,110.75,260.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.24,241.72a.38.38,0,0,1-.19-.7l16.25-9.38a.38.38,0,0,1,.52.13.39.39,0,0,1-.14.52l-16.25,9.38A.41.41,0,0,1,143.24,241.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.5,230a.38.38,0,0,1-.32-.19.37.37,0,0,1,.14-.51l24.42-14.1a.38.38,0,0,1,.51.14.37.37,0,0,1-.14.51L163.69,230A.41.41,0,0,1,163.5,230Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.75,265.17a.39.39,0,0,1-.33-.19.37.37,0,0,1,.14-.51l12.18-7a.39.39,0,0,1,.52.14.37.37,0,0,1-.14.51l-12.19,7A.37.37,0,0,1,110.75,265.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,255.79a.37.37,0,0,1-.18-.7l28.43-16.42a.37.37,0,0,1,.51.14.36.36,0,0,1-.13.51l-28.44,16.42A.41.41,0,0,1,127,255.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.49,237a.39.39,0,0,1-.33-.19.37.37,0,0,1,.14-.51l28.44-16.42a.37.37,0,1,1,.37.65L159.68,237A.45.45,0,0,1,159.49,237Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.45,118.22v52.5a3.63,3.63,0,0,1-1.64,2.84l-81.25,47.13-.28.13h0c-.78.3-1.36-.14-1.36-1.08v-52.5a3.5,3.5,0,0,1,.48-1.62,3.33,3.33,0,0,1,1.16-1.22l81.26-47.14c.75-.43,1.39-.2,1.59.49a.35.35,0,0,0,0-.14,2.17,2.17,0,0,1,.07.35C278.44,118.05,278.45,118.14,278.45,118.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.5 213.17 273.86 169.65 273.86 156.98 253.44 153.66 238.96 171.33 242.9 175.77 219.64 161.69 198.5 196.01 198.5 213.17",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.89,132.34c2.24-1.31,4.05-.28,4.05,2.31a9,9,0,0,1-4.07,7c-2.24,1.3-4.05.26-4.05-2.3A9,9,0,0,1,265.89,132.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.39,264.38l0,39.41a2.63,2.63,0,0,1-1.18,2l-44,25.36-.2.09h0c-.56.22-1-.1-1-.77V291.07a2.49,2.49,0,0,1,.34-1.17,2.38,2.38,0,0,1,.84-.88l43.92-25.33c.55-.31,1-.15,1.15.35a.36.36,0,0,0,0-.1,2.21,2.21,0,0,1,0,.25C157.38,264.26,157.39,264.32,157.39,264.38Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.39,264.38l0,39.41a2.63,2.63,0,0,1-1.18,2l-44,25.36-.2.09h0c-.56.22-1-.1-1-.77V291.07a2.49,2.49,0,0,1,.34-1.17,2.38,2.38,0,0,1,.84-.88l43.92-25.33c.55-.31,1-.15,1.15.35a.36.36,0,0,0,0-.1,2.21,2.21,0,0,1,0,.25C157.38,264.26,157.39,264.32,157.39,264.38Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.41 325.77 154.07 302.87 154.07 292.58 145.51 287.5 137.28 299.51 139.75 302.69 124.78 291.9 114.41 312.77 114.41 325.77",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.54,279.43c1.62-1,2.93-.21,2.92,1.7a6.69,6.69,0,0,1-2.93,5.2c-1.62,1-2.93.2-2.93-1.7A6.72,6.72,0,0,1,138.54,279.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.41,194.5l0,39.41a2.62,2.62,0,0,1-1.19,2.06l-43.95,25.35-.2.1h0c-.57.21-1-.1-1-.78V221.19a2.47,2.47,0,0,1,.35-1.16,2.38,2.38,0,0,1,.84-.88l43.92-25.34c.54-.31,1-.15,1.14.35a.38.38,0,0,0,0-.1,1.18,1.18,0,0,1,0,.25A1.28,1.28,0,0,1,278.41,194.5Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.41,194.5l0,39.41a2.62,2.62,0,0,1-1.19,2.06l-43.95,25.35-.2.1h0c-.57.21-1-.1-1-.78V221.19a2.47,2.47,0,0,1,.35-1.16,2.38,2.38,0,0,1,.84-.88l43.92-25.34c.54-.31,1-.15,1.14.35a.38.38,0,0,0,0-.1,1.18,1.18,0,0,1,0,.25A1.28,1.28,0,0,1,278.41,194.5Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.44 255.89 275.1 233 275.1 222.7 266.54 217.63 258.31 229.63 260.78 232.82 245.81 222.03 235.44 242.9 235.44 255.89",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.56,209.55c1.62-1,2.93-.21,2.93,1.71a6.69,6.69,0,0,1-2.94,5.2c-1.62.95-2.93.19-2.92-1.71A6.75,6.75,0,0,1,259.56,209.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.9,229.44l0,39.42a2.64,2.64,0,0,1-1.19,2.05L172.8,296.26l-.2.1h0c-.56.21-1-.1-1-.78V256.13A2.36,2.36,0,0,1,172,255a2.28,2.28,0,0,1,.83-.88l43.92-25.34c.55-.31,1-.15,1.15.35a.2.2,0,0,0,0-.1,1.19,1.19,0,0,1,0,.26C217.89,229.32,217.9,229.38,217.9,229.44Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.9,229.44l0,39.42a2.64,2.64,0,0,1-1.19,2.05L172.8,296.26l-.2.1h0c-.56.21-1-.1-1-.78V256.13A2.36,2.36,0,0,1,172,255a2.28,2.28,0,0,1,.83-.88l43.92-25.34c.55-.31,1-.15,1.15.35a.2.2,0,0,0,0-.1,1.19,1.19,0,0,1,0,.26C217.89,229.32,217.9,229.38,217.9,229.44Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.93 290.83 214.59 267.94 214.59 257.64 206.02 252.57 197.8 264.57 200.27 267.76 185.29 256.97 174.93 277.84 174.93 290.83",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.05,244.49c1.62-1,2.93-.2,2.93,1.71a6.71,6.71,0,0,1-2.94,5.2c-1.62.95-2.93.19-2.93-1.71A6.76,6.76,0,0,1,199.05,244.49Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.61,431.45c8.92-9.21,14.16-42.23,5.46-49.53H26.81c-8.7,7.29-3.47,40.31,5.45,49.52l.24.25.31.31c.25.24.52.48.8.72l.22.17c.22.17.43.35.67.51a11.29,11.29,0,0,0,1.15.75c7.34,4.28,19.24,4.28,26.57,0h0c.39-.22.77-.48,1.16-.75.22-.16.42-.32.62-.48l.27-.21c.27-.23.53-.46.77-.7l.36-.35Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.65,379c-10.1,5.89-10.1,15.45,0,21.35s26.48,5.9,36.58,0,10.1-15.46,0-21.35S40.75,373.08,30.65,379Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.51,381.81c-7.42,4.33-7.42,11.35,0,15.68s19.44,4.34,26.86,0,7.42-11.35,0-15.68S42.93,377.48,35.51,381.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.37,389.25c-7.42-4.33-19.44-4.33-26.86,0a12.4,12.4,0,0,0-4.44,4.12,12.23,12.23,0,0,0,4.44,4.12c7.42,4.34,19.44,4.34,26.86,0a12.23,12.23,0,0,0,4.44-4.12A12.4,12.4,0,0,0,62.37,389.25Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.37,389.25c-7.42-4.33-19.44-4.33-26.86,0a12.4,12.4,0,0,0-4.44,4.12,12.23,12.23,0,0,0,4.44,4.12c7.42,4.34,19.44,4.34,26.86,0a12.23,12.23,0,0,0,4.44-4.12A12.4,12.4,0,0,0,62.37,389.25Z",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34,330l11.58,9.94-11.34-5.78a31.93,31.93,0,0,0,1.58,11,70,70,0,0,1,8.75,6.73L35.8,348s-.84,5.82,1.25,14.82c.54,2.35,3,6.91,4.52,10.3A38,38,0,0,0,44,377.7c.05.1.11.18.17.28q3.11-1.62,6.44-3.13c1.54-2.94,3.68-10.26,4.59-16.29,3.44-23.09-13.57-37.06-27.5-42.06A42,42,0,0,1,34,330Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,330l11.58,9.94-11.34-5.78a31.93,31.93,0,0,0,1.58,11,70,70,0,0,1,8.75,6.73L35.8,348s-.84,5.82,1.25,14.82c.54,2.35,3,6.91,4.52,10.3A38,38,0,0,0,44,377.7c.05.1.11.18.17.28q3.11-1.62,6.44-3.13c1.54-2.94,3.68-10.26,4.59-16.29,3.44-23.09-13.57-37.06-27.5-42.06A42,42,0,0,1,34,330Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.91,331.34a22.64,22.64,0,0,1,4.61,9.1,46.82,46.82,0,0,1,1.73,10.11,43.56,43.56,0,0,1-3.3,20h0a.34.34,0,0,0,.18.44.33.33,0,0,0,.44-.17h0a44,44,0,0,0,3-20.32,47.15,47.15,0,0,0-1.91-10.14A22.69,22.69,0,0,0,43.91,331.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.09,342.61l0,0a190,190,0,0,0-11.58,19.75l-12.66,3.2,9.62.82-4.38,8.5-12.4,3.73,10,.73s-1.89,9.87-8.6,14.51c-3.7,2.56-5.39,2.77-6.85,2.06-1.78-.86-2.83-3.55-3.87-7.61S44,375.8,47.18,367.37a25.24,25.24,0,0,1,3.52-6.3C59.13,349.83,76.35,343.25,85.09,342.61Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.09,342.61l0,0a190,190,0,0,0-11.58,19.75l-12.66,3.2,9.62.82-4.38,8.5-12.4,3.73,10,.73s-1.89,9.87-8.6,14.51c-3.7,2.56-5.39,2.77-6.85,2.06-1.78-.86-2.83-3.55-3.87-7.61S44,375.8,47.18,367.37a25.24,25.24,0,0,1,3.52-6.3C59.13,349.83,76.35,343.25,85.09,342.61Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,348a52.37,52.37,0,0,0-16.77,13.91,35.36,35.36,0,0,0-5.32,9.62,33.5,33.5,0,0,0-1.86,10.8,0,0,0,0,0,0,0,0,0,0,0,0,0,0,43.44,43.44,0,0,1,2.46-10.55,40,40,0,0,1,5.1-9.53,53.73,53.73,0,0,1,16.35-14.19,0,0,0,0,0,0-.05A0,0,0,0,0,72,348Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,342.1H9a29.43,29.43,0,0,1,3.82.35,61.31,61.31,0,0,1,14.45,4.23q2.58,1.1,5.12,2.45c.84.45,1.68.93,2.5,1.42a42.26,42.26,0,0,1,10.8,9,26.41,26.41,0,0,1,3.61,5.59c.12.26.26.52.37.78h0c.29.68.55,1.35.8,2a36.65,36.65,0,0,1,2.47,18.14c-.36,4.35-2.07,9.26-3,10a2.09,2.09,0,0,1-.39.27c-1.28.73-3.24.18-6.84-2.06-7.21-4.48-9.63-15.1-9.63-15.1L43.48,378,30.39,374.7l-5-8.62,9.95-1.34-13.32-2.68A197.87,197.87,0,0,0,9,342.11Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,342.1H9a29.43,29.43,0,0,1,3.82.35,61.31,61.31,0,0,1,14.45,4.23q2.58,1.1,5.12,2.45c.84.45,1.68.93,2.5,1.42a42.26,42.26,0,0,1,10.8,9,26.41,26.41,0,0,1,3.61,5.59c.12.26.26.52.37.78h0c.29.68.55,1.35.8,2a36.65,36.65,0,0,1,2.47,18.14c-.36,4.35-2.07,9.26-3,10a2.09,2.09,0,0,1-.39.27c-1.28.73-3.24.18-6.84-2.06-7.21-4.48-9.63-15.1-9.63-15.1L43.48,378,30.39,374.7l-5-8.62,9.95-1.34-13.32-2.68A197.87,197.87,0,0,0,9,342.11Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8,342.45a61.31,61.31,0,0,1,14.45,4.23q2.58,1.1,5.12,2.45c.84.45,1.68.93,2.5,1.42a42.26,42.26,0,0,1,10.8,9,26.41,26.41,0,0,1,3.61,5.59c.12.26.26.52.37.78h0c.29.68.55,1.35.8,2a36.65,36.65,0,0,1,2.47,18.14c-.36,4.35-2.07,9.26-3,10a2.09,2.09,0,0,1-.39.27,2.3,2.3,0,0,1-.83.26c1.22-6.72-1.31-24-6-31.29C37.84,357.78,25.91,346.57,9,342.11H9A30.7,30.7,0,0,1,12.8,342.45Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8,342.45a61.31,61.31,0,0,1,14.45,4.23q2.58,1.1,5.12,2.45c.84.45,1.68.93,2.5,1.42a42.26,42.26,0,0,1,10.8,9,26.41,26.41,0,0,1,3.61,5.59c.12.26.26.52.37.78h0c.29.68.55,1.35.8,2a36.65,36.65,0,0,1,2.47,18.14c-.36,4.35-2.07,9.26-3,10a2.09,2.09,0,0,1-.39.27,2.3,2.3,0,0,1-.83.26c1.22-6.72-1.31-24-6-31.29C37.84,357.78,25.91,346.57,9,342.11H9A30.7,30.7,0,0,1,12.8,342.45Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.79,396.64a57.89,57.89,0,0,0-.28-15,48.34,48.34,0,0,0-4.3-14.4,42.1,42.1,0,0,0-9.52-11.67,55.86,55.86,0,0,0-12.52-8.31,0,0,0,0,0-.05,0s0,0,0,0a73.85,73.85,0,0,1,12,8.87,54.39,54.39,0,0,1,5.21,5.31,33.34,33.34,0,0,1,4.27,6,47.87,47.87,0,0,1,4.49,14.16,58.17,58.17,0,0,1,.61,14.91,0,0,0,0,0,0,.05S48.79,396.67,48.79,396.64Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M456.33,366.48,448.61,362s-4.6-19.1-2.77-36.29c2.58-24.17,18.49-33.27,24.53-31.18s7.81,9.11-2.2,23.51C462.26,326.55,455,344.24,456.33,366.48Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M456.33,366.48,448.61,362s-4.6-19.1-2.77-36.29c2.58-24.17,18.49-33.27,24.53-31.18s7.81,9.11-2.2,23.51C462.26,326.55,455,344.24,456.33,366.48Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M453.13,357.1h.07a.54.54,0,0,0,.43-.63c-4.23-22.29,3.55-47.34,13.2-57.76a.55.55,0,0,0,0-.76.54.54,0,0,0-.76,0c-9.82,10.61-17.76,36.07-13.46,58.69A.54.54,0,0,0,453.13,357.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.77,377.71c1.16.59,4.23-2,5.08-2.68a10.62,10.62,0,0,0,3.35-4.27,10,10,0,0,0,.59-6.07,23.72,23.72,0,0,0-.92-3.16l-1.05-3.06a7.86,7.86,0,0,1-.62-3.12c.17-2.14,2-3.72,3.63-5.09,1.83-1.52,3.71-3.5,3.57-6.06a9,9,0,0,0-2.53-5.24c-1.3-1.49-2.82-2.79-4-4.37a6.32,6.32,0,0,1-1.49-3.91,6.71,6.71,0,0,1,.74-2.53,34.92,34.92,0,0,0,2.47-5.12c.53-1.82.33-4-1.13-5.26a5.89,5.89,0,0,0-4.46-.87,10.18,10.18,0,0,0-4,1.65c-4,2.46-6,7.39-10.26,9.35a44.93,44.93,0,0,1-5.15,1.54,6.44,6.44,0,0,0-4.16,3.16c-1.42,3.25,1.71,7,.77,10.41-.84,3-3.66,4.3-5.15,7.06a6.32,6.32,0,0,0-.56,3.93,18.56,18.56,0,0,0,2,6.48,57.82,57.82,0,0,0,3.9,6Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M475.77,377.71c1.16.59,4.23-2,5.08-2.68a10.62,10.62,0,0,0,3.35-4.27,10,10,0,0,0,.59-6.07,23.72,23.72,0,0,0-.92-3.16l-1.05-3.06a7.86,7.86,0,0,1-.62-3.12c.17-2.14,2-3.72,3.63-5.09,1.83-1.52,3.71-3.5,3.57-6.06a9,9,0,0,0-2.53-5.24c-1.3-1.49-2.82-2.79-4-4.37a6.32,6.32,0,0,1-1.49-3.91,6.71,6.71,0,0,1,.74-2.53,34.92,34.92,0,0,0,2.47-5.12c.53-1.82.33-4-1.13-5.26a5.89,5.89,0,0,0-4.46-.87,10.18,10.18,0,0,0-4,1.65c-4,2.46-6,7.39-10.26,9.35a44.93,44.93,0,0,1-5.15,1.54,6.44,6.44,0,0,0-4.16,3.16c-1.42,3.25,1.71,7,.77,10.41-.84,3-3.66,4.3-5.15,7.06a6.32,6.32,0,0,0-.56,3.93,18.56,18.56,0,0,0,2,6.48,57.82,57.82,0,0,0,3.9,6Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M464.59,371.88h0a.51.51,0,0,0,.47-.55c-1.85-20.05,6.5-42.71,13.06-49.5a.51.51,0,1,0-.73-.71c-6.69,6.93-15.21,30-13.34,50.3A.51.51,0,0,0,464.59,371.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.58,347.16l.15,0A68.52,68.52,0,0,1,481.19,344a.5.5,0,0,0,.46-.55.49.49,0,0,0-.55-.46,69.39,69.39,0,0,0-14.72,3.15.5.5,0,0,0-.3.65A.52.52,0,0,0,466.58,347.16Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coins--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--coins--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M477.1,375.9a24.13,24.13,0,0,0-8.93-8.26c-14.6-8.43-38.27-8.43-52.86,0a24.13,24.13,0,0,0-8.93,8.26h-2v7.63h0c.27,5.31,3.91,10.58,10.93,14.63,14.59,8.43,38.26,8.43,52.86,0,7-4.05,10.68-9.32,10.95-14.63h0V375.9Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M477.1,375.9a24.13,24.13,0,0,0-8.93-8.26c-14.6-8.43-38.27-8.43-52.86,0a24.13,24.13,0,0,0-8.93,8.26h-2v7.63h0c.27,5.31,3.91,10.58,10.93,14.63,14.59,8.43,38.26,8.43,52.86,0,7-4.05,10.68-9.32,10.95-14.63h0V375.9Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M441.74,361.32c-9.57,0-19.13,2.1-26.43,6.32a24.13,24.13,0,0,0-8.93,8.26h-2v7.63h0c.27,5.31,3.91,10.58,10.93,14.63,7.3,4.21,16.86,6.32,26.43,6.32Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.32,364.82a40.43,40.43,0,0,0-6,2.82,24.13,24.13,0,0,0-8.93,8.26h-2v7.63h0c.27,5.31,3.91,10.58,10.93,14.63a41.46,41.46,0,0,0,6,2.82Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.15,364.82a40.55,40.55,0,0,1,6,2.82,24.13,24.13,0,0,1,8.93,8.26h2v7.63h0c-.27,5.31-3.93,10.58-10.95,14.63a41.58,41.58,0,0,1-6,2.82Z",
    style: {
      fill: "#FE3E69",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.17,360.64c-14.6-8.43-38.27-8.43-52.86,0s-14.6,22.09,0,30.52,38.26,8.43,52.86,0S482.77,369.07,468.17,360.64Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.17,360.64c-14.6-8.43-38.27-8.43-52.86,0s-14.6,22.09,0,30.52,38.26,8.43,52.86,0S482.77,369.07,468.17,360.64Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459,366.22a42.19,42.19,0,0,0-34.42,0c-4.9,2.51-7.59,5.95-7.59,9.68s2.69,7.17,7.59,9.67a42.08,42.08,0,0,0,34.42,0c4.89-2.5,7.58-5.94,7.58-9.67S463.84,368.73,459,366.22Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459,366.22a42.19,42.19,0,0,0-34.42,0c-4.9,2.51-7.59,5.95-7.59,9.68s2.69,7.17,7.59,9.67a42.08,42.08,0,0,0,34.42,0c4.89-2.5,7.58-5.94,7.58-9.67S463.84,368.73,459,366.22Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.36,362.05c-6.82-3.94-15.92-6.11-25.62-6.11s-18.8,2.17-25.62,6.11c-6.54,3.77-10.13,8.69-10.13,13.85s3.59,10.08,10.13,13.85c6.82,3.93,15.91,6.1,25.62,6.1s18.8-2.17,25.62-6.1c6.53-3.77,10.13-8.69,10.13-13.85S473.89,365.82,467.36,362.05ZM459,385.57a42.08,42.08,0,0,1-34.42,0c-4.9-2.5-7.59-5.94-7.59-9.67s2.69-7.17,7.59-9.68a42.19,42.19,0,0,1,34.42,0c4.89,2.51,7.58,5.95,7.58,9.68S463.84,383.07,459,385.57Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.36,362.05c-6.82-3.94-15.92-6.11-25.62-6.11s-18.8,2.17-25.62,6.11c-6.54,3.77-10.13,8.69-10.13,13.85s3.59,10.08,10.13,13.85c6.82,3.93,15.91,6.1,25.62,6.1s18.8-2.17,25.62-6.1c6.53-3.77,10.13-8.69,10.13-13.85S473.89,365.82,467.36,362.05ZM459,385.57a42.08,42.08,0,0,1-34.42,0c-4.9-2.5-7.59-5.94-7.59-9.67s2.69-7.17,7.59-9.68a42.19,42.19,0,0,1,34.42,0c4.89,2.51,7.58,5.95,7.58,9.68S463.84,383.07,459,385.57Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 441.74,
    cy: 375.9,
    rx: 23.51,
    ry: 12.06,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 441.74,
    cy: 375.9,
    rx: 23.51,
    ry: 12.06,
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 441.74,
    cy: 375.9,
    rx: 23.51,
    ry: 12.06,
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.36,370.56c-9.18-4.71-24.07-4.71-33.25,0-3.79,1.95-6,4.4-6.67,6.94.66,2.53,2.88,5,6.67,6.93,9.18,4.71,24.07,4.71,33.25,0,3.8-1.95,6-4.4,6.68-6.93C464.38,375,462.16,372.51,458.36,370.56Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.36,370.56c-9.18-4.71-24.07-4.71-33.25,0-3.79,1.95-6,4.4-6.67,6.94.66,2.53,2.88,5,6.67,6.93,9.18,4.71,24.07,4.71,33.25,0,3.8-1.95,6-4.4,6.68-6.93C464.38,375,462.16,372.51,458.36,370.56Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443.96 367.55 443.96 371 442.79 372.24 440.61 374.52 440.61 370.93 443.96 367.55",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443.96 367.55 443.96 371 442.79 372.24 440.61 374.52 440.61 370.93 443.96 367.55",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.61,370.93v2a18.67,18.67,0,0,1-3.35,1,3.56,3.56,0,0,1-1.43-.05,3.61,3.61,0,0,1-.68-.28c-.83-.5-1-1.23.61-2.14A5.52,5.52,0,0,1,440.61,370.93Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.61,370.93v2a18.67,18.67,0,0,1-3.35,1,3.56,3.56,0,0,1-1.43-.05,3.61,3.61,0,0,1-.68-.28c-.83-.5-1-1.23.61-2.14A5.52,5.52,0,0,1,440.61,370.93Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.22,380.72v3l-3.77,2.18-2.79-1.61a14.2,14.2,0,0,1-10.8.48v-3l1.71-1.7-1.71.47a11,11,0,0,1-8.41-1c-1.69-1-2.48-2-2.47-3.14v-2.9l.3-1.27-1-.6v-3l2.79,1.61c-1.36,1.05-2.08,2.14-2.06,3.2v0c0,1.07.82,2.11,2.47,3.06,3.66,2.12,7.3,1.42,10.63.35,3.09-1,5.34-2.19,7.13-1.17,1.11.65.77,1.42-.47,2.14a6.16,6.16,0,0,1-5.32.31l-3.56,3.54a12.48,12.48,0,0,0,2,.57,14.63,14.63,0,0,0,8.83-1.06l2.79,1.61Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428,373.51v0c0,1.07.82,2.11,2.47,3.06,3.66,2.12,7.3,1.42,10.63.35,3.09-1,5.34-2.19,7.13-1.17,1.11.65.77,1.42-.47,2.14a6.16,6.16,0,0,1-5.32.31l-3.56,3.54a12.48,12.48,0,0,0,2,.57,14.63,14.63,0,0,0,8.83-1.06l2.79,1.61,3.77-2.17v3l-3.77,2.18-2.79-1.61a14.2,14.2,0,0,1-10.8.48v-3l1.71-1.7-1.71.47a11,11,0,0,1-8.41-1c-1.69-1-2.48-2-2.47-3.14v-2.9l.3-1.27",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.25,368.7v3l1,.6h0a6.19,6.19,0,0,1,1.77-2Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.59,378.77a3.55,3.55,0,0,1-.28,1.42l-1.89-1.08a3.72,3.72,0,0,0,2.14-2.87C455.58,377.06,455.59,378.69,455.59,378.77Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M455.59,378.77a3.55,3.55,0,0,1-.28,1.42l-1.89-1.08a3.72,3.72,0,0,0,2.14-2.87C455.58,377.06,455.59,378.69,455.59,378.77Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M455.58,380.36l-2.15-1.25a3.68,3.68,0,0,0,2.15-3.31,2.71,2.71,0,0,0,0-.29c-.1-1-.85-2-2.41-2.92h0a9.87,9.87,0,0,0-5-1.31h-.48l-.45,0-.39,0-.16,0-.3,0a20.48,20.48,0,0,0-2.43.5l-1.14.34-1.58.51-.6.21a18.61,18.61,0,0,1-3.34,1,3.42,3.42,0,0,1-1.44-.05,3.06,3.06,0,0,1-.67-.28c-.85-.49-1-1.23.6-2.14a5.52,5.52,0,0,1,4.85-.51l3.35-3.38a14.32,14.32,0,0,0-10.11.56l-2.8-1.61-3.8,2.2,2.8,1.61c-1.37,1.05-2.1,2.14-2.08,3.2v0c0,1.07.82,2.11,2.48,3.06,3.67,2.12,7.3,1.42,10.63.35,3.09-1,5.34-2.2,7.12-1.17,1.12.65.78,1.42-.46,2.14a6.16,6.16,0,0,1-5.32.31l-3.57,3.54a14.21,14.21,0,0,0,2,.58,13.47,13.47,0,0,0,3.44.25,15.87,15.87,0,0,0,5.38-1.32l2.8,1.62,3.76-2.18Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M455.58,380.36l-2.15-1.25a3.68,3.68,0,0,0,2.15-3.31,2.71,2.71,0,0,0,0-.29c-.1-1-.85-2-2.41-2.92h0a9.87,9.87,0,0,0-5-1.31h-.48l-.45,0-.39,0-.16,0-.3,0a20.48,20.48,0,0,0-2.43.5l-1.14.34-1.58.51-.6.21a18.61,18.61,0,0,1-3.34,1,3.42,3.42,0,0,1-1.44-.05,3.06,3.06,0,0,1-.67-.28c-.85-.49-1-1.23.6-2.14a5.52,5.52,0,0,1,4.85-.51l3.35-3.38a14.32,14.32,0,0,0-10.11.56l-2.8-1.61-3.8,2.2,2.8,1.61c-1.37,1.05-2.1,2.14-2.08,3.2v0c0,1.07.82,2.11,2.48,3.06,3.67,2.12,7.3,1.42,10.63.35,3.09-1,5.34-2.2,7.12-1.17,1.12.65.78,1.42-.46,2.14a6.16,6.16,0,0,1-5.32.31l-3.57,3.54a14.21,14.21,0,0,0,2,.58,13.47,13.47,0,0,0,3.44.25,15.87,15.87,0,0,0,5.38-1.32l2.8,1.62,3.76-2.18Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "449.65 381.28 449.65 384.26 452.45 385.87 452.45 382.89 449.65 381.28",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "449.65 381.28 449.65 384.26 452.45 385.87 452.45 382.89 449.65 381.28",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "427.25 368.7 431.05 366.5 433.85 368.11 431.08 366.95 427.25 368.7",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.76,371.44a5.52,5.52,0,0,1,4.85-.51l3.35-3.38-3.35,3A5.08,5.08,0,0,0,435.76,371.44Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.85,381.77a14.21,14.21,0,0,0,2,.58,13.47,13.47,0,0,0,3.44.25,12.12,12.12,0,0,1-4.85-1l3-3.4Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "449.65 381.28 452.45 382.54 456.21 380.72 452.45 382.89 449.65 381.28",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.41,362.55c9.9-6,25.33-6.61,25.33-6.61-9.71,0-18.8,2.17-25.62,6.11-6.54,3.77-10.13,8.69-10.13,13.85C406,375.9,406.34,368.67,416.41,362.55Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.85,397.42c10.51.46,21.29-1.62,29.32-6.26,8.35-4.82,11.93-11.36,10.72-17.65,0,0,1.56,10.25-11.35,17.26S438.85,397.42,438.85,397.42Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.64,365.31a24.05,24.05,0,0,0-8.93-8.26c-14.59-8.43-38.26-8.43-52.86,0a24.13,24.13,0,0,0-8.93,8.26h-2v7.63h0c.27,5.31,3.9,10.58,10.92,14.63,14.6,8.43,38.27,8.43,52.86,0,7-4.05,10.68-9.32,11-14.63h0v-7.63Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M474.64,365.31a24.05,24.05,0,0,0-8.93-8.26c-14.59-8.43-38.26-8.43-52.86,0a24.13,24.13,0,0,0-8.93,8.26h-2v7.63h0c.27,5.31,3.9,10.58,10.92,14.63,14.6,8.43,38.27,8.43,52.86,0,7-4.05,10.68-9.32,11-14.63h0v-7.63Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M439.29,350.73c-9.57,0-19.14,2.1-26.44,6.32a24.13,24.13,0,0,0-8.93,8.26h-2v7.63h0c.27,5.31,3.9,10.58,10.92,14.63,7.3,4.21,16.87,6.32,26.44,6.32Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.87,354.23a40.55,40.55,0,0,0-6,2.82,24.13,24.13,0,0,0-8.93,8.26h-2v7.63h0c.27,5.31,3.9,10.58,10.92,14.63a41.58,41.58,0,0,0,6,2.82Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.7,354.23a40,40,0,0,1,6,2.82,24.05,24.05,0,0,1,8.93,8.26h2v7.63h0c-.27,5.31-3.93,10.58-11,14.63a41,41,0,0,1-6,2.82Z",
    style: {
      fill: "#FE3E69",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.71,350.05c-14.59-8.43-38.26-8.43-52.86,0s-14.6,22.09,0,30.52,38.27,8.43,52.86,0S480.31,358.48,465.71,350.05Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.71,350.05c-14.59-8.43-38.26-8.43-52.86,0s-14.6,22.09,0,30.52,38.27,8.43,52.86,0S480.31,358.48,465.71,350.05Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.5,355.63a42.21,42.21,0,0,0-34.43,0c-4.89,2.51-7.59,5.95-7.59,9.68s2.7,7.17,7.59,9.67a42.11,42.11,0,0,0,34.43,0c4.88-2.5,7.58-5.94,7.58-9.67S461.38,358.14,456.5,355.63Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.5,355.63a42.21,42.21,0,0,0-34.43,0c-4.89,2.51-7.59,5.95-7.59,9.68s2.7,7.17,7.59,9.67a42.11,42.11,0,0,0,34.43,0c4.88-2.5,7.58-5.94,7.58-9.67S461.38,358.14,456.5,355.63Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.9,351.46c-6.81-3.94-15.92-6.11-25.62-6.11s-18.8,2.17-25.61,6.11c-6.54,3.77-10.14,8.69-10.14,13.85s3.6,10.08,10.14,13.85c6.81,3.93,15.91,6.1,25.61,6.1s18.81-2.17,25.62-6.1c6.53-3.77,10.14-8.69,10.14-13.85S471.43,355.23,464.9,351.46ZM456.5,375a42.11,42.11,0,0,1-34.43,0c-4.89-2.5-7.59-5.94-7.59-9.67s2.7-7.17,7.59-9.68a42.21,42.21,0,0,1,34.43,0c4.88,2.51,7.58,5.95,7.58,9.68S461.38,372.48,456.5,375Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.9,351.46c-6.81-3.94-15.92-6.11-25.62-6.11s-18.8,2.17-25.61,6.11c-6.54,3.77-10.14,8.69-10.14,13.85s3.6,10.08,10.14,13.85c6.81,3.93,15.91,6.1,25.61,6.1s18.81-2.17,25.62-6.1c6.53-3.77,10.14-8.69,10.14-13.85S471.43,355.23,464.9,351.46ZM456.5,375a42.11,42.11,0,0,1-34.43,0c-4.89-2.5-7.59-5.94-7.59-9.67s2.7-7.17,7.59-9.68a42.21,42.21,0,0,1,34.43,0c4.88,2.51,7.58,5.95,7.58,9.68S461.38,372.48,456.5,375Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.91,373.84c9.18-4.71,9.18-12.35,0-17.06s-24.07-4.71-33.25,0-9.18,12.35,0,17.06S446.73,378.55,455.91,373.84Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.91,373.84c9.18-4.71,9.18-12.35,0-17.06s-24.07-4.71-33.25,0-9.18,12.35,0,17.06S446.73,378.55,455.91,373.84Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.91,373.84c9.18-4.71,9.18-12.35,0-17.06s-24.07-4.71-33.25,0-9.18,12.35,0,17.06S446.73,378.55,455.91,373.84Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.91,360c-9.18-4.71-24.07-4.71-33.25,0-3.8,1.95-6,4.4-6.68,6.94.66,2.53,2.88,5,6.68,6.93,9.18,4.71,24.07,4.71,33.25,0,3.79-1.95,6-4.4,6.67-6.93C461.93,364.37,459.7,361.92,455.91,360Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.91,360c-9.18-4.71-24.07-4.71-33.25,0-3.8,1.95-6,4.4-6.68,6.94.66,2.53,2.88,5,6.68,6.93,9.18,4.71,24.07,4.71,33.25,0,3.79-1.95,6-4.4,6.67-6.93C461.93,364.37,459.7,361.92,455.91,360Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "441.51 356.96 441.51 360.41 440.33 361.65 438.16 363.93 438.16 360.34 441.51 356.96",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "441.51 356.96 441.51 360.41 440.33 361.65 438.16 363.93 438.16 360.34 441.51 356.96",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.16,360.34v2a18.67,18.67,0,0,1-3.35.95,3.55,3.55,0,0,1-1.43-.05,3.7,3.7,0,0,1-.69-.28c-.83-.5-1-1.23.62-2.14A5.52,5.52,0,0,1,438.16,360.34Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.16,360.34v2a18.67,18.67,0,0,1-3.35.95,3.55,3.55,0,0,1-1.43-.05,3.7,3.7,0,0,1-.69-.28c-.83-.5-1-1.23.62-2.14A5.52,5.52,0,0,1,438.16,360.34Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.76,370.13v3L450,375.28l-2.79-1.61a14.24,14.24,0,0,1-10.8.49v-3l1.72-1.7-1.72.47a11,11,0,0,1-8.41-1c-1.69-1-2.47-2-2.47-3.14V363l.31-1.27-1-.59v-3l2.79,1.61c-1.36,1.06-2.09,2.14-2.07,3.2v0c0,1.07.82,2.11,2.47,3.06,3.67,2.12,7.3,1.42,10.63.35,3.1-1,5.35-2.19,7.13-1.16,1.11.64.78,1.41-.47,2.13a6.14,6.14,0,0,1-5.31.31l-3.57,3.54a12.48,12.48,0,0,0,2,.57,14.63,14.63,0,0,0,8.83-1.06l2.79,1.62Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.52,362.92v0c0,1.07.82,2.11,2.47,3.06,3.67,2.12,7.3,1.42,10.63.35,3.1-1,5.35-2.19,7.13-1.16,1.11.64.78,1.41-.47,2.13a6.14,6.14,0,0,1-5.31.31l-3.57,3.54a12.48,12.48,0,0,0,2,.57,14.63,14.63,0,0,0,8.83-1.06l2.79,1.62,3.77-2.18v3L450,375.28l-2.79-1.61a14.24,14.24,0,0,1-10.8.49v-3l1.72-1.7-1.72.47a11,11,0,0,1-8.41-1c-1.69-1-2.47-2-2.47-3.14V363l.31-1.27",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.8,358.11v3l1,.59h0a6.08,6.08,0,0,1,1.77-2Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.14,368.18a3.39,3.39,0,0,1-.29,1.42L451,368.52a3.72,3.72,0,0,0,2.14-2.87C453.12,366.47,453.14,368.1,453.14,368.18Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M453.14,368.18a3.39,3.39,0,0,1-.29,1.42L451,368.52a3.72,3.72,0,0,0,2.14-2.87C453.12,366.47,453.14,368.1,453.14,368.18Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M453.13,369.77,451,368.52a3.68,3.68,0,0,0,2.16-3.31,2.64,2.64,0,0,0,0-.29c-.09-1-.85-2-2.41-2.92h0a9.82,9.82,0,0,0-5-1.31h-.47l-.45,0-.39,0-.16,0-.3,0a21.07,21.07,0,0,0-2.44.5l-1.14.34-1.58.51-.59.21a17.86,17.86,0,0,1-3.35.95,3.43,3.43,0,0,1-1.44-.05,3.53,3.53,0,0,1-.67-.28c-.84-.49-1-1.23.61-2.14a5.52,5.52,0,0,1,4.85-.51l3.35-3.38a14.35,14.35,0,0,0-10.12.56l-2.79-1.61-3.8,2.2,2.79,1.61c-1.36,1-2.09,2.15-2.07,3.2v0c0,1.07.82,2.11,2.47,3.06,3.67,2.12,7.31,1.42,10.63.35,3.09-1,5.35-2.2,7.13-1.17,1.11.65.78,1.42-.47,2.14a6.14,6.14,0,0,1-5.31.31l-3.57,3.54a14.09,14.09,0,0,0,2,.58,13.53,13.53,0,0,0,3.44.25,16,16,0,0,0,5.39-1.32l2.79,1.62,3.77-2.18Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M453.13,369.77,451,368.52a3.68,3.68,0,0,0,2.16-3.31,2.64,2.64,0,0,0,0-.29c-.09-1-.85-2-2.41-2.92h0a9.82,9.82,0,0,0-5-1.31h-.47l-.45,0-.39,0-.16,0-.3,0a21.07,21.07,0,0,0-2.44.5l-1.14.34-1.58.51-.59.21a17.86,17.86,0,0,1-3.35.95,3.43,3.43,0,0,1-1.44-.05,3.53,3.53,0,0,1-.67-.28c-.84-.49-1-1.23.61-2.14a5.52,5.52,0,0,1,4.85-.51l3.35-3.38a14.35,14.35,0,0,0-10.12.56l-2.79-1.61-3.8,2.2,2.79,1.61c-1.36,1-2.09,2.15-2.07,3.2v0c0,1.07.82,2.11,2.47,3.06,3.67,2.12,7.31,1.42,10.63.35,3.09-1,5.35-2.2,7.13-1.17,1.11.65.78,1.42-.47,2.14a6.14,6.14,0,0,1-5.31.31l-3.57,3.54a14.09,14.09,0,0,0,2,.58,13.53,13.53,0,0,0,3.44.25,16,16,0,0,0,5.39-1.32l2.79,1.62,3.77-2.18Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "447.2 370.69 447.2 373.67 449.99 375.28 449.99 372.31 447.2 370.69",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "447.2 370.69 447.2 373.67 449.99 375.28 449.99 372.31 447.2 370.69",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.8 358.11 428.6 355.92 431.39 357.52 428.62 356.36 424.8 358.11",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.31,360.85a5.52,5.52,0,0,1,4.85-.51l3.35-3.38-3.35,3A5.08,5.08,0,0,0,433.31,360.85Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.4,371.18a14.09,14.09,0,0,0,2,.58,13.53,13.53,0,0,0,3.44.25,12.15,12.15,0,0,1-4.85-1l3-3.4Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "447.2 370.69 449.99 371.95 453.76 370.13 449.99 372.31 447.2 370.69",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,352c9.9-6,25.33-6.61,25.33-6.61-9.7,0-18.8,2.17-25.61,6.11-6.54,3.77-10.14,8.69-10.14,13.85C403.53,365.31,403.89,358.08,414,352Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.4,386.83c10.5.46,21.28-1.62,29.31-6.26,8.36-4.82,11.93-11.36,10.72-17.65,0,0,1.56,10.25-11.35,17.27S436.4,386.83,436.4,386.83Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--gears--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gear--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.86,69a1.14,1.14,0,0,1-.56-.14l-3-1.71a1.1,1.1,0,0,1-.44-1.45l2.72-5.49a.65.65,0,0,0,0-.51,9.94,9.94,0,0,1-1-2.14l-4.08,1.83a.83.83,0,0,1-1.23-.79v-5.3A1.74,1.74,0,0,1,147,52l4.19-3a1.14,1.14,0,0,0,.39-.59,29,29,0,0,1,1.08-3.62.38.38,0,0,0-.08-.36l-2.37-2A1.21,1.21,0,0,1,150,41l3.37-5.85a1.24,1.24,0,0,1,1.42-.53l2.95,1a.38.38,0,0,0,.36-.1,28.42,28.42,0,0,1,2.59-2.75,1.19,1.19,0,0,0,.32-.63l.46-5.11a1.72,1.72,0,0,1,.79-1.24l4.59-2.65a.89.89,0,0,1,.85-.05.87.87,0,0,1,.45.72l.45,4.45A9.55,9.55,0,0,1,170.9,28h0a.61.61,0,0,0,.45-.22l3.39-5.1a1.12,1.12,0,0,1,1.48-.35l3,1.71a1.1,1.1,0,0,1,.44,1.45L176.9,31a.65.65,0,0,0,0,.51,9.48,9.48,0,0,1,1,2.14L182,31.8a.83.83,0,0,1,1.22.79v5.3a1.71,1.71,0,0,1-.68,1.31l-4.19,2.95a1.33,1.33,0,0,0-.39.59,27,27,0,0,1-1.08,3.62.39.39,0,0,0,.09.36l2.36,2a1.22,1.22,0,0,1,.26,1.49L176.2,56.1a1.22,1.22,0,0,1-1.42.53l-2.95-1a.42.42,0,0,0-.35.1,28.5,28.5,0,0,1-2.6,2.75,1.17,1.17,0,0,0-.31.63l-.46,5.11a1.73,1.73,0,0,1-.8,1.24l-4.59,2.65a.84.84,0,0,1-1.3-.66L161,63a9.64,9.64,0,0,1-2.34.24.52.52,0,0,0-.47.22l-3.39,5.1A1.09,1.09,0,0,1,153.86,69Zm-2.22-12.45a.93.93,0,0,1,.4.09,1,1,0,0,1,.54.62,8.42,8.42,0,0,0,.86,1.92,1.63,1.63,0,0,1,.09,1.47l-2.73,5.49a.13.13,0,0,0,0,.15l3,1.71a.12.12,0,0,0,.15,0l3.4-5.1a1.67,1.67,0,0,1,1.31-.67,8.43,8.43,0,0,0,2.09-.21,1.07,1.07,0,0,1,.82.16,1,1,0,0,1,.4.71l.42,4.26,4.42-2.55a.73.73,0,0,0,.3-.47l.46-5.11a2.18,2.18,0,0,1,.64-1.27,28.86,28.86,0,0,0,2.5-2.65,1.39,1.39,0,0,1,1.45-.41l3,1a.23.23,0,0,0,.23-.09l3.38-5.84a.25.25,0,0,0-.05-.25l-2.36-2a1.39,1.39,0,0,1-.37-1.46,27.12,27.12,0,0,0,1-3.5,2.19,2.19,0,0,1,.79-1.18l4.19-3a.74.74,0,0,0,.26-.49v-5.1l-3.91,1.76a1,1,0,0,1-.81,0,1,1,0,0,1-.55-.63,8.62,8.62,0,0,0-.86-1.92,1.63,1.63,0,0,1-.08-1.47l2.72-5.49a.12.12,0,0,0,0-.15l-3-1.7a.12.12,0,0,0-.15,0l-3.39,5.11a1.57,1.57,0,0,1-1.32.66,8.57,8.57,0,0,0-2.09.21,1,1,0,0,1-.81-.16,1,1,0,0,1-.4-.71l-.43-4.26-4.42,2.55a.77.77,0,0,0-.3.47L162,32.21a2.15,2.15,0,0,1-.64,1.27,28.86,28.86,0,0,0-2.5,2.65,1.37,1.37,0,0,1-1.45.41l-2.94-1a.25.25,0,0,0-.24.09l-3.37,5.84a.23.23,0,0,0,0,.25l2.37,2a1.38,1.38,0,0,1,.37,1.45,27.68,27.68,0,0,0-1,3.5,2.25,2.25,0,0,1-.78,1.19l-4.2,3a.78.78,0,0,0-.25.49v5.11l3.9-1.77A1.06,1.06,0,0,1,151.64,56.56Zm9.66-.45a4.45,4.45,0,0,1-2.26-.58c-1.63-.94-2.52-2.88-2.52-5.45,0-5.1,3.59-11.32,8-13.86,2.23-1.29,4.36-1.49,6-.55S173,38.55,173,41.12c0,5.1-3.59,11.32-8,13.86h0A7.46,7.46,0,0,1,161.3,56.11Zm6.93-20a6.54,6.54,0,0,0-3.21,1,16.61,16.61,0,0,0-7.51,13c0,2.2.72,3.83,2,4.59s3.08.56,5-.55h0a16.6,16.6,0,0,0,7.5-13c0-2.2-.71-3.83-2-4.59A3.5,3.5,0,0,0,168.23,36.08Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.86,69a1.14,1.14,0,0,1-.56-.14l-3-1.71a1.1,1.1,0,0,1-.44-1.45l2.72-5.49a.65.65,0,0,0,0-.51,9.94,9.94,0,0,1-1-2.14l-4.08,1.83a.83.83,0,0,1-1.23-.79v-5.3A1.74,1.74,0,0,1,147,52l4.19-3a1.14,1.14,0,0,0,.39-.59,29,29,0,0,1,1.08-3.62.38.38,0,0,0-.08-.36l-2.37-2A1.21,1.21,0,0,1,150,41l3.37-5.85a1.24,1.24,0,0,1,1.42-.53l2.95,1a.38.38,0,0,0,.36-.1,28.42,28.42,0,0,1,2.59-2.75,1.19,1.19,0,0,0,.32-.63l.46-5.11a1.72,1.72,0,0,1,.79-1.24l4.59-2.65a.89.89,0,0,1,.85-.05.87.87,0,0,1,.45.72l.45,4.45A9.55,9.55,0,0,1,170.9,28h0a.61.61,0,0,0,.45-.22l3.39-5.1a1.12,1.12,0,0,1,1.48-.35l3,1.71a1.1,1.1,0,0,1,.44,1.45L176.9,31a.65.65,0,0,0,0,.51,9.48,9.48,0,0,1,1,2.14L182,31.8a.83.83,0,0,1,1.22.79v5.3a1.71,1.71,0,0,1-.68,1.31l-4.19,2.95a1.33,1.33,0,0,0-.39.59,27,27,0,0,1-1.08,3.62.39.39,0,0,0,.09.36l2.36,2a1.22,1.22,0,0,1,.26,1.49L176.2,56.1a1.22,1.22,0,0,1-1.42.53l-2.95-1a.42.42,0,0,0-.35.1,28.5,28.5,0,0,1-2.6,2.75,1.17,1.17,0,0,0-.31.63l-.46,5.11a1.73,1.73,0,0,1-.8,1.24l-4.59,2.65a.84.84,0,0,1-1.3-.66L161,63a9.64,9.64,0,0,1-2.34.24.52.52,0,0,0-.47.22l-3.39,5.1A1.09,1.09,0,0,1,153.86,69Zm-2.22-12.45a.93.93,0,0,1,.4.09,1,1,0,0,1,.54.62,8.42,8.42,0,0,0,.86,1.92,1.63,1.63,0,0,1,.09,1.47l-2.73,5.49a.13.13,0,0,0,0,.15l3,1.71a.12.12,0,0,0,.15,0l3.4-5.1a1.67,1.67,0,0,1,1.31-.67,8.43,8.43,0,0,0,2.09-.21,1.07,1.07,0,0,1,.82.16,1,1,0,0,1,.4.71l.42,4.26,4.42-2.55a.73.73,0,0,0,.3-.47l.46-5.11a2.18,2.18,0,0,1,.64-1.27,28.86,28.86,0,0,0,2.5-2.65,1.39,1.39,0,0,1,1.45-.41l3,1a.23.23,0,0,0,.23-.09l3.38-5.84a.25.25,0,0,0-.05-.25l-2.36-2a1.39,1.39,0,0,1-.37-1.46,27.12,27.12,0,0,0,1-3.5,2.19,2.19,0,0,1,.79-1.18l4.19-3a.74.74,0,0,0,.26-.49v-5.1l-3.91,1.76a1,1,0,0,1-.81,0,1,1,0,0,1-.55-.63,8.62,8.62,0,0,0-.86-1.92,1.63,1.63,0,0,1-.08-1.47l2.72-5.49a.12.12,0,0,0,0-.15l-3-1.7a.12.12,0,0,0-.15,0l-3.39,5.11a1.57,1.57,0,0,1-1.32.66,8.57,8.57,0,0,0-2.09.21,1,1,0,0,1-.81-.16,1,1,0,0,1-.4-.71l-.43-4.26-4.42,2.55a.77.77,0,0,0-.3.47L162,32.21a2.15,2.15,0,0,1-.64,1.27,28.86,28.86,0,0,0-2.5,2.65,1.37,1.37,0,0,1-1.45.41l-2.94-1a.25.25,0,0,0-.24.09l-3.37,5.84a.23.23,0,0,0,0,.25l2.37,2a1.38,1.38,0,0,1,.37,1.45,27.68,27.68,0,0,0-1,3.5,2.25,2.25,0,0,1-.78,1.19l-4.2,3a.78.78,0,0,0-.25.49v5.11l3.9-1.77A1.06,1.06,0,0,1,151.64,56.56Zm9.66-.45a4.45,4.45,0,0,1-2.26-.58c-1.63-.94-2.52-2.88-2.52-5.45,0-5.1,3.59-11.32,8-13.86,2.23-1.29,4.36-1.49,6-.55S173,38.55,173,41.12c0,5.1-3.59,11.32-8,13.86h0A7.46,7.46,0,0,1,161.3,56.11Zm6.93-20a6.54,6.54,0,0,0-3.21,1,16.61,16.61,0,0,0-7.51,13c0,2.2.72,3.83,2,4.59s3.08.56,5-.55h0a16.6,16.6,0,0,0,7.5-13c0-2.2-.71-3.83-2-4.59A3.5,3.5,0,0,0,168.23,36.08Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--World--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.08,16.64c-2.11-1.23-4.81-1-7.58.58-6.16,3.56-11.18,13.12-11.18,21.32,0,4.4,1.46,7.76,4,9.23a6,6,0,0,0,3,.79,9.21,9.21,0,0,0,4.56-1.37c6.17-3.56,11.18-13.13,11.18-21.33C212.08,21.47,210.62,18.1,208.08,16.64ZM190.15,37.83a27.24,27.24,0,0,1,3.58-12.09,6,6,0,0,0,1.56.5A29,29,0,0,0,193.34,36Zm10.95-5.4,6.14-3.54a28.82,28.82,0,0,1-2,9.2,8.75,8.75,0,0,0-4.18,1Zm0-.92V24.83A18.2,18.2,0,0,0,205.51,21a13.43,13.43,0,0,1,1.74,7Zm0-7.63V18A5.81,5.81,0,0,1,205,20.3,18.09,18.09,0,0,1,201.1,23.88Zm-.8.49a8.35,8.35,0,0,1-3.86,1.14,30.85,30.85,0,0,1,3.86-6.8Zm-4.18,1.95h.22a8.91,8.91,0,0,0,4-1.06V32l-6.14,3.55A28.55,28.55,0,0,1,196.12,26.32Zm4.18,6.58v6.67a17.86,17.86,0,0,0-4.41,3.87,13.53,13.53,0,0,1-1.75-7Zm0,7.62V46.4a5.81,5.81,0,0,1-3.94-2.29A17.92,17.92,0,0,1,200.3,40.52Zm.8-.49A8.35,8.35,0,0,1,205,38.89a30.85,30.85,0,0,1-3.86,6.8Zm7-11.61,3.2-1.85a27.24,27.24,0,0,1-3.58,12.1,5.65,5.65,0,0,0-1.57-.5A29,29,0,0,0,208.05,28.42Zm3.22-2.78L208,27.5a13.68,13.68,0,0,0-2-7.18A26.34,26.34,0,0,0,208,17.53C210,18.92,211.22,21.83,211.27,25.64Zm-4-8.51a24.75,24.75,0,0,1-1.72,2.52A6.63,6.63,0,0,0,202,17.36a7.7,7.7,0,0,1,3.07-.71A5.29,5.29,0,0,1,207.27,17.13Zm-8.44,2.25a32.42,32.42,0,0,0-3.23,6.08,4.88,4.88,0,0,1-1.47-.42A22.62,22.62,0,0,1,198.83,19.38Zm-8.7,19.39,3.22-1.86a13.74,13.74,0,0,0,2,7.19,24.6,24.6,0,0,0-1.91,2.77C191.38,45.49,190.18,42.58,190.13,38.77Zm4,8.5a25.75,25.75,0,0,1,1.72-2.51,6.62,6.62,0,0,0,3.54,2.29A6.37,6.37,0,0,1,194.13,47.27ZM202.57,45a32.78,32.78,0,0,0,3.23-6.09,5.18,5.18,0,0,1,1.47.42A22.67,22.67,0,0,1,202.57,45Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.08,16.64c-2.11-1.23-4.81-1-7.58.58-6.16,3.56-11.18,13.12-11.18,21.32,0,4.4,1.46,7.76,4,9.23a6,6,0,0,0,3,.79,9.21,9.21,0,0,0,4.56-1.37c6.17-3.56,11.18-13.13,11.18-21.33C212.08,21.47,210.62,18.1,208.08,16.64ZM190.15,37.83a27.24,27.24,0,0,1,3.58-12.09,6,6,0,0,0,1.56.5A29,29,0,0,0,193.34,36Zm10.95-5.4,6.14-3.54a28.82,28.82,0,0,1-2,9.2,8.75,8.75,0,0,0-4.18,1Zm0-.92V24.83A18.2,18.2,0,0,0,205.51,21a13.43,13.43,0,0,1,1.74,7Zm0-7.63V18A5.81,5.81,0,0,1,205,20.3,18.09,18.09,0,0,1,201.1,23.88Zm-.8.49a8.35,8.35,0,0,1-3.86,1.14,30.85,30.85,0,0,1,3.86-6.8Zm-4.18,1.95h.22a8.91,8.91,0,0,0,4-1.06V32l-6.14,3.55A28.55,28.55,0,0,1,196.12,26.32Zm4.18,6.58v6.67a17.86,17.86,0,0,0-4.41,3.87,13.53,13.53,0,0,1-1.75-7Zm0,7.62V46.4a5.81,5.81,0,0,1-3.94-2.29A17.92,17.92,0,0,1,200.3,40.52Zm.8-.49A8.35,8.35,0,0,1,205,38.89a30.85,30.85,0,0,1-3.86,6.8Zm7-11.61,3.2-1.85a27.24,27.24,0,0,1-3.58,12.1,5.65,5.65,0,0,0-1.57-.5A29,29,0,0,0,208.05,28.42Zm3.22-2.78L208,27.5a13.68,13.68,0,0,0-2-7.18A26.34,26.34,0,0,0,208,17.53C210,18.92,211.22,21.83,211.27,25.64Zm-4-8.51a24.75,24.75,0,0,1-1.72,2.52A6.63,6.63,0,0,0,202,17.36a7.7,7.7,0,0,1,3.07-.71A5.29,5.29,0,0,1,207.27,17.13Zm-8.44,2.25a32.42,32.42,0,0,0-3.23,6.08,4.88,4.88,0,0,1-1.47-.42A22.62,22.62,0,0,1,198.83,19.38Zm-8.7,19.39,3.22-1.86a13.74,13.74,0,0,0,2,7.19,24.6,24.6,0,0,0-1.91,2.77C191.38,45.49,190.18,42.58,190.13,38.77Zm4,8.5a25.75,25.75,0,0,1,1.72-2.51,6.62,6.62,0,0,0,3.54,2.29A6.37,6.37,0,0,1,194.13,47.27ZM202.57,45a32.78,32.78,0,0,0,3.23-6.09,5.18,5.18,0,0,1,1.47.42A22.67,22.67,0,0,1,202.57,45Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--ad-4--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Ad--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.65,71.35a2.64,2.64,0,0,1,.15-.29h0A2.69,2.69,0,0,0,41.65,71.35Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.49,17.57a.64.64,0,0,0-.63-.5,1,1,0,0,0-.54.17L42.66,70.15a2.52,2.52,0,0,0-.86.91l-3.65-2.12a2.48,2.48,0,0,1,.83-.87l91.65-52.91a2.74,2.74,0,0,1,2.45,0l1.23.69A2.66,2.66,0,0,1,135.49,17.57Z",
    style: {
      fill: "#37474f",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.66,137.86a2.79,2.79,0,0,1-2.44,0L39,137.11A2.62,2.62,0,0,1,37.76,135V70.19a2.5,2.5,0,0,1,.39-1.25l3.65,2.12a2.49,2.49,0,0,0-.36,1.2v64.89C41.44,137.86,42,138.27,42.66,137.86Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.85
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.86,17.07a1,1,0,0,0-.54.17L42.66,70.15a2.72,2.72,0,0,0-1.22,2.11v64.89c0,.55.28.87.68.87a1.1,1.1,0,0,0,.54-.16l91.66-52.92a2.7,2.7,0,0,0,1.22-2.11V17.94c0-.55-.28-.87-.68-.87Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M134.67,18V82.83a1.88,1.88,0,0,1-.78,1.37L42.31,137.07V72.26a1.82,1.82,0,0,1,.79-1.36L134.67,18m.19-.95a1,1,0,0,0-.54.17L42.66,70.15a2.72,2.72,0,0,0-1.22,2.11v64.89c0,.55.28.87.68.87a1.1,1.1,0,0,0,.54-.16l91.66-52.92a2.7,2.7,0,0,0,1.22-2.11V17.94c0-.55-.28-.87-.68-.87Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-88",
    d: "M125.41,77.37v-48c0-1.58-1.11-2.22-2.48-1.43L49.07,70.55a5.49,5.49,0,0,0-2.48,4.3v48c0,1.59,1.11,2.23,2.48,1.44l73.86-42.64A5.49,5.49,0,0,0,125.41,77.37Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--ad--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.9,78.8v-48c0-1.58-1.11-2.22-2.48-1.43L51.56,72a5.49,5.49,0,0,0-2.48,4.3v48c0,1.59,1.11,2.23,2.48,1.44l73.86-42.64A5.51,5.51,0,0,0,127.9,78.8Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Text--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.78,77l-20,11.55c-.24.15-.44,0-.44-.33V81.36a1.09,1.09,0,0,1,.44-.86l20-11.56c.25-.14.45,0,.45.34v6.81A1.07,1.07,0,0,1,81.78,77Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.14,84.47a.22.22,0,0,1,0-.14V80.68a.48.48,0,0,1,0-.18.24.24,0,0,1,.1-.1l.67-.39c.25-.15.45-.17.57-.07a.79.79,0,0,1,.19.63,2.18,2.18,0,0,1-.09.63,2,2,0,0,1-.25.5v0a.32.32,0,0,1,.3.15,1.07,1.07,0,0,1,.12.58,2.19,2.19,0,0,1-.21,1,1.54,1.54,0,0,1-.63.66l-.67.39S65.16,84.5,65.14,84.47Zm.76-2.76a.5.5,0,0,0,.21-.27,1.26,1.26,0,0,0,.08-.46.61.61,0,0,0-.07-.36c-.05-.05-.12-.05-.22,0l-.31.17v1.09Zm0,1.74c.21-.12.31-.38.31-.79a.61.61,0,0,0-.08-.37c-.05-.06-.14-.06-.25,0l-.34.2v1.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.35,83a.92.92,0,0,1-.24-.76V79.47a.34.34,0,0,1,.2-.28l.11-.06c.13-.08.19-.06.19.05v2.71a.51.51,0,0,0,.11.37c.07.07.16.07.28,0a.75.75,0,0,0,.27-.33,1,1,0,0,0,.11-.49V78.74a.35.35,0,0,1,.19-.28l.12-.06c.12-.08.19-.06.19,0v2.74a2.26,2.26,0,0,1-.23,1,1.69,1.69,0,0,1-.65.7C67.72,83.08,67.5,83.1,67.35,83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.75,81.71V80.08l-.6-1.71a.26.26,0,0,1,0-.11c0-.08.07-.15.2-.23l.15-.09.13,0a.06.06,0,0,1,.06,0L70,79.23l.36-1.71a.24.24,0,0,1,.06-.11.48.48,0,0,1,.13-.09l.12-.07c.13-.08.2-.09.2,0s0,.07,0,.15l-.6,2.42v1.61a.31.31,0,0,1-.2.27l-.11.07C69.82,81.84,69.75,81.82,69.75,81.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.65,80.61V76.85a.33.33,0,0,1,.19-.28l.1,0a.21.21,0,0,1,.11,0s0,0,.07.08l.74,1.71a3.65,3.65,0,0,1,.12.36l0,0a3.19,3.19,0,0,1,0-.42v-2.1a.33.33,0,0,1,.19-.28l.07,0c.13-.07.2,0,.2.06v3.75a.32.32,0,0,1-.2.28l-.07,0s-.08,0-.11,0-.06,0-.07-.07L72.2,78.1a2.87,2.87,0,0,1-.1-.31l0,0a2.4,2.4,0,0,1,0,.37v2.16a.3.3,0,0,1-.19.27l-.08,0C71.71,80.74,71.65,80.72,71.65,80.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.81,77.48c0-1.38.32-2.26,1-2.63s1,.13,1,1.51-.32,2.27-1,2.64S73.81,78.87,73.81,77.48Zm1.31.34a4.22,4.22,0,0,0,.12-1.16,2.94,2.94,0,0,0-.12-1,.21.21,0,0,0-.34-.12.86.86,0,0,0-.35.53,4.64,4.64,0,0,0-.11,1.16,3.21,3.21,0,0,0,.11,1c.08.18.19.22.35.13A.82.82,0,0,0,75.12,77.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.39,77.93l-.51-3.47v-.08c0-.09.07-.18.2-.25l.09,0q.19-.12.21,0l.23,2.24,0,.48,0,.27c0-.19,0-.48.08-.85L77,73.7a.22.22,0,0,1,0-.12.35.35,0,0,1,.11-.09l.15-.09a.24.24,0,0,1,.12,0s0,0,0,.06l.27,2.26c0,.07,0,.22,0,.44s0,.19,0,.32l.07-.85.24-2.51a.35.35,0,0,1,.21-.27l.07,0c.13-.08.2-.07.2,0v.09l-.51,4.05a.29.29,0,0,1-.16.21l-.21.12c-.1.06-.15,0-.16,0l-.28-2,0-.63-.05.69-.29,2.35a.29.29,0,0,1-.16.21l-.21.12C76.45,78,76.4,78,76.39,77.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.21,66.06a17,17,0,0,1-.65,4.88,14,14,0,0,1-4.45,6.83,22.8,22.8,0,0,1-3.39,2.37,26.18,26.18,0,0,1-2.6,1.34c-.77.33-1.6.67-2.5,1V53c.68-.56,1.42-1.13,2.23-1.7a31.82,31.82,0,0,1,2.82-1.8,12.58,12.58,0,0,1,2.86-1.26,3.74,3.74,0,0,1,2.32,0,2.8,2.8,0,0,1,1.57,1.57,8.53,8.53,0,0,1,.58,3.57,13.42,13.42,0,0,1-.57,3.86A13,13,0,0,1,100,60.47a3,3,0,0,1,1.2.28,2.6,2.6,0,0,1,1,.9,5.27,5.27,0,0,1,.71,1.71A11.48,11.48,0,0,1,103.21,66.06Zm-8.94-4.51.75-.43a4.93,4.93,0,0,0,1.8-1.77,5.6,5.6,0,0,0,.64-2.87,3,3,0,0,0-.23-1.31,1.11,1.11,0,0,0-.57-.58,1.22,1.22,0,0,0-.78,0,4.43,4.43,0,0,0-.84.36l-.39.23a1.94,1.94,0,0,0-.38.26Zm0,5.87v7l.47-.21c.18-.1.43-.23.73-.41a6.08,6.08,0,0,0,1-.76,5.78,5.78,0,0,0,.95-1.11,5.53,5.53,0,0,0,.69-1.47,6.3,6.3,0,0,0,.25-1.86c0-1.32-.28-2.08-.84-2.26a2.76,2.76,0,0,0-2.19.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.7,73a11.38,11.38,0,0,1-2.39,1V44.47c.48-.39.92-.73,1.31-1s.75-.51,1-.69a11.08,11.08,0,0,1,1.09-.54c.4-.18.84-.35,1.3-.51V71.24A17.8,17.8,0,0,1,106.7,73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,48.4q.73-.59,1.29-1a12.41,12.41,0,0,1,1-.69,10.2,10.2,0,0,1,1.1-.55,9,9,0,0,1,1.26-.48v15a21.22,21.22,0,0,1-3.13,3,26.9,26.9,0,0,1-2.64,1.82,7.61,7.61,0,0,1-4.14,1.25,4.2,4.2,0,0,1-3-1.45A8.57,8.57,0,0,1,111,61.55a25.27,25.27,0,0,1-.59-5.78,34.16,34.16,0,0,1,.62-6.49,29.07,29.07,0,0,1,1.78-5.93,20.69,20.69,0,0,1,2.89-4.89,13.86,13.86,0,0,1,3.89-3.41,13.23,13.23,0,0,1,2.46-1.13,6.7,6.7,0,0,1,2.57-.28,22.1,22.1,0,0,1-.41,3.54q-.35,1.82-.72,3.15a9.2,9.2,0,0,0-1,.07,5.57,5.57,0,0,0-.85.15,7.58,7.58,0,0,0-.8.28,7.82,7.82,0,0,0-.86.44,8.07,8.07,0,0,0-3.36,4.19,19.92,19.92,0,0,0-1.18,7.4c0,3,.38,4.92,1.15,5.93s1.92,1.06,3.44.18a4.79,4.79,0,0,0,.91-.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.69,84.28a5.26,5.26,0,0,1,1,.13,1.57,1.57,0,0,1,.78.42,2,2,0,0,1,.5,1,6,6,0,0,1,.18,1.64,8.71,8.71,0,0,1-1,4.11A8,8,0,0,1,102,93.21a7.19,7.19,0,0,1-1.64,1.29,6.19,6.19,0,0,1-1.48.65,5.28,5.28,0,0,1-1.4.15c0-.51.1-1.06.19-1.67s.2-1.22.33-1.87a3.52,3.52,0,0,0,2.17-.42,3.3,3.3,0,0,0,1.09-1,2.3,2.3,0,0,0,.38-1.34,1.28,1.28,0,0,0-.08-.53.58.58,0,0,0-.22-.28.64.64,0,0,0-.3-.11l-.35,0h-.76A2.52,2.52,0,0,1,99,88a1.62,1.62,0,0,1-.69-.5,2.37,2.37,0,0,1-.44-.93,6,6,0,0,1-.16-1.48,8.76,8.76,0,0,1,.93-4,7,7,0,0,1,1.07-1.51,6.21,6.21,0,0,1,1.4-1.12,5.73,5.73,0,0,1,1.34-.56,6.66,6.66,0,0,1,1.38-.19c0,.47-.1,1-.19,1.59s-.22,1.17-.36,1.73a7.42,7.42,0,0,0-.83,0,2.88,2.88,0,0,0-1.19.43,2.94,2.94,0,0,0-.41.31,2.77,2.77,0,0,0-.36.4,2.51,2.51,0,0,0-.25.52,2.27,2.27,0,0,0-.09.65c0,.41.08.66.26.76a1.41,1.41,0,0,0,.61.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.21,90.82c-.21.18-.4.33-.57.46s-.34.23-.51.33a5.92,5.92,0,0,1-.56.27c-.22.09-.45.17-.72.26l3.05-16.71.66-.49a5.93,5.93,0,0,1,.62-.4,5.84,5.84,0,0,1,.56-.28l.7-.3,3,13.23a10.77,10.77,0,0,1-1.36,1q-.27.15-.54.27a5.12,5.12,0,0,1-.59.21L109.44,86a8.56,8.56,0,0,1-.72.67,5.41,5.41,0,0,1-.69.48,4.12,4.12,0,0,1-.64.3,4.83,4.83,0,0,1-.68.17Zm1.9-12.16-.91,5.91.43-.08a2.2,2.2,0,0,0,.43-.18,4.16,4.16,0,0,0,.45-.32,4.48,4.48,0,0,0,.47-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.65,72.13l.67-.52c.2-.14.38-.25.53-.34a4.69,4.69,0,0,1,.55-.28c.21-.09.43-.17.66-.25V82.46l3.14-1.81a7.64,7.64,0,0,1,.09.86c0,.25,0,.48,0,.69s0,.49,0,.75,0,.6-.09,1l-5.55,3.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.81,72.85a12.44,12.44,0,0,1-.13,1.7l-2.62,1.52v3l3.41-2a9.27,9.27,0,0,1,.13,1.52,12.4,12.4,0,0,1-.13,1.73l-5.82,3.36V68.62l5.74-3.31c0,.28.06.55.08.81s0,.5,0,.74c0,.46,0,1-.11,1.71l-3.33,1.93v2.3l2.62-1.52A10,10,0,0,1,123.81,72.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.64,120.48l-.35-.24a4.56,4.56,0,0,0,.45-1.89c0-.68-.24-.9-.49-.75s-.43.65-.55,1.55c-.15,1.1-.35,1.88-.93,2.22s-.94-.18-.94-1.17a5.15,5.15,0,0,1,.45-2.07l.36.21a4.19,4.19,0,0,0-.4,1.65c0,.55.23.81.49.66s.4-.66.53-1.55c.15-1.07.36-1.88.94-2.21s.95.08.95,1.25A5.59,5.59,0,0,1,53.64,120.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.89,113.53l3.21-1.85v.72l-1.42.82v2.71l1.42-.82v.73l-3.21,1.85V117l1.35-.78v-2.7l-1.35.78Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.49,112.08c-.9.52-1.66-.22-1.66-1.61A4.46,4.46,0,0,1,52.49,107c.91-.52,1.67.2,1.67,1.59A4.46,4.46,0,0,1,52.49,112.08Zm0-4.39a3.21,3.21,0,0,0-1.22,2.53c0,1,.56,1.5,1.22,1.11a3.22,3.22,0,0,0,1.23-2.53C53.72,107.81,53.16,107.3,52.49,107.69Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.89,107.34v-2.08a2.91,2.91,0,0,1,1-2.44c.61-.36,1,.18,1,1.23v1.35l1.12-.64v.73Zm1.65-2.94c0-.71-.23-1.06-.6-.84a1.79,1.79,0,0,0-.61,1.55v1.25l1.21-.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.49,100.59c-.9.53-1.66-.22-1.66-1.61a4.46,4.46,0,0,1,1.66-3.52c.91-.52,1.67.21,1.67,1.6A4.46,4.46,0,0,1,52.49,100.59Zm0-4.39a3.22,3.22,0,0,0-1.22,2.53c0,1,.56,1.5,1.22,1.11a3.18,3.18,0,0,0,1.23-2.53C53.72,96.32,53.16,95.82,52.49,96.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.89,95.77V95l2.44-4.25-2.44,1.4v-.72l3.21-1.86v.73l-2.44,4.25,2.44-1.4v.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.66,85.76l.44-.25v3.36l-3.21,1.86V90l2.77-1.6Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.89,87v-.73l3.21-1.86v.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.89,85.41v-.72l2.44-4.26-2.44,1.41v-.73l3.21-1.86V80l-2.44,4.26,2.44-1.41v.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.33,79.32l.91-.53V76.16l.44-.25v2.62l1-.56V75.06l.44-.25v3.64l-3.21,1.86V76.66l.44-.25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.61,96.14a9.26,9.26,0,0,1-.12-1.49A11.76,11.76,0,0,1,62.61,93l5.64-3.26.24.43L66.6,96.34a1.25,1.25,0,0,1,1.49.42,3.89,3.89,0,0,1,.54,2.31,9.71,9.71,0,0,1-.3,2.44,9.53,9.53,0,0,1-.83,2.13,8.46,8.46,0,0,1-1.24,1.73,7.19,7.19,0,0,1-1.53,1.22L64,107a4.06,4.06,0,0,1-.63.24c-.21.06-.42.1-.63.14a3.63,3.63,0,0,1-.67,0,11.42,11.42,0,0,1,.19-1.66,16,16,0,0,1,.4-1.62,7.56,7.56,0,0,0,1-.12,3.61,3.61,0,0,0,1-.4,3.54,3.54,0,0,0,1.25-1.21,3.43,3.43,0,0,0,.46-1.77,1.64,1.64,0,0,0-.12-.69.76.76,0,0,0-.32-.36.79.79,0,0,0-.46-.07,1.58,1.58,0,0,0-.53.2c-.14.08-.29.18-.45.29a5.6,5.6,0,0,0-.54.46l-.29-.5,1.64-5.33Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.51,87.13a2.2,2.2,0,0,1,1.55-.36,1.75,1.75,0,0,1,1.08.85,5,5,0,0,1,.63,1.84A16.12,16.12,0,0,1,76,92.1,19,19,0,0,1,75.76,95a13.58,13.58,0,0,1-.65,2.55A8.37,8.37,0,0,1,74,99.59,5.1,5.1,0,0,1,72.46,101a2.22,2.22,0,0,1-1.55.38,1.74,1.74,0,0,1-1.08-.83,5.37,5.37,0,0,1-.62-1.82A14.52,14.52,0,0,1,69,96.13a19.33,19.33,0,0,1,.21-2.88,14.75,14.75,0,0,1,.64-2.58,8.67,8.67,0,0,1,1.09-2.1A5.1,5.1,0,0,1,72.51,87.13Zm0,3.12a2.26,2.26,0,0,0-.82,1.44,12.51,12.51,0,0,0-.3,3.07,8.52,8.52,0,0,0,.3,2.71c.2.52.48.69.82.49a2.26,2.26,0,0,0,.81-1.43,13,13,0,0,0,.29-3,9.05,9.05,0,0,0-.29-2.73C73.09,90.22,72.82,90.06,72.48,90.25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.07,85.79a5.72,5.72,0,0,1,.09-1,4.42,4.42,0,0,1,.27-1,3.41,3.41,0,0,1,.46-.84,2.15,2.15,0,0,1,.67-.61,1,1,0,0,1,.66-.16.76.76,0,0,1,.47.3,1.82,1.82,0,0,1,.27.66,4.32,4.32,0,0,1,.09.91,5.81,5.81,0,0,1-.09,1,5.25,5.25,0,0,1-.27,1,3.8,3.8,0,0,1-.47.84,2.08,2.08,0,0,1-.66.6,1,1,0,0,1-.67.17.69.69,0,0,1-.46-.31,1.6,1.6,0,0,1-.27-.66A4.16,4.16,0,0,1,76.07,85.79ZM78,84.68a2.7,2.7,0,0,0-.1-.82c-.07-.17-.18-.22-.33-.13a.82.82,0,0,0-.33.51,4.14,4.14,0,0,0-.1.93,2.74,2.74,0,0,0,.1.82c.07.19.18.23.33.15a.81.81,0,0,0,.33-.53A4.14,4.14,0,0,0,78,84.68Zm.76,5.59-.28.22a2.38,2.38,0,0,1-.3.18l-.26.15a1.73,1.73,0,0,1-.35.13l3.21-10.32a3.15,3.15,0,0,1,.29-.22l.29-.19.26-.14a2,2,0,0,1,.35-.14Zm1.72-3.4a5.83,5.83,0,0,1,.09-1,5.25,5.25,0,0,1,.27-1A3.43,3.43,0,0,1,81.3,84a2.21,2.21,0,0,1,.66-.6,1,1,0,0,1,.67-.17.75.75,0,0,1,.46.31,1.67,1.67,0,0,1,.28.66,4.16,4.16,0,0,1,.09.9,5.72,5.72,0,0,1-.09,1,4.44,4.44,0,0,1-.28,1,3.63,3.63,0,0,1-.46.85,2.25,2.25,0,0,1-.67.6,1,1,0,0,1-.66.17.75.75,0,0,1-.47-.31,1.82,1.82,0,0,1-.27-.66A4.29,4.29,0,0,1,80.47,86.87Zm1.92-1.11a2.41,2.41,0,0,0-.1-.82c-.07-.18-.17-.22-.33-.13a.76.76,0,0,0-.32.51,3.53,3.53,0,0,0-.1.93,2.49,2.49,0,0,0,.1.82c.07.18.17.23.32.14a.75.75,0,0,0,.33-.52A3.63,3.63,0,0,0,82.39,85.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.69,98a1,1,0,0,1-.66.18.68.68,0,0,1-.46-.3,1.84,1.84,0,0,1-.27-.69,5.26,5.26,0,0,1-.09-1A7.08,7.08,0,0,1,76.3,95a5.15,5.15,0,0,1,.27-1,3.41,3.41,0,0,1,.46-.84,2.16,2.16,0,0,1,.66-.58,1,1,0,0,1,.66-.18.7.7,0,0,1,.46.3,1.79,1.79,0,0,1,.26.71,5.26,5.26,0,0,1,.09,1,7,7,0,0,1-.09,1.13,4.44,4.44,0,0,1-.26,1,3.49,3.49,0,0,1-.46.83A2.26,2.26,0,0,1,77.69,98Zm0-.88c.49-.29.73-1,.73-2.23a3,3,0,0,0-.18-1.25c-.12-.23-.3-.28-.55-.13-.49.28-.74,1-.74,2.23S77.2,97.38,77.69,97.1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5,91.62l1.92-1.11a2.9,2.9,0,0,1,0,.43,3.71,3.71,0,0,1,0,.47l-1.23.71v1.23l1-.56a3.11,3.11,0,0,1,0,.43,3.87,3.87,0,0,1,0,.48l-1,.56v2.19a2.72,2.72,0,0,1-.34.24,2.14,2.14,0,0,1-.35.16Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.66,90.37l1.92-1.11a3,3,0,0,1,0,.43,3.59,3.59,0,0,1,0,.47l-1.23.72v1.23l1-.57a3.25,3.25,0,0,1,0,.44,3.83,3.83,0,0,1,0,.47l-1,.57v2.19a2.72,2.72,0,0,1-.34.24,3.52,3.52,0,0,1-.35.16Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--x--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.54,14.48l-2.21-1.28h0l0,0h0a3.75,3.75,0,0,0-3.76.38,11.81,11.81,0,0,0-5.34,9.26,3.74,3.74,0,0,0,1.56,3.45h0l2,1.15.47-.79a5.38,5.38,0,0,0,1.54-.59,11.82,11.82,0,0,0,5.34-9.26,5.62,5.62,0,0,0-.17-1.36Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.54,14.48l-2.21-1.28h0l0,0h0a3.75,3.75,0,0,0-3.76.38,11.81,11.81,0,0,0-5.34,9.26,3.74,3.74,0,0,0,1.56,3.45h0l2,1.15.47-.79a5.38,5.38,0,0,0,1.54-.59,11.82,11.82,0,0,0,5.34-9.26,5.62,5.62,0,0,0-.17-1.36Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.41,21a8.63,8.63,0,0,0-.2,1.8,3.74,3.74,0,0,0,1.56,3.45h0l2,1.15.47-.79a5.38,5.38,0,0,0,1.54-.59A8.52,8.52,0,0,0,135.25,25Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.66,14.78A11.81,11.81,0,0,0,130.31,24c0,3.41,2.39,4.79,5.35,3.08A11.79,11.79,0,0,0,141,17.87C141,14.46,138.61,13.08,135.66,14.78Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.66,14.78A11.81,11.81,0,0,0,130.31,24c0,3.41,2.39,4.79,5.35,3.08A11.79,11.79,0,0,0,141,17.87C141,14.46,138.61,13.08,135.66,14.78Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.44,20.76l1.45-3.06a.83.83,0,0,0-.06-1c-.28-.23-.56-.11-.73.25L135.66,20l-1.45-1.39c-.17-.16-.44,0-.61.36a.89.89,0,0,0,0,1L135,21.31l-1.44,3.06c-.18.36-.25.78,0,1a.49.49,0,0,0,.74-.22l1.45-3.06,1.27,1.23a.23.23,0,0,0,.31,0,.85.85,0,0,0,.31-.37.93.93,0,0,0,0-1Z",
    style: {
      fill: "#fafafa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--ad-3--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--ad--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.66,93.74a1.47,1.47,0,0,1,.14-.28h0A2.44,2.44,0,0,0,297.66,93.74Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,43.08a.61.61,0,0,0-.59-.47,1,1,0,0,0-.51.16L298.61,92.6a2.32,2.32,0,0,0-.81.86l-3.44-2a2.43,2.43,0,0,1,.78-.81l86.33-49.84a2.55,2.55,0,0,1,2.3,0l1.16.65A2.48,2.48,0,0,1,386,43.08Z",
    style: {
      fill: "#37474f",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.61,195.18a2.62,2.62,0,0,1-2.3,0l-1.16-.71a2.51,2.51,0,0,1-1.16-2V92.64a2.4,2.4,0,0,1,.37-1.17l3.44,2a2.34,2.34,0,0,0-.34,1.13v99.93C297.46,195.19,297.94,195.58,298.61,195.18Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.85
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.45,42.61a1,1,0,0,0-.52.16L298.61,92.6a2.56,2.56,0,0,0-1.15,2v99.93c0,.52.26.82.64.82a1,1,0,0,0,.51-.16l86.32-49.83a2.54,2.54,0,0,0,1.15-2V43.43c0-.52-.26-.82-.63-.82Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M385.27,43.51v99.85a1.74,1.74,0,0,1-.74,1.28l-86.25,49.8V94.59A1.78,1.78,0,0,1,299,93.3l86.25-49.79m.18-.9a1,1,0,0,0-.52.16L298.61,92.6a2.56,2.56,0,0,0-1.15,2v99.93c0,.52.26.82.64.82a1,1,0,0,0,.51-.16l86.32-49.83a2.54,2.54,0,0,0,1.15-2V43.43c0-.52-.26-.82-.63-.82Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-88",
    d: "M376.55,138.21v-84c0-1.49-1.05-2.1-2.34-1.35L304.65,93a5.14,5.14,0,0,0-2.34,4v84c0,1.5,1,2.1,2.34,1.35l69.56-40.16A5.17,5.17,0,0,0,376.55,138.21Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Video--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.89,139.57v-84c0-1.49-1-2.09-2.33-1.35L307,94.33a5.17,5.17,0,0,0-2.33,4v84.05c0,1.49,1,2.09,2.33,1.35l69.57-40.16A5.17,5.17,0,0,0,378.89,139.57Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.89,139.57v-84c0-1.49-1-2.09-2.33-1.35L307,94.33a5.17,5.17,0,0,0-2.33,4v84.05c0,1.49,1,2.09,2.33,1.35l69.57-40.16A5.17,5.17,0,0,0,378.89,139.57Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.69,136.71V110.14a5.21,5.21,0,0,1,4.94-5.16l24.27-1c2.72-.12,3.45,1.43,1.63,3.46L333,138C331.17,140,329.69,139.44,329.69,136.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bar--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316,170.55l55.87-32.15c.81-.47,1.47-.14,1.47.74a3.19,3.19,0,0,1-1.47,2.46L316,173.74c-.82.47-1.48.14-1.48-.74A3.14,3.14,0,0,1,316,170.55Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,170.55l43.49-25c.82-.47,1.48-.14,1.48.75a3.16,3.16,0,0,1-1.48,2.45l-43.49,25c-.82.47-1.48.14-1.48-.74A3.14,3.14,0,0,1,316,170.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.29,174.12v3.13a.49.49,0,0,1-.23.39l-.6.35c-.12.07-.22,0-.22-.13v-3.13a.49.49,0,0,1,.22-.39l.61-.35C309.19,173.92,309.29,174,309.29,174.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.4,172.9V176a.48.48,0,0,1-.23.39l-.6.35c-.13.07-.23,0-.23-.13v-3.13a.49.49,0,0,1,.23-.39l.6-.35C311.3,172.7,311.4,172.76,311.4,172.9Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,77.81a2.05,2.05,0,0,1,.94-.32,1.13,1.13,0,0,1,.68.16,1.11,1.11,0,0,1,.41.49,1.87,1.87,0,0,1,.15.66.46.46,0,0,1-.06.28.45.45,0,0,1-.15.18l-.56.32a.24.24,0,0,1-.2,0,.31.31,0,0,1-.12-.15.69.69,0,0,0-.37-.32c-.16-.06-.4,0-.72.19a3.27,3.27,0,0,0-.39.29,3.09,3.09,0,0,0-.33.39,1.78,1.78,0,0,0-.21.44,1.21,1.21,0,0,0-.08.46.86.86,0,0,0,.07.41.32.32,0,0,0,.26.16,1.34,1.34,0,0,0,.47,0l.73-.17a3.31,3.31,0,0,1,.82-.1,1,1,0,0,1,.57.19,1.1,1.1,0,0,1,.33.5,2.81,2.81,0,0,1,.1.83,4,4,0,0,1-.16,1.12,4.35,4.35,0,0,1-.45,1.07,5.4,5.4,0,0,1-.72.95,4.42,4.42,0,0,1-1,.75,2.66,2.66,0,0,1-.85.33,1.31,1.31,0,0,1-.72-.07,1,1,0,0,1-.5-.46,1.86,1.86,0,0,1-.22-.85.67.67,0,0,1,.06-.28.57.57,0,0,1,.16-.18l.55-.32c.1,0,.16-.07.21,0a.24.24,0,0,1,.12.15,1.49,1.49,0,0,0,.14.24.42.42,0,0,0,.21.16.77.77,0,0,0,.34,0,1.49,1.49,0,0,0,.5-.21,3.55,3.55,0,0,0,.47-.32,2.46,2.46,0,0,0,.38-.41,2.08,2.08,0,0,0,.28-.47,1.62,1.62,0,0,0,.1-.54.51.51,0,0,0-.11-.37.45.45,0,0,0-.34-.1,2.78,2.78,0,0,0-.56.09c-.22,0-.48.11-.77.16a2.23,2.23,0,0,1-.7.06.81.81,0,0,1-.49-.21,1.08,1.08,0,0,1-.29-.53,3.16,3.16,0,0,1-.1-.89,4.25,4.25,0,0,1,.16-1.11,4.86,4.86,0,0,1,.44-1.05,4.53,4.53,0,0,1,.66-.9A3.65,3.65,0,0,1,345,77.81Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.21,81.64v2.1a.66.66,0,0,1-.06.27.63.63,0,0,1-.15.19l-.61.34c-.06,0-.11,0-.15,0a.25.25,0,0,1-.06-.19v-8a.66.66,0,0,1,.06-.27.42.42,0,0,1,.15-.19l.61-.35a.12.12,0,0,1,.15,0,.3.3,0,0,1,.06.2v3.86l1.33-2.42.12-.21a.47.47,0,0,1,.19-.18l.81-.47a.11.11,0,0,1,.14,0,.26.26,0,0,1,.05.17.53.53,0,0,1,0,.13.49.49,0,0,1-.08.17l-1.85,3.37,2,1.83a.24.24,0,0,1,.06.09.25.25,0,0,1,0,.1.53.53,0,0,1-.06.24.31.31,0,0,1-.13.16l-.77.45a.28.28,0,0,1-.21,0l-.12-.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.51,72.9a.12.12,0,0,1,.15,0,.28.28,0,0,1,.06.2v1a.66.66,0,0,1-.06.27.63.63,0,0,1-.15.19l-.69.39a.12.12,0,0,1-.15,0,.28.28,0,0,1-.06-.2v-1a.66.66,0,0,1,.06-.27.42.42,0,0,1,.15-.19Zm.17,8.26a.66.66,0,0,1-.06.27.63.63,0,0,1-.15.19l-.61.34c-.06,0-.11,0-.15,0a.25.25,0,0,1-.06-.19V76.05a.66.66,0,0,1,.06-.27.35.35,0,0,1,.15-.18l.61-.35a.12.12,0,0,1,.15,0,.28.28,0,0,1,.06.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357,79.69a1.2,1.2,0,0,1-.44.18,1,1,0,0,1-.34,0,.63.63,0,0,1-.25-.1.61.61,0,0,1-.17-.14v2.61a.66.66,0,0,1-.06.27.4.4,0,0,1-.15.18l-.61.35a.12.12,0,0,1-.15,0,.28.28,0,0,1-.06-.2v-8a.66.66,0,0,1,.06-.27.35.35,0,0,1,.15-.18l.61-.35a.12.12,0,0,1,.15,0,.28.28,0,0,1,.06.2v.28a3.57,3.57,0,0,1,.17-.34,3.52,3.52,0,0,1,.25-.38,3,3,0,0,1,.34-.38,2,2,0,0,1,.44-.33,1.17,1.17,0,0,1,.72-.18.89.89,0,0,1,.55.32,2.06,2.06,0,0,1,.36.71,4.89,4.89,0,0,1,.15,1v.86a8.15,8.15,0,0,1-.15,1.17,6.38,6.38,0,0,1-.36,1.12,4.29,4.29,0,0,1-.55,1A2.32,2.32,0,0,1,357,79.69Zm.74-3.39a4,4,0,0,0,0-.69c0-.51-.14-.83-.32-1a.59.59,0,0,0-.66,0,1.68,1.68,0,0,0-.65.73,2.94,2.94,0,0,0-.31,1.19c0,.13,0,.29,0,.48s0,.34,0,.45a1.13,1.13,0,0,0,.31.83.54.54,0,0,0,.65,0,1.76,1.76,0,0,0,.66-.73A3.21,3.21,0,0,0,357.75,76.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364,67c.09,0,.15,0,.19,0a.58.58,0,0,1,.12.25l1.94,6.61a.19.19,0,0,1,0,.08.66.66,0,0,1-.06.27.42.42,0,0,1-.15.19l-.57.33c-.11.06-.19.07-.23,0a.28.28,0,0,1-.08-.15l-.35-1.16-2.51,1.45L362,76.41a2,2,0,0,1-.09.25.54.54,0,0,1-.22.23l-.57.33a.12.12,0,0,1-.16,0,.25.25,0,0,1-.06-.19.22.22,0,0,1,0-.09l1.95-8.87a1.85,1.85,0,0,1,.11-.37.41.41,0,0,1,.19-.22Zm.44,5.12-.87-3-.88,4Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.45,66.48a1.46,1.46,0,0,1,.44-.19,1,1,0,0,1,.34,0,.63.63,0,0,1,.25.1.61.61,0,0,1,.17.14V63.91a.66.66,0,0,1,.06-.27.4.4,0,0,1,.15-.18l.61-.35a.11.11,0,0,1,.15,0,.25.25,0,0,1,.06.19v8a.63.63,0,0,1-.06.27.38.38,0,0,1-.15.19l-.61.35a.12.12,0,0,1-.15,0,.28.28,0,0,1-.06-.2v-.28a3.57,3.57,0,0,1-.17.34,3.52,3.52,0,0,1-.25.38,2.69,2.69,0,0,1-.78.71,1.17,1.17,0,0,1-.72.18.91.91,0,0,1-.55-.33,1.89,1.89,0,0,1-.36-.71,3.75,3.75,0,0,1-.15-1v-.85a6.05,6.05,0,0,1,.15-1.17,6.78,6.78,0,0,1,.36-1.13,4.22,4.22,0,0,1,.55-1A2.32,2.32,0,0,1,368.45,66.48Zm-.74,3.39a3.86,3.86,0,0,0,0,.68c0,.51.14.83.32,1a.57.57,0,0,0,.66,0,1.68,1.68,0,0,0,.65-.73,3,3,0,0,0,.31-1.2c0-.12,0-.28,0-.47s0-.34,0-.46a1.1,1.1,0,0,0-.31-.82.52.52,0,0,0-.65,0,1.76,1.76,0,0,0-.66.73A3.17,3.17,0,0,0,367.71,69.87Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374,67.92a.25.25,0,0,0-.06-.19s-.1,0-.19,0a2.54,2.54,0,0,0-.37.07l-.59.14a1.18,1.18,0,0,1-.58,0,.63.63,0,0,1-.37-.21.93.93,0,0,1-.19-.45,3,3,0,0,1-.06-.64,3.26,3.26,0,0,1,.11-.79,4.35,4.35,0,0,1,.32-.82,4.12,4.12,0,0,1,.52-.74,2.69,2.69,0,0,1,.69-.57,2,2,0,0,1,.7-.27.84.84,0,0,1,.51.06.68.68,0,0,1,.34.31,1.2,1.2,0,0,1,.13.5.45.45,0,0,1-.06.27.38.38,0,0,1-.15.19l-.61.35c-.08,0-.14.06-.18,0l-.13-.08a.36.36,0,0,0-.19,0,.88.88,0,0,0-.36.14,1.57,1.57,0,0,0-.42.35.78.78,0,0,0-.19.5.34.34,0,0,0,.05.2.19.19,0,0,0,.16.07,1.77,1.77,0,0,0,.35,0l.57-.14q.71-.18,1,.15a1.54,1.54,0,0,1,.29,1.06,2.86,2.86,0,0,1-.12.79,3.39,3.39,0,0,1-.34.82,3.72,3.72,0,0,1-.56.76,3.25,3.25,0,0,1-.74.6,1.9,1.9,0,0,1-.75.27.86.86,0,0,1-.54-.08.77.77,0,0,1-.34-.35,1.33,1.33,0,0,1-.13-.53.66.66,0,0,1,.06-.27.41.41,0,0,1,.16-.18l.61-.36c.08,0,.14-.05.18,0l.13.12a.33.33,0,0,0,.21.08,1,1,0,0,0,.41-.15l.25-.17a2.29,2.29,0,0,0,.23-.21,1.44,1.44,0,0,0,.18-.25A.54.54,0,0,0,374,67.92Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--x--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.86,40.17,387.78,39h0a3.56,3.56,0,0,0-3.53.36,11.14,11.14,0,0,0-5,8.72,3.55,3.55,0,0,0,1.47,3.26h0l1.9,1.09.44-.75a4.91,4.91,0,0,0,1.44-.56,11.13,11.13,0,0,0,5-8.72,5.6,5.6,0,0,0-.16-1.28Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.86,40.17,387.78,39h0a3.56,3.56,0,0,0-3.53.36,11.14,11.14,0,0,0-5,8.72,3.55,3.55,0,0,0,1.47,3.26h0l1.9,1.09.44-.75a4.91,4.91,0,0,0,1.44-.56,11.13,11.13,0,0,0,5-8.72,5.6,5.6,0,0,0-.16-1.28Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.37,46.34a8.26,8.26,0,0,0-.19,1.69,3.55,3.55,0,0,0,1.47,3.26h0l1.9,1.09.44-.75a4.91,4.91,0,0,0,1.44-.56,8.11,8.11,0,0,0,1.38-1Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.2,40.45a11.14,11.14,0,0,0-5,8.72c0,3.21,2.26,4.51,5,2.91a11.13,11.13,0,0,0,5-8.72C391.23,40.15,389,38.85,386.2,40.45Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.2,40.45a11.14,11.14,0,0,0-5,8.72c0,3.21,2.26,4.51,5,2.91a11.13,11.13,0,0,0,5-8.72C391.23,40.15,389,38.85,386.2,40.45Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.94,46.08l1.36-2.88a.77.77,0,0,0-.06-.94c-.26-.22-.52-.11-.68.23l-1.36,2.88-1.36-1.31c-.16-.15-.42,0-.58.34a.87.87,0,0,0,0,.89l1.35,1.31-1.35,2.88c-.16.34-.23.74,0,.92a.46.46,0,0,0,.7-.21l1.36-2.88,1.2,1.16a.22.22,0,0,0,.29,0,.85.85,0,0,0,.29-.36.87.87,0,0,0,0-.89Z",
    style: {
      fill: "#fafafa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--ad-2--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--ad--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.65,236.51a2.24,2.24,0,0,1,.13-.27h0A2.29,2.29,0,0,0,90.65,236.51Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179,185.85a.61.61,0,0,0-.59-.47,1.06,1.06,0,0,0-.52.16L91.6,235.38a2.43,2.43,0,0,0-.82.86l-3.43-2a2.37,2.37,0,0,1,.78-.82l86.32-49.83a2.57,2.57,0,0,1,2.31,0l1.16.65A2.49,2.49,0,0,1,179,185.85Z",
    style: {
      fill: "#37474f",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.6,409.63a2.62,2.62,0,0,1-2.3,0l-1.16-.71A2.5,2.5,0,0,1,87,407V235.41a2.4,2.4,0,0,1,.37-1.17l3.44,2a2.28,2.28,0,0,0-.34,1.13V409C90.45,409.64,90.93,410,91.6,409.63Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.85
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.44,185.38a1.15,1.15,0,0,0-.52.16L91.6,235.38a2.55,2.55,0,0,0-1.15,2V409c0,.52.26.82.64.82a1,1,0,0,0,.51-.16l86.32-49.83a2.54,2.54,0,0,0,1.15-2V186.2c0-.51-.26-.82-.63-.82Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M178.26,186.28V357.81a1.76,1.76,0,0,1-.74,1.29L91.26,408.89V237.37a1.74,1.74,0,0,1,.75-1.29l86.25-49.8m.18-.9a1.15,1.15,0,0,0-.52.16L91.6,235.38a2.55,2.55,0,0,0-1.15,2V409c0,.52.26.82.64.82a1,1,0,0,0,.51-.16l86.32-49.83a2.54,2.54,0,0,0,1.15-2V186.2c0-.51-.26-.82-.63-.82Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-88",
    d: "M169.54,352.66V196.94c0-1.49-1-2.09-2.33-1.35L97.63,235.75a5.17,5.17,0,0,0-2.33,4.06V395.53c0,1.49,1,2.09,2.33,1.35l69.57-40.17A5.15,5.15,0,0,0,169.54,352.66Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--ad--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.88,354V198.3c0-1.49-1-2.1-2.34-1.35L100,237.11a5.17,5.17,0,0,0-2.34,4V396.88c0,1.49,1,2.1,2.34,1.35l69.57-40.16A5.17,5.17,0,0,0,171.88,354Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.88,354V198.3c0-1.49-1-2.1-2.34-1.35L100,237.11a5.17,5.17,0,0,0-2.34,4V396.88c0,1.49,1,2.1,2.34,1.35l69.57-40.16A5.17,5.17,0,0,0,171.88,354Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--text--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.64,396.88c0,1.49,1,2.1,2.34,1.35l69.57-40.16a5.17,5.17,0,0,0,2.33-4.05v-73.2L97.64,352.37Z",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.86,318.78c.09-.1.18-.12.25-.08a.35.35,0,0,1,.1.3l-.08,2.29a1.26,1.26,0,0,1-.12.51,1.17,1.17,0,0,1-.26.42l-4,3.8-.09,3,3.71-3.55c.1-.09.18-.12.25-.07s.1.15.09.31l-.07,2.28a1.51,1.51,0,0,1-.11.51,1.38,1.38,0,0,1-.27.42l-3.71,3.55-.15,4.65a1.42,1.42,0,0,1-.11.5,1.07,1.07,0,0,1-.26.41l-1.74,1.67c-.1.09-.18.12-.25.07s-.11-.14-.1-.3l.44-13.91a1.42,1.42,0,0,1,.11-.51,1.32,1.32,0,0,1,.26-.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.54,331.78c-.09.1-.18.12-.25.07s-.1-.14-.1-.3l.45-13.91a1.47,1.47,0,0,1,.11-.51,1.16,1.16,0,0,1,.26-.41l1.74-1.66c.1-.1.18-.12.25-.08a.35.35,0,0,1,.1.3l-.44,13.92a1.45,1.45,0,0,1-.12.5,1.06,1.06,0,0,1-.25.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.84,321.94c-.15.14-.27.2-.35.16a.8.8,0,0,1-.21-.15l-3.06-4.17-.23,7.28a1.42,1.42,0,0,1-.11.5,1.38,1.38,0,0,1-.26.42l-1.74,1.66c-.1.1-.19.12-.25.07s-.11-.14-.11-.3L118,313.5a1.47,1.47,0,0,1,.11-.51,1.16,1.16,0,0,1,.26-.41l1.12-1.07q.23-.21.36-.15a.4.4,0,0,1,.17.13l3.09,4.18.23-7.28a1.42,1.42,0,0,1,.11-.5,1.21,1.21,0,0,1,.26-.41l1.74-1.67c.1-.09.19-.12.25-.07a.35.35,0,0,1,.11.3L125.33,320a1.42,1.42,0,0,1-.11.5,1.07,1.07,0,0,1-.26.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.69,298.87c.18-.17.31-.22.4-.15a.65.65,0,0,1,.18.29l2.47,10.79a1,1,0,0,1-.25,1l-1.61,1.54c-.18.17-.3.23-.37.18a.34.34,0,0,1-.14-.22l-.32-1.42-3.55,3.39-.42,2.13a2,2,0,0,1-.15.49,1.45,1.45,0,0,1-.38.54l-1.86,1.78c-.13.12-.21.13-.25,0a1.15,1.15,0,0,1,0-.58l3.33-16.34a4.08,4.08,0,0,1,.21-.66,1.64,1.64,0,0,1,.41-.62Zm-2.39,11.41,2.16-2.06-.92-4.14Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.47,299.85c.09-.09.18-.12.24-.07s.1.15.1.31l-.08,2.29a1.45,1.45,0,0,1-.12.5,1.06,1.06,0,0,1-.25.41l-6.17,5.9c-.1.09-.18.11-.25.07a.35.35,0,0,1-.1-.3l.45-13.92a1.42,1.42,0,0,1,.11-.5,1.2,1.2,0,0,1,.25-.41l1.75-1.67c.1-.09.18-.12.25-.07s.1.14.1.3l-.35,11Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.41,339.51a17.11,17.11,0,0,1,.34-2.52,13.28,13.28,0,0,1,.76-2.52,13.61,13.61,0,0,1,1.26-2.42,12.15,12.15,0,0,1,1.83-2.2,5,5,0,0,1,1.64-1.12,1.78,1.78,0,0,1,1.3,0,1.72,1.72,0,0,1,.87,1,5.06,5.06,0,0,1,.31,1.9c0,.6,0,1.24,0,1.91s-.05,1.32-.09,1.93a19,19,0,0,1-.35,2.53,15.71,15.71,0,0,1-.76,2.54,14.57,14.57,0,0,1-1.26,2.41,12.57,12.57,0,0,1-1.84,2.2,5.12,5.12,0,0,1-1.63,1.12,1.73,1.73,0,0,1-1.3,0,1.79,1.79,0,0,1-.86-1,4.87,4.87,0,0,1-.31-1.9c0-.57,0-1.19,0-1.87S122.37,340.15,122.41,339.51Zm5.73-1.86c0-.26,0-.56.05-.88s0-.65,0-1l0-1c0-.3,0-.56,0-.8a3.38,3.38,0,0,0-.11-.85.87.87,0,0,0-.3-.48.57.57,0,0,0-.5,0,2.05,2.05,0,0,0-.71.49,5.12,5.12,0,0,0-.72.88,7.46,7.46,0,0,0-.53,1,7.66,7.66,0,0,0-.51,2.22c0,.25,0,.54-.06.86s0,.64,0,1,0,.65,0,1,0,.58,0,.83a1.84,1.84,0,0,0,.41,1.34c.25.22.65.07,1.2-.46a5.07,5.07,0,0,0,1.26-1.89A8.31,8.31,0,0,0,128.14,337.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.9,318.31c.1-.1.18-.12.25-.08a.35.35,0,0,1,.1.3l-.08,2.29a1.26,1.26,0,0,1-.12.51,1,1,0,0,1-.26.42l-4,3.81-.09,2.94,3.71-3.55c.1-.09.19-.11.25-.07s.1.15.09.31l-.06,2.28a1.34,1.34,0,0,1-.12.51,1.45,1.45,0,0,1-.26.42L134.61,332l-.15,4.65a1.42,1.42,0,0,1-.11.5,1.2,1.2,0,0,1-.25.41l-1.75,1.67c-.1.1-.18.12-.25.07s-.1-.14-.1-.3l.44-13.91a1.5,1.5,0,0,1,.12-.51,1.15,1.15,0,0,1,.25-.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.12,310.45c.1-.1.19-.12.26-.07s.1.14.1.3L147.4,313a1.26,1.26,0,0,1-.12.51,1.32,1.32,0,0,1-.26.42l-4,3.81-.09,2.95,3.72-3.56c.1-.09.18-.11.25-.07s.1.15.09.31l-.07,2.28a1.3,1.3,0,0,1-.12.51,1.12,1.12,0,0,1-.26.42l-3.71,3.55-.15,4.65a1.37,1.37,0,0,1-.11.5,1.26,1.26,0,0,1-.26.42l-1.74,1.66c-.1.1-.19.12-.25.07s-.11-.14-.11-.3l.45-13.91a1.37,1.37,0,0,1,.11-.5,1.12,1.12,0,0,1,.26-.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.23,314c.1-.1.18-.12.25-.07a.39.39,0,0,1,.09.31l-.08,2.29a1.42,1.42,0,0,1-.11.5,1.07,1.07,0,0,1-.26.41l-6.31,6c-.1.1-.18.12-.25.08a.35.35,0,0,1-.1-.3l.44-13.92a1.45,1.45,0,0,1,.12-.5,1.06,1.06,0,0,1,.25-.41l6.21-5.94c.1-.09.18-.11.25-.07a.35.35,0,0,1,.1.3l-.08,2.29a1.26,1.26,0,0,1-.12.51,1,1,0,0,1-.26.42l-4.1,3.92-.08,2.32,3.82-3.64c.09-.09.18-.11.25-.07a.38.38,0,0,1,.1.3l-.08,2.29a1.26,1.26,0,0,1-.12.51,1.32,1.32,0,0,1-.26.42l-3.81,3.64L151,318Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.31,296.89a6.16,6.16,0,0,1,1.47-1.08,1.77,1.77,0,0,1,1.22-.21,1.28,1.28,0,0,1,.81.79,4.76,4.76,0,0,1,.25,1.91,10.25,10.25,0,0,1-.5,3,13.26,13.26,0,0,1-1.23,2.66l1.5,3.53a1.25,1.25,0,0,1,0,.21,1.6,1.6,0,0,1-.09.41,1,1,0,0,1-.21.34l-1.68,1.6c-.18.17-.3.23-.38.17a.51.51,0,0,1-.17-.21l-1.33-3.2-1.36,1.3-.15,4.61a1.42,1.42,0,0,1-.11.51,1.31,1.31,0,0,1-.25.41l-1.75,1.67c-.1.09-.18.11-.25.07a.35.35,0,0,1-.1-.3l.45-13.92a1.23,1.23,0,0,1,.11-.5,1.06,1.06,0,0,1,.25-.41Zm-1.57,7.83,1.5-1.44a4.57,4.57,0,0,0,.94-1.23,3.54,3.54,0,0,0,.41-1.6c0-.59-.1-.89-.34-.88a1.57,1.57,0,0,0-.91.53l-1.51,1.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.7,280.19c-.18.17-.33.21-.46.13s-.19-.27-.19-.55l.14-4L108,283.56c-.18.18-.33.22-.46.14s-.18-.28-.16-.58l.12-4.18a7.49,7.49,0,0,1,.37-2L115.64,255a6.47,6.47,0,0,1,.43-1,3,3,0,0,1,.5-.61l4.19-4c.18-.17.33-.22.46-.13s.19.26.19.55l-.49,15.21,1.86-1.78q.27-.25.45-.12a.66.66,0,0,1,.17.57l-.11,4.18a3,3,0,0,1-.24,1,2,2,0,0,1-.47.76l-1.86,1.78-.13,4.05a2.81,2.81,0,0,1-.21.92,2,2,0,0,1-.47.76Zm-.19-10.92.23-7.29L113,272.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.92,237.41a8.76,8.76,0,0,1,3.09-2.1,2.49,2.49,0,0,1,2.21.16,3.58,3.58,0,0,1,1.33,2,12.22,12.22,0,0,1,.45,3.55c0,1.1,0,2.28-.06,3.52s-.09,2.42-.17,3.53c-.1,1.48-.28,3-.53,4.49a23.85,23.85,0,0,1-1.2,4.47,24.15,24.15,0,0,1-2.15,4.32,21.67,21.67,0,0,1-3.37,4.07,8.18,8.18,0,0,1-3,2,2.56,2.56,0,0,1-2.21-.16,3.69,3.69,0,0,1-1.38-2,10.88,10.88,0,0,1-.49-3.51c0-1,0-2.19.06-3.44s.1-2.45.17-3.62c.1-1.48.28-3,.53-4.48a25.11,25.11,0,0,1,1.19-4.46,23,23,0,0,1,2.14-4.31A21.67,21.67,0,0,1,132.92,237.41Zm2.33,14.84q.19-3.47.21-6.66a9.78,9.78,0,0,0-.12-1.65,2.11,2.11,0,0,0-.4-1,.72.72,0,0,0-.76-.22,3.07,3.07,0,0,0-1.21.82,7.27,7.27,0,0,0-1.23,1.51,9.3,9.3,0,0,0-.81,1.72,11.53,11.53,0,0,0-.48,1.86c-.11.64-.18,1.3-.23,2Q130,254,130,257.26a11.33,11.33,0,0,0,.11,1.66,2,2,0,0,0,.39,1,.72.72,0,0,0,.76.22,3.13,3.13,0,0,0,1.21-.81,7.78,7.78,0,0,0,1.24-1.53,8.82,8.82,0,0,0,.82-1.73,11.41,11.41,0,0,0,.49-1.87A16.21,16.21,0,0,0,135.25,252.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,226.94a30,30,0,0,1-.12,3,22.29,22.29,0,0,1-.27,2.37,11.44,11.44,0,0,1-.63,2.25,11.46,11.46,0,0,1-2.87,4.24,4.28,4.28,0,0,1-1.59,1.06,1.53,1.53,0,0,1-1.22-.07,1.84,1.84,0,0,1-.79-1,5.21,5.21,0,0,1-.31-1.87c0-.51,0-1,0-1.47s.05-1,.09-1.56a20.27,20.27,0,0,1,.29-2.39,11.73,11.73,0,0,1,.62-2.25,12,12,0,0,1,1.11-2.16,12.18,12.18,0,0,1,1.75-2.07,4.41,4.41,0,0,1,1.59-1.06,1.53,1.53,0,0,1,1.22.07,1.94,1.94,0,0,1,.8,1A5.75,5.75,0,0,1,150,226.94Zm-2.86,23.44a8.8,8.8,0,0,1-.38.89,2.45,2.45,0,0,1-.53.7l-2.3,2.2c-.25.24-.42.27-.52.09a1,1,0,0,1,.05-.83l12.91-37.31a8,8,0,0,1,.37-.89,2.87,2.87,0,0,1,.53-.7l2.31-2.2c.24-.24.42-.27.52-.1a1.06,1.06,0,0,1-.06.84Zm-2.08-16.19a3,3,0,0,0,.2,1.31c.12.22.36.15.72-.19a2.92,2.92,0,0,0,.77-1.24,8.48,8.48,0,0,0,.32-1.8c0-.47.07-.92.08-1.35s0-.84,0-1.27a3.1,3.1,0,0,0-.21-1.29c-.13-.21-.37-.15-.73.2a2.72,2.72,0,0,0-.75,1.22,8.92,8.92,0,0,0-.32,1.79c0,.47-.06.92-.07,1.34S145.05,233.76,145.06,234.19Zm16.4-4.76a30,30,0,0,1-.12,3,22.48,22.48,0,0,1-.27,2.38,11.44,11.44,0,0,1-.63,2.25,11.7,11.7,0,0,1-1.12,2.16,11.44,11.44,0,0,1-1.75,2.08,4.41,4.41,0,0,1-1.59,1.06,1.53,1.53,0,0,1-1.22-.07,1.88,1.88,0,0,1-.79-1,5.27,5.27,0,0,1-.31-1.88c0-.51,0-1,0-1.46s0-1,.09-1.57a20.1,20.1,0,0,1,.29-2.38,11.59,11.59,0,0,1,1.73-4.41,12.18,12.18,0,0,1,1.75-2.07,4.28,4.28,0,0,1,1.59-1.06,1.54,1.54,0,0,1,1.22.06,1.93,1.93,0,0,1,.8,1A5.69,5.69,0,0,1,161.46,229.43Zm-4.94,7.25a3.26,3.26,0,0,0,.19,1.32c.13.21.37.15.73-.2a2.83,2.83,0,0,0,.77-1.23,8.47,8.47,0,0,0,.32-1.81c0-.47.06-.91.08-1.34s0-.85,0-1.27a3.2,3.2,0,0,0-.21-1.29c-.13-.22-.37-.15-.73.19a2.72,2.72,0,0,0-.75,1.22,9,9,0,0,0-.32,1.8c0,.47-.06.92-.07,1.34S156.51,236.26,156.52,236.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.78,276.62a20.33,20.33,0,0,1,.38-2.84A16.37,16.37,0,0,1,132,271a16.67,16.67,0,0,1,1.41-2.71,13.64,13.64,0,0,1,2.07-2.47,5.38,5.38,0,0,1,1.83-1.25,2,2,0,0,1,1.46,0,1.93,1.93,0,0,1,1,1.09,5.4,5.4,0,0,1,.35,2.14c0,.67,0,1.38,0,2.14s-.06,1.48-.1,2.16a20.37,20.37,0,0,1-.39,2.84,17,17,0,0,1-.86,2.85,15.52,15.52,0,0,1-1.41,2.71,14.36,14.36,0,0,1-2.07,2.47,5.79,5.79,0,0,1-1.83,1.25,1.83,1.83,0,0,1-1.45,0,2,2,0,0,1-1-1.1,5.59,5.59,0,0,1-.35-2.14c0-.63,0-1.33,0-2.09S130.74,277.33,130.78,276.62Zm6.42-2.09c0-.3.05-.63.06-1s0-.73.05-1.1,0-.73,0-1.07v-.9a4.12,4.12,0,0,0-.13-1,.91.91,0,0,0-.34-.53.58.58,0,0,0-.55,0,2.2,2.2,0,0,0-.8.55,5.41,5.41,0,0,0-.81,1,6.83,6.83,0,0,0-.59,1.14,6.76,6.76,0,0,0-.39,1.23,7.83,7.83,0,0,0-.19,1.26c0,.28,0,.61-.06,1s0,.72,0,1.09,0,.73,0,1.08,0,.66,0,.93a2.08,2.08,0,0,0,.45,1.51c.28.25.73.07,1.35-.52a5.78,5.78,0,0,0,1.42-2.12A8.8,8.8,0,0,0,137.2,274.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.29,252.82c.11-.11.2-.14.28-.09s.11.17.11.34l-.08,2.57a1.69,1.69,0,0,1-.14.57,1.36,1.36,0,0,1-.29.47L144.7,261l-.1,3.31,4.17-4c.11-.1.2-.13.28-.08s.11.17.1.35l-.08,2.56a1.45,1.45,0,0,1-.13.57,1.36,1.36,0,0,1-.3.47l-4.17,4-.16,5.22a1.38,1.38,0,0,1-.13.57,1.25,1.25,0,0,1-.28.46l-2,1.87c-.11.11-.2.13-.28.08s-.12-.16-.12-.33l.5-15.62a1.92,1.92,0,0,1,.13-.57,1.35,1.35,0,0,1,.29-.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.52,244c.11-.1.21-.13.28-.08s.12.16.12.34l-.09,2.57a1.65,1.65,0,0,1-.13.57,1.47,1.47,0,0,1-.3.47l-4.47,4.27-.1,3.31,4.17-4c.11-.1.2-.13.28-.08s.11.17.1.35l-.07,2.55a1.48,1.48,0,0,1-.14.58,1.31,1.31,0,0,1-.29.47l-4.17,4-.17,5.22a1.62,1.62,0,0,1-.12.57,1.35,1.35,0,0,1-.29.46l-2,1.87c-.11.1-.2.13-.28.08s-.11-.16-.11-.34l.5-15.61a1.38,1.38,0,0,1,.13-.57,1.25,1.25,0,0,1,.28-.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.81,304.78h0a.46.46,0,0,1-.35-.5V293.45a.88.88,0,0,1,.13-.47.55.55,0,0,1,.38-.3l6.1-.74a.4.4,0,0,1,.44.38.9.9,0,0,1-.1.55l-6.09,11.58a.73.73,0,0,1-.25.27h0A.36.36,0,0,1,110.81,304.78Zm.18-11.6s0,0,0,.05a.46.46,0,0,0-.06.22v10.6l6-11.41a.54.54,0,0,0,0-.19l-6,.73Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.4,300h-.08a.43.43,0,0,1-.3-.46V288.57a.7.7,0,0,1,.48-.7h0l6.16-.75a.34.34,0,0,1,.34.15.72.72,0,0,1,0,.71l-6.16,11.7A.5.5,0,0,1,115.4,300Zm-.05-.49Zm.24-11.14a.47.47,0,0,0-.07.21v10.62l6-11.45a.76.76,0,0,0,0-.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.59,295h0a.45.45,0,0,1-.36-.5V283.63a1,1,0,0,1,.13-.47.55.55,0,0,1,.39-.3l6.09-.74a.4.4,0,0,1,.44.38.89.89,0,0,1-.1.55l-6.09,11.58a.66.66,0,0,1-.25.27h0A.42.42,0,0,1,120.59,295Zm.19-11.6s0,0,0,.05a.46.46,0,0,0-.06.22v10.6l6-11.41a.54.54,0,0,0,0-.19l-6,.73Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.7,363.17v-4.42l-.62.36s-.08,0-.1,0a.7.7,0,0,1,0-.24v-.21a1,1,0,0,1,0-.27.19.19,0,0,1,.1-.14l1.93-1.12s.08,0,.1,0a.62.62,0,0,1,0,.24v.21a1,1,0,0,1,0,.28.3.3,0,0,1-.1.14l-.62.36v4.42a.44.44,0,0,1-.27.38l-.16.09C119.79,363.35,119.7,363.32,119.7,363.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.53,362.12V357a.42.42,0,0,1,.26-.38l.17-.1c.17-.1.25-.07.25.08v2l1-.59V356a.42.42,0,0,1,.26-.37l.16-.1c.17-.1.26-.07.26.08v5.09a.45.45,0,0,1-.26.38l-.16.09c-.18.1-.26.08-.26-.07V359l-1,.59v2.16a.43.43,0,0,1-.25.38l-.17.1C121.61,362.3,121.53,362.27,121.53,362.12Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.59,360.35v-5.09a.43.43,0,0,1,.26-.39l.17-.09c.17-.1.25-.07.25.09V360a.44.44,0,0,1-.25.38l-.17.1C124.67,360.54,124.59,360.51,124.59,360.35Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.16,359.6a.47.47,0,0,1-.36-.08l0-.1a.41.41,0,0,1,0-.12,1.77,1.77,0,0,1,.06-.43.5.5,0,0,1,.14-.28h.1l.09,0a.53.53,0,0,0,.47-.05.93.93,0,0,0,.33-.35,1.15,1.15,0,0,0,.14-.57.59.59,0,0,0-.12-.44.8.8,0,0,0-.37-.17,1.32,1.32,0,0,1-.43-.19.75.75,0,0,1-.26-.37,2,2,0,0,1-.09-.68,2.78,2.78,0,0,1,.29-1.29,2.13,2.13,0,0,1,.77-.85,1.3,1.3,0,0,1,.36-.13.53.53,0,0,1,.29,0,.19.19,0,0,1,.08.18,1.76,1.76,0,0,1-.06.41c0,.17-.08.26-.13.29a.2.2,0,0,1-.12,0,.7.7,0,0,0-.38.1.78.78,0,0,0-.32.35,1.12,1.12,0,0,0-.11.47.7.7,0,0,0,.07.36.31.31,0,0,0,.16.16l.32.1a.94.94,0,0,1,.53.35,1.51,1.51,0,0,1,.18.85,3,3,0,0,1-.13.9,2.44,2.44,0,0,1-.37.8,1.85,1.85,0,0,1-.59.56A1.23,1.23,0,0,1,126.16,359.6Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.26,357.73l-.68-4.7v-.11c0-.13.09-.25.27-.35l.11-.07c.18-.1.27-.08.29.05l.31,3,.07.66,0,.37c0-.27.06-.65.11-1.16l.37-3.46a.21.21,0,0,1,.06-.16.5.5,0,0,1,.15-.13l.2-.11a.46.46,0,0,1,.16-.06s.06,0,.07.08l.36,3.06c0,.1,0,.31.07.61a4.12,4.12,0,0,0,0,.42l.09-1.15.33-3.4a.47.47,0,0,1,.28-.37l.09,0q.27-.17.27,0v.12l-.69,5.49a.37.37,0,0,1-.22.28l-.29.17c-.13.07-.2.07-.21,0l-.38-2.75-.07-.85-.06.93-.39,3.19a.42.42,0,0,1-.22.28l-.29.16C129.35,357.83,129.28,357.82,129.26,357.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.73,355.8a.31.31,0,0,1,0-.2v-4.94a.55.55,0,0,1,0-.24.31.31,0,0,1,.13-.15l1.49-.86c.05,0,.08,0,.1,0a.6.6,0,0,1,0,.23v.21a1,1,0,0,1,0,.27.19.19,0,0,1-.1.14l-1,.57v1.37l.88-.5s.08,0,.1,0a.66.66,0,0,1,0,.24v.2a1,1,0,0,1,0,.28.22.22,0,0,1-.1.14l-.88.51v1.49l1-.57c.05,0,.08,0,.1,0a.62.62,0,0,1,0,.24v.2a1,1,0,0,1,0,.28.22.22,0,0,1-.1.14l-1.49.86C132.8,355.82,132.75,355.83,132.73,355.8Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.06,354.45s0-.09,0-.2v-4.93a.57.57,0,0,1,0-.25.25.25,0,0,1,.13-.14l1.49-.86s.08,0,.1,0a.62.62,0,0,1,0,.24v.2a1,1,0,0,1,0,.28.24.24,0,0,1-.1.14l-1,.57v1.37l.88-.51c.05,0,.08,0,.1,0a.6.6,0,0,1,0,.23v.21a1,1,0,0,1,0,.27.19.19,0,0,1-.1.14l-.88.51v1.5l1-.57s.08,0,.1,0a.62.62,0,0,1,0,.24v.21a1,1,0,0,1,0,.28.22.22,0,0,1-.1.13l-1.49.86C135.13,354.48,135.08,354.48,135.06,354.45Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.65,351.77c0,.08-.08.16-.24.25l-.26.15a.49.49,0,0,1-.17.08.1.1,0,0,1-.1-.06l-.84-2v2.42a.44.44,0,0,1-.27.38l-.15.09c-.18.1-.26.08-.26-.07v-5.1a.43.43,0,0,1,.26-.38l.15-.08c.18-.11.27-.08.27.07v2.38h0l.83-3a.42.42,0,0,1,.09-.16.74.74,0,0,1,.16-.12l.21-.12c.17-.1.25-.11.25,0a.54.54,0,0,1,0,.18l-.89,3,1,2A.31.31,0,0,1,139.65,351.77Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.53,348.59c0-1.87.44-3.06,1.32-3.56s1.31.17,1.31,2.05-.44,3.07-1.31,3.57S140.53,350.47,140.53,348.59Zm1.79.46a6.19,6.19,0,0,0,.15-1.58,4.23,4.23,0,0,0-.15-1.4c-.1-.23-.25-.29-.47-.16a1.13,1.13,0,0,0-.47.71,6.11,6.11,0,0,0-.15,1.57,4.3,4.3,0,0,0,.15,1.41.3.3,0,0,0,.47.17A1.13,1.13,0,0,0,142.32,349.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.67,349.33v-5.09a.45.45,0,0,1,.26-.38l.14-.08a.24.24,0,0,1,.15,0s.06,0,.09.1l1,2.32c0,.09.09.25.16.48l0,0a3.6,3.6,0,0,1,0-.56v-2.84a.45.45,0,0,1,.26-.38l.1-.06c.18-.1.26-.07.26.08v5.09a.43.43,0,0,1-.26.38l-.1.06a.37.37,0,0,1-.15.05s-.07,0-.09-.1l-1.06-2.4a3.9,3.9,0,0,1-.14-.42l0,0a4.73,4.73,0,0,1,0,.52V349a.45.45,0,0,1-.26.38l-.11.06C143.76,349.51,143.67,349.48,143.67,349.33Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.75,347.7s0-.09,0-.2v-5a.45.45,0,0,1,.26-.38l.16-.09c.09-.06.16-.08.2-.06s.06.06.06.14v4.42l.86-.5c.05,0,.09,0,.11,0a.62.62,0,0,1,0,.24v.2a1,1,0,0,1,0,.28.23.23,0,0,1-.11.14l-1.37.79C146.82,347.73,146.78,347.73,146.75,347.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.07,346.22V344l-.82-2.31a.53.53,0,0,1,0-.16c0-.1.09-.2.27-.31l.21-.11a.43.43,0,0,1,.17-.07.08.08,0,0,1,.08.06l.48,1.76.48-2.32a.28.28,0,0,1,.08-.15.83.83,0,0,1,.18-.13l.16-.1c.19-.1.28-.11.28,0a.82.82,0,0,1,0,.2l-.81,3.28v2.18a.44.44,0,0,1-.26.38l-.16.09C149.15,346.4,149.07,346.37,149.07,346.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.19,362.35l-18.85,10.88c-.24.14-.43,0-.43-.31V366.5a1,1,0,0,1,.43-.8l18.85-10.89c.23-.13.42,0,.42.32v6.41A1,1,0,0,1,144.19,362.35Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.52,369.44a.22.22,0,0,1,0-.14v-3.43a.4.4,0,0,1,0-.17.22.22,0,0,1,.09-.1l.63-.36c.24-.14.42-.16.54-.07a.76.76,0,0,1,.18.59,1.92,1.92,0,0,1-.09.59,1.58,1.58,0,0,1-.23.47v0a.28.28,0,0,1,.28.14,1,1,0,0,1,.11.54,1.91,1.91,0,0,1-.2.91,1.41,1.41,0,0,1-.58.63l-.64.36S128.54,369.46,128.52,369.44Zm.71-2.6a.48.48,0,0,0,.2-.26,1.1,1.1,0,0,0,.08-.43.61.61,0,0,0-.07-.34c0-.05-.11-.05-.2,0L129,366v1Zm.05,1.63c.2-.11.29-.36.29-.74a.59.59,0,0,0-.07-.35c-.05-.06-.13-.05-.24,0l-.31.18v1.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.6,368c-.15-.11-.22-.35-.22-.71v-2.58a.3.3,0,0,1,.18-.26l.11-.07q.18-.11.18.06V367a.45.45,0,0,0,.1.34c.06.07.15.07.26,0a.63.63,0,0,0,.26-.31,1,1,0,0,0,.1-.46V364a.3.3,0,0,1,.18-.26l.11-.06c.12-.07.18-.06.18,0v2.58a2.07,2.07,0,0,1-.22,1,1.53,1.53,0,0,1-.61.65C131,368.12,130.74,368.14,130.6,368Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.86,366.83V365.3l-.56-1.61a.26.26,0,0,1,0-.11c0-.07.06-.14.19-.21l.14-.08a.28.28,0,0,1,.12-.05s0,0,.05.05l.34,1.21.33-1.61a.21.21,0,0,1,.06-.1l.12-.09.11-.07c.13-.07.2-.08.2,0a.9.9,0,0,1,0,.15l-.56,2.27v1.52a.32.32,0,0,1-.19.26l-.11.06C132.92,367,132.86,366.94,132.86,366.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.65,365.8v-3.54a.31.31,0,0,1,.18-.26l.09-.05a.21.21,0,0,1,.11,0,.14.14,0,0,1,.06.08l.7,1.61a1.75,1.75,0,0,1,.11.33l0,0a2.56,2.56,0,0,1,0-.39v-2a.31.31,0,0,1,.18-.27l.07,0q.18-.11.18.06v3.53a.31.31,0,0,1-.18.27l-.07,0-.11,0s-.05,0-.06-.07l-.73-1.66a1.82,1.82,0,0,1-.1-.29l0,0a2.16,2.16,0,0,1,0,.35v2a.3.3,0,0,1-.18.26l-.07,0C134.71,365.92,134.65,365.91,134.65,365.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.68,362.85c0-1.3.3-2.12.91-2.47s.91.12.91,1.42-.3,2.14-.91,2.49S136.68,364.16,136.68,362.85Zm1.24.32a4.18,4.18,0,0,0,.11-1.09,2.93,2.93,0,0,0-.11-1c-.07-.16-.18-.2-.32-.11a.77.77,0,0,0-.33.49,4.18,4.18,0,0,0-.11,1.09,2.89,2.89,0,0,0,.11,1q.1.26.33.12A.8.8,0,0,0,137.92,363.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.11,363.28l-.47-3.27a.07.07,0,0,1,0-.05v0c0-.08.06-.16.18-.23l.08-.05c.12-.07.19-.06.2,0l.22,2.1,0,.46,0,.26c0-.19.05-.45.08-.8l.26-2.41a.18.18,0,0,1,0-.11.35.35,0,0,1,.11-.09L140,359a.21.21,0,0,1,.11,0s0,0,0,.06l.25,2.12a3.68,3.68,0,0,1,.05.42c0,.08,0,.18,0,.3l.07-.8.22-2.36a.34.34,0,0,1,.19-.26l.07,0c.13-.07.19-.06.19,0v.08l-.48,3.82a.29.29,0,0,1-.15.19l-.2.11c-.09.06-.14.05-.15,0l-.26-1.92,0-.59-.05.65-.27,2.22a.27.27,0,0,1-.15.19l-.2.11C139.17,363.35,139.12,363.34,139.11,363.28Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--x--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.85,182.94l-2.09-1.2h0a3.53,3.53,0,0,0-3.54.36,11.12,11.12,0,0,0-5,8.72,3.53,3.53,0,0,0,1.47,3.25h0l1.9,1.08.45-.74a5.21,5.21,0,0,0,1.44-.56,11.14,11.14,0,0,0,5-8.72,5.62,5.62,0,0,0-.16-1.29Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.85,182.94l-2.09-1.2h0a3.53,3.53,0,0,0-3.54.36,11.12,11.12,0,0,0-5,8.72,3.53,3.53,0,0,0,1.47,3.25h0l1.9,1.08.45-.74a5.21,5.21,0,0,0,1.44-.56,11.14,11.14,0,0,0,5-8.72,5.62,5.62,0,0,0-.16-1.29Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.36,189.12a8.26,8.26,0,0,0-.19,1.69,3.53,3.53,0,0,0,1.47,3.25h0l1.9,1.08.45-.74a5.21,5.21,0,0,0,1.44-.56,8.19,8.19,0,0,0,1.37-1Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.19,183.23a11.14,11.14,0,0,0-5,8.72c0,3.21,2.25,4.51,5,2.9a11.11,11.11,0,0,0,5-8.71C184.22,182.93,182,181.63,179.19,183.23Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.19,183.23a11.14,11.14,0,0,0-5,8.72c0,3.21,2.25,4.51,5,2.9a11.11,11.11,0,0,0,5-8.71C184.22,182.93,182,181.63,179.19,183.23Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.93,188.86l1.36-2.88a.77.77,0,0,0-.06-.94c-.26-.22-.53-.11-.69.23l-1.35,2.88-1.36-1.31c-.16-.16-.42,0-.59.33a.89.89,0,0,0,0,.9l1.36,1.31-1.36,2.88c-.16.34-.23.74,0,.92a.47.47,0,0,0,.7-.22l1.36-2.87,1.19,1.16a.24.24,0,0,0,.29,0,.76.76,0,0,0,.3-.35.89.89,0,0,0,0-.9Z",
    style: {
      fill: "#fafafa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--ad-1--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--ad--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.66,208.61a1.38,1.38,0,0,1,.14-.27h0A2.29,2.29,0,0,0,297.66,208.61Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,158a.61.61,0,0,0-.59-.47,1,1,0,0,0-.51.16l-86.33,49.84a2.25,2.25,0,0,0-.81.86l-3.44-2a2.37,2.37,0,0,1,.78-.82l86.33-49.83a2.55,2.55,0,0,1,2.3,0l1.16.65A2.49,2.49,0,0,1,386,158Z",
    style: {
      fill: "#37474f",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.61,303.39a2.65,2.65,0,0,1-2.3,0l-1.16-.71a2.5,2.5,0,0,1-1.16-2v-93.2a2.4,2.4,0,0,1,.37-1.17l3.44,2a2.28,2.28,0,0,0-.34,1.13v93.25C297.46,303.39,297.94,303.78,298.61,303.39Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.85
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.45,157.48a1,1,0,0,0-.52.16l-86.32,49.84a2.53,2.53,0,0,0-1.15,2v93.25c0,.52.26.82.64.82a1.09,1.09,0,0,0,.51-.15l86.32-49.84a2.54,2.54,0,0,0,1.15-2V158.3c0-.52-.26-.82-.63-.82Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M385.27,158.38v93.18a1.76,1.76,0,0,1-.74,1.29l-86.25,49.79V209.47a1.76,1.76,0,0,1,.74-1.29l86.25-49.8m.18-.9a1,1,0,0,0-.52.16l-86.32,49.84a2.53,2.53,0,0,0-1.15,2v93.25c0,.52.26.82.64.82a1.09,1.09,0,0,0,.51-.15l86.32-49.84a2.54,2.54,0,0,0,1.15-2V158.3c0-.52-.26-.82-.63-.82Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-88",
    d: "M376.55,246.41V169c0-1.49-1.05-2.09-2.34-1.35l-69.56,40.16a5.16,5.16,0,0,0-2.34,4.05v77.38c0,1.49,1,2.09,2.34,1.35l69.56-40.17A5.15,5.15,0,0,0,376.55,246.41Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--x--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.86,155l-2.08-1.2h0a3.51,3.51,0,0,0-3.53.36,11.13,11.13,0,0,0-5,8.72,3.53,3.53,0,0,0,1.47,3.25h0l1.9,1.09.44-.74a5.21,5.21,0,0,0,1.44-.56,11.14,11.14,0,0,0,5-8.72,5.62,5.62,0,0,0-.16-1.29Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.86,155l-2.08-1.2h0a3.51,3.51,0,0,0-3.53.36,11.13,11.13,0,0,0-5,8.72,3.53,3.53,0,0,0,1.47,3.25h0l1.9,1.09.44-.74a5.21,5.21,0,0,0,1.44-.56,11.14,11.14,0,0,0,5-8.72,5.62,5.62,0,0,0-.16-1.29Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.37,161.21a8.43,8.43,0,0,0-.19,1.7,3.53,3.53,0,0,0,1.47,3.25h0l1.9,1.09.44-.74a5.21,5.21,0,0,0,1.44-.56,8.69,8.69,0,0,0,1.38-1Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.2,155.33a11.13,11.13,0,0,0-5,8.72c0,3.21,2.26,4.51,5,2.9a11.1,11.1,0,0,0,5-8.71C391.23,155,389,153.72,386.2,155.33Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.2,155.33a11.13,11.13,0,0,0-5,8.72c0,3.21,2.26,4.51,5,2.9a11.1,11.1,0,0,0,5-8.71C391.23,155,389,153.72,386.2,155.33Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.94,161l1.36-2.88a.77.77,0,0,0-.06-.94c-.26-.22-.52-.11-.68.23l-1.36,2.88-1.36-1.31c-.16-.16-.42,0-.58.33a.89.89,0,0,0,0,.9l1.35,1.31-1.35,2.87c-.16.34-.23.75,0,.93a.47.47,0,0,0,.7-.22l1.36-2.87,1.2,1.16a.24.24,0,0,0,.29,0,.81.81,0,0,0,.29-.35.89.89,0,0,0,0-.9Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--ad--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.89,247.77V170.4c0-1.49-1-2.1-2.33-1.35L307,209.21a5.16,5.16,0,0,0-2.33,4v77.37c0,1.49,1,2.1,2.33,1.35l69.57-40.16A5.17,5.17,0,0,0,378.89,247.77Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.89,247.77V170.4c0-1.49-1-2.1-2.33-1.35L307,209.21a5.16,5.16,0,0,0-2.33,4v77.37c0,1.49,1,2.1,2.33,1.35l69.57-40.16A5.17,5.17,0,0,0,378.89,247.77Z",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--text--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.77,264.17c-14.5,8.38-26.3-.54-26.3-19.88s11.8-41.88,26.3-50.25,26.3.54,26.3,19.88S355.27,255.8,340.77,264.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.2,249.48c.32.71,1,.68,2-.15a2.58,2.58,0,0,0,1.2-2.21c-.16-1.09-1.26-.11-2.45.49s-3,1.23-3.34-1.17.9-4.64,3-6.36c1.89-1.55,3.38-1.72,4.2-.12l-2,2.44c-.35-.64-.95-.66-1.87.1a2.27,2.27,0,0,0-1.06,2c.15,1,1.06.37,2.4-.37s3-1.33,3.4,1.12-.81,4.61-3.07,6.47c-1.61,1.33-3.53,2.23-4.43.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.34,243.81l-.28,2.34-2.34,1.93,1.86-14.29,2.53-2.09,5.29,8.41-2.38,2-.84-1.43Zm1.74-6.76c-.43-.7-.75-1.24-.77-1.24l0,0s-.11.9-.26,2.08l-.32,2.81,2.39-2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.6,228l2.22-1.83,1.34,8.82,4.15-3.42.38,2.53-6.37,5.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.13,221.8l6.74-5.56.38,2.53-4.52,3.73.29,1.95,3.34-2.75.34,2.27-3.33,2.75.31,2.07,4.59-3.78.38,2.53-6.81,5.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.49,223.8c1.47-.64,2.89-.23,3.24,2.1.41,2.72-.8,6.43-4.37,9.37l-6.16,5.08-2.66-17.59,6.19-5.1c2.58-2.12,4.69-1.46,5,1a7.51,7.51,0,0,1-1.31,5.06Zm-3.37,1.36a3.4,3.4,0,0,0,1.3-3c-.15-1-.86-1.25-1.84-.44l-2.07,1.71.52,3.47Zm1.41,6.87a3.88,3.88,0,0,0,1.52-3.51c-.19-1.26-1-1.44-2.13-.51l-2.42,2,.61,4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.49,212.09l3.44-2.83,2.66,17.58-3.45,2.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.74,216c-.15-1-.15-1.12-.17-1.24l0,0a14.93,14.93,0,0,1-3.79,4.91c-4,3.29-7.94,2.38-8.76-3.09A17.6,17.6,0,0,1,348,201.36c3.26-2.69,6.09-2.54,7.44-.43l-3.23,3.93c-.72-.67-1.95-.9-3.78.6a9.27,9.27,0,0,0-3,8.32c.47,3.11,2.44,3.78,5,1.69a10.74,10.74,0,0,0,3.37-4.82l-.12-.83-3.61,3-.59-3.92,6.8-5.61,1.54,10.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.68,259.67l0-.12.47-.38,0,.15c.05.34.3.41.61.15a1.12,1.12,0,0,0,.41-1c-.05-.34-.29-.43-.6-.18-.59.49-1.05.36-1.15-.32a2.2,2.2,0,0,1,.81-2c.58-.48,1-.33,1.15.38l0,.11-.47.39,0-.14c-.06-.36-.29-.42-.59-.17a1.15,1.15,0,0,0-.43,1c.05.36.29.43.6.17.59-.48,1.05-.35,1.15.34a2.21,2.21,0,0,1-.79,2C329.25,260.53,328.78,260.39,328.68,259.67Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,254.21l.42,2.8-.47.39-.41-2.73c-.06-.4-.29-.5-.61-.24a1.2,1.2,0,0,0-.41,1.08l.42,2.73-.48.38-.8-5.33.47-.39.26,1.71a1.86,1.86,0,0,1,.57-.85C332.43,253.36,332.86,253.45,333,254.21Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.9,255.27l-.23-1.51a2.37,2.37,0,0,1,.81-2.09c.59-.49,1.07-.31,1.18.44l.23,1.52a2.31,2.31,0,0,1-.8,2.08C334.5,256.2,334,256,333.9,255.27Zm1.53-1.22-.24-1.57c-.06-.4-.3-.51-.62-.24a1.23,1.23,0,0,0-.43,1.11l.23,1.57c.06.39.31.5.64.22A1.21,1.21,0,0,0,335.43,254.05Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.36,249.87l.24,1.56a2.12,2.12,0,0,1-.72,2c-.26.22-.49.28-.66.18l.23,1.53-.47.38-.78-5.15.47-.39,0,.25a1.92,1.92,0,0,1,.56-.84C337.78,249,338.24,249,338.36,249.87Zm-.47.38c-.06-.4-.29-.5-.62-.23a1.18,1.18,0,0,0-.42,1.1l.23,1.57c.06.4.29.51.63.23a1.23,1.23,0,0,0,.42-1.1Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.48,248.2a2.31,2.31,0,0,1-.8,2.08c-.59.5-1.08.32-1.19-.44l-.23-1.51a2.37,2.37,0,0,1,.81-2.09c.59-.49,1.07-.31,1.18.45v.07l-.46.38,0-.09c-.06-.4-.3-.51-.62-.24a1.23,1.23,0,0,0-.43,1.11l.23,1.57c.06.39.31.5.64.22a1.21,1.21,0,0,0,.42-1.09l0-.1.47-.39Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.46,243.54l.48-.39.8,5.34-.47.39Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.64,245.69l.1.68c.06.4.31.5.64.23a1.23,1.23,0,0,0,.42-1.1l0-.1.47-.39v.08a2.32,2.32,0,0,1-.8,2.08c-.59.49-1.08.32-1.19-.44l-.23-1.52a2.39,2.39,0,0,1,.81-2.09c.59-.48,1.07-.31,1.18.45l.13.86Zm-.13-.89.05.34,1.05-.86-.05-.35c-.06-.39-.3-.5-.62-.24A1.24,1.24,0,0,0,344.51,244.8Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.59,241.46l.41,2.7-.46.38-.05-.28a2,2,0,0,1-.64.94c-.57.47-1,.3-1.05-.31a2,2,0,0,1,.42-1.43c.41-.6,1-1.06.92-1.55v-.09c-.06-.4-.31-.5-.64-.22a1.19,1.19,0,0,0-.42,1.1v.12l-.47.38v-.1a2.3,2.3,0,0,1,.8-2.07C348,240.53,348.48,240.71,348.59,241.46Zm-.23,1.89-.1-.66a7.46,7.46,0,0,1-.71.92,1.14,1.14,0,0,0-.29.85c.05.32.27.39.62.11A1.3,1.3,0,0,0,348.36,243.35Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.4,238.6l.09.57-.26.21a1.19,1.19,0,0,0-.41,1.08l.4,2.69-.47.39-.58-3.88.47-.38.05.3a1.77,1.77,0,0,1,.57-.86Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.87,237.94l.4,2.7-.46.38,0-.28a2.14,2.14,0,0,1-.64.94c-.58.47-1,.3-1.05-.31a2,2,0,0,1,.41-1.43c.42-.6,1-1.06.92-1.56v-.08c-.06-.4-.31-.5-.64-.23a1.23,1.23,0,0,0-.42,1.1l0,.13-.47.38,0-.1a2.36,2.36,0,0,1,.8-2.08C352.27,237,352.75,237.18,352.87,237.94Zm-.24,1.89-.1-.66a7.41,7.41,0,0,1-.7.92,1.17,1.17,0,0,0-.3.84c.05.33.28.4.62.12A1.31,1.31,0,0,0,352.63,239.83Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.57,235.68l.41,2.72-.46.39-.41-2.72c-.06-.4-.3-.51-.61-.25a1.19,1.19,0,0,0-.41,1.09l.41,2.72L354,240l-.59-3.87.48-.39,0,.27a1.73,1.73,0,0,1,.57-.87C355.06,234.72,355.46,234.93,355.57,235.68Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.47,235a2.33,2.33,0,0,1-.8,2.09c-.59.49-1.08.32-1.19-.44l-.23-1.52a2.39,2.39,0,0,1,.81-2.09c.59-.48,1.07-.31,1.18.45v.07l-.47.39v-.1c-.06-.4-.3-.5-.62-.24a1.24,1.24,0,0,0-.43,1.11l.23,1.57c.06.4.31.5.64.23a1.23,1.23,0,0,0,.42-1.1l0-.1.47-.39Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.36,233.56l.1.68c.06.4.31.5.64.23a1.23,1.23,0,0,0,.42-1.1l0-.1.47-.39V233a2.33,2.33,0,0,1-.8,2.09c-.59.49-1.08.32-1.19-.44l-.23-1.52a2.39,2.39,0,0,1,.81-2.09c.59-.48,1.07-.31,1.18.45l.13.86Zm-.13-.89,0,.34,1.05-.86-.05-.35c-.06-.39-.3-.5-.62-.24A1.24,1.24,0,0,0,359.23,232.67Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "366.22 245.07 354.57 261.63 358.29 252.1 366.22 245.07",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "366.22 245.07 354.57 261.63 358.29 252.1 366.22 245.07",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.84 255.41 364.8 235.16 366.22 245.07 341.85 266.86 339.84 255.41",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.84 255.41 364.8 235.16 366.22 245.07 341.85 266.86 339.84 255.41",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.44,261l0-.25.67-.56,0,.25c.05.29.22.37.46.17a.86.86,0,0,0,.3-.79l-.08-.51c0-.29-.21-.37-.45-.17-.64.53-1.13.35-1.25-.44l-.1-.63a2.43,2.43,0,0,1,.86-2.19c.65-.53,1.14-.34,1.26.45l0,.25-.67.55,0-.25c-.05-.29-.21-.36-.45-.17a.89.89,0,0,0-.31.8l.09.63c.05.29.22.36.46.17.64-.53,1.13-.35,1.25.44l.08.51a2.43,2.43,0,0,1-.86,2.19C343.05,262,342.56,261.81,342.44,261Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.68,254.53l.68-.56.4,2.68.66-.53-.41-2.69.68-.56.81,5.34-.68.56-.28-1.82-.65.54.27,1.82-.68.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.16,256.32l-.45-2.94a2.46,2.46,0,0,1,.86-2.18c.64-.53,1.14-.35,1.26.44l.44,2.93a2.45,2.45,0,0,1-.86,2.19C348.77,257.29,348.28,257.11,348.16,256.32Zm1.43-1.19-.44-2.93c0-.29-.22-.37-.45-.17a.86.86,0,0,0-.31.79l.44,2.94c.05.29.22.37.45.17A.87.87,0,0,0,349.59,255.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.49,249.74l1.07-.88c.63-.52,1.11-.34,1.23.43l.1.68a2.37,2.37,0,0,1-.84,2.13l-.39.32.31,2.1-.67.56Zm1.43,1.52a.82.82,0,0,0,.29-.74l-.1-.67c0-.27-.2-.34-.42-.16l-.4.33.24,1.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.64,244.67l.81,5.34-.52.43-1.39-2.35.47,3.1-.63.53-.81-5.34.52-.43,1.39,2.35-.47-3.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.11,248.11l-.44-2.93a2.44,2.44,0,0,1,.85-2.19c.65-.53,1.14-.34,1.26.45l.44,2.93a2.43,2.43,0,0,1-.86,2.19C358.72,249.09,358.23,248.9,358.11,248.11Zm1.44-1.18L359.1,244c0-.3-.21-.37-.45-.17a.86.86,0,0,0-.31.79l.45,2.93c0,.3.21.37.45.18A.92.92,0,0,0,359.55,246.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.64,238.9l.25,5.8-.73.6-1-2.72v3.51l-.73.6-1.36-4.88.7-.57.85,3.26-.06-3.91.56-.46,1,3.13-.21-3.79Z",
    style: {
      fill: "#fff"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.31,413l7.78-14.87,17.65,8.81c-9.21,8.88-19.15,19.7-21.38,23.6,0,0-9.55-2.24-11-7.13S290.71,414.57,293.31,413Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.46,418.72a8.08,8.08,0,0,0-2.15,2.29c-.62.91-.49,5.34-1.1,7.39s-1.08,2.59-2.09,5.15c-1.12,2.85-3.17,5.43-1,12.8s5.79,10.91,8.84,12.74a8.09,8.09,0,0,0,3.7.94s4.05-1.47,3.46-3.86S282.46,418.72,282.46,418.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,427a8.91,8.91,0,0,1-1.62,2.51c-1.48,2.06-2.17,4.86-2.71,7.31-2.52,11.58,2,17.55-4.28,21.82-1.83,1.12-5.58.76-11.2-6.63-2.87-3.78-4.44-11.49-3.26-14.95s2.77-5.72,3.54-8.39.44-7.67,1.95-9.95a10.8,10.8,0,0,1,3.67-3.07c1.11-.66,3.55-1.52,4.69-2.15s1.77-1.35,2.49-.52l-1.33,1.6c-2.07,2.79-1.51,3.21-1.48,4.72a23.36,23.36,0,0,1-.82,4.77c1.48-1.81,2.09-3.4,3.67-3.1s1.77.22,4,2.38S300.15,426.33,300,427Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,427a8.91,8.91,0,0,1-1.62,2.51c-1.48,2.06-2.17,4.86-2.71,7.31-2.52,11.58,2,17.55-4.28,21.82-1.83,1.12-5.58.76-11.2-6.63-2.87-3.78-4.44-11.49-3.26-14.95s2.77-5.72,3.54-8.39.44-7.67,1.95-9.95a10.8,10.8,0,0,1,3.67-3.07c1.11-.66,3.55-1.52,4.69-2.15s1.77-1.35,2.49-.52l-1.33,1.6c-2.07,2.79-1.51,3.21-1.48,4.72a23.36,23.36,0,0,1-.82,4.77c1.48-1.81,2.09-3.4,3.67-3.1s1.77.22,4,2.38S300.15,426.33,300,427Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.23,452c-2.87-3.78-4.44-11.49-3.26-14.95a33.28,33.28,0,0,1,1.38-3.36c-.05.23-.12.47-.15.67-.08.45-.15.9-.19,1.36a10.42,10.42,0,0,0,.51,5.28c.64,1.45,2.11,5.1,4.06,5.21,1.11.06,2.06-1,2.5-2.25.18-.52.5-1.92.5-1.92a17.29,17.29,0,0,1,5.05,2.13c2.81,1.91,2.71,2.33,2.71,2.33a7.54,7.54,0,0,0-.13,2.49,6.13,6.13,0,0,0,1,2.49,3.84,3.84,0,0,0,.71.58,7.56,7.56,0,0,1-3.52,6.57C289.6,459.76,285.85,459.4,280.23,452Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.71,436.82a39.43,39.43,0,0,0-.84,9.27c-1.1,3-2,2.86-2.15,1.32s2-7.91,3.62-13.18C296.1,435.11,295.89,436,295.71,436.82Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.88,418.11a6.4,6.4,0,0,1,1.19-4.24c.28-.13.54-.25.75-.37,1.23-.68,1.77-1.35,2.49-.52l-1.33,1.6c-2.07,2.79-1.51,3.21-1.48,4.72a23.36,23.36,0,0,1-.82,4.77c-1.24,5-2.34,6.7-3,11.45s.3,8-.38,8.24-2-.3-2.23-4.12,1.57-10.22,2.79-13.24S289.09,420.15,288.88,418.11Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.24,442.38a.47.47,0,0,0,.24.13,11.41,11.41,0,0,1,7.56,4.56.48.48,0,0,0,.67.06.48.48,0,0,0,.06-.67,12.32,12.32,0,0,0-8.09-4.88.47.47,0,0,0-.56.37A.45.45,0,0,0,285.24,442.38Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.89,438.41a.49.49,0,0,0,.23.14,12.7,12.7,0,0,1,8,5,.49.49,0,0,0,.75-.63,13.66,13.66,0,0,0-8.47-5.29.49.49,0,0,0-.47.81Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.86,434a.61.61,0,0,0,.26.15,14.51,14.51,0,0,1,8.9,5.58.54.54,0,1,0,.82-.69,15.54,15.54,0,0,0-9.47-5.94.55.55,0,0,0-.65.4A.57.57,0,0,0,285.86,434Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.54,430.31a.47.47,0,0,0,.26.14,14.14,14.14,0,0,1,8.7,5.46.53.53,0,0,0,.74.06.52.52,0,0,0,.06-.74,15.07,15.07,0,0,0-9.26-5.8.53.53,0,0,0-.5.88Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,426.68a.46.46,0,0,0,.25.15,14.07,14.07,0,0,1,8.7,5.46.53.53,0,0,0,.74.06.52.52,0,0,0,.07-.74,15.12,15.12,0,0,0-9.26-5.8.52.52,0,0,0-.5.87Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.41,357.84s42.19-.75,57.55.68c15.66,1.46,16.1,13.36,11.55,20.22C334.8,391.89,308.1,418,308.1,418s-9.5-3.79-11.54-11.61l6.28-13.22-30.75,1.55-5.19-4.45Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.41,357.84s42.19-.75,57.55.68c15.66,1.46,16.1,13.36,11.55,20.22C334.8,391.89,308.1,418,308.1,418s-9.5-3.79-11.54-11.61l6.28-13.22-30.75,1.55-5.19-4.45Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.36,404.75c-3-4.59-5.15-5.79-11-8.42l-4.77,10.05c2,7.82,11.54,11.61,11.54,11.61s3.08-3,7.48-7.5A57.42,57.42,0,0,0,312.36,404.75Z",
    style: {
      fill: "#FE3E69",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.05,380.44c-2.21,2.75-4.15,5.24-5.82,7.63s-6.3,3.21-10.8,1.87c-5.6-1.65-11.83-5.06-15.45-7,3.79-6.06.58-13.4.58-13.4.4,5.06-1.12,9.59-3.19,12l-2.24,2.22.46,8.06,2,2.86,31.29-1.5c6.51-12.39,8.53-17.91,15.43-20C318.27,373.19,312.62,372.27,306.05,380.44Z",
    style: {
      fill: "#FE3E69",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.93,459.3l-12.46-15.87L323,432.91c5.47,10.33,10.82,20.22,14.51,24.17,0,0-3.44,8.73-8.54,8.81S321.77,462.22,320.93,459.3Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.42,468.41a8,8,0,0,0,1.63,2.68c.71.85,5,1.9,6.83,3s2.21,1.73,4.41,3.39c2.43,1.84,4.38,4.5,12.06,4.37s12.06-2.67,14.64-5.12a8,8,0,0,0,1.9-3.31s-.34-4.3-2.8-4.37S323.42,468.41,323.42,468.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.09,453.68c.7.31,1.52,1.65,2,2.24a19.91,19.91,0,0,0,6.32,4.55c10.49,5.53,17.45,2.74,19.89,10,.59,2.06-.76,5.58-9.39,9-4.4,1.76-12.25,1.21-15.28-.86s-4.77-4.19-7.14-5.64-7.26-2.48-9.06-4.54a10.84,10.84,0,0,1-2-4.35c-.34-1.26-1.24-5.54-1.24-5.54,2.14,2.74,4.46,1.92,5.92,2.3a23,23,0,0,1,4.38,2.06c-1.35-1.91-2.72-2.92-2-4.36s.69-1.65,3.37-3.23S335.47,453.39,336.09,453.68Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.09,453.68c.7.31,1.52,1.65,2,2.24a19.91,19.91,0,0,0,6.32,4.55c10.49,5.53,17.45,2.74,19.89,10,.59,2.06-.76,5.58-9.39,9-4.4,1.76-12.25,1.21-15.28-.86s-4.77-4.19-7.14-5.64-7.26-2.48-9.06-4.54a10.84,10.84,0,0,1-2-4.35c-.34-1.26-1.24-5.54-1.24-5.54,2.14,2.74,4.46,1.92,5.92,2.3a23,23,0,0,1,4.38,2.06c-1.35-1.91-2.72-2.92-2-4.36s.69-1.65,3.37-3.23S335.47,453.39,336.09,453.68Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.9,479.45c-4.4,1.76-12.25,1.21-15.28-.86a30,30,0,0,1-2.86-2.22l.6.33c.42.19.83.38,1.26.55a10.45,10.45,0,0,0,5.22.91c1.58-.23,5.49-.67,6.11-2.52.35-1.05-.43-2.25-1.5-3-.45-.32-1.72-1-1.72-1a17.11,17.11,0,0,1,3.41-4.29c2.59-2.2,3-2,3-2a7.45,7.45,0,0,0,2.36.78,6,6,0,0,0,2.68-.32,3.81,3.81,0,0,0,.76-.53,7.57,7.57,0,0,1,5.39,5.15C364.88,472.49,363.53,476,354.9,479.45Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.4,460.47a38.88,38.88,0,0,0,8.71,3.29c2.56,1.85,2.21,2.73.7,2.42s-7.09-4.06-11.73-7C342.85,459.64,343.64,460.08,344.4,460.47Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.54,462.06c-1.44-.24-2.57-.24-3.76-1-.76-.46-1-2.31-.94-3.12l1.17,1.48c2.1,1.16,3.65,1.05,5.11,1.43a23,23,0,0,1,4.38,2.06c4.51,2.54,5.83,4.05,10.25,5.91s7.76,1.85,7.83,2.57-.83,1.87-4.56,1-9.43-4.23-12-6.22S326.56,462.4,324.54,462.06Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347,472.05a.5.5,0,0,0,.19-.19,11.38,11.38,0,0,1,6.41-6.07.49.49,0,0,0,.24-.63.48.48,0,0,0-.63-.24,12.32,12.32,0,0,0-6.86,6.49.48.48,0,0,0,.65.64Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.31,470.37a.46.46,0,0,0,.19-.2,12.81,12.81,0,0,1,6.92-6.34.48.48,0,0,0,.24-.65.5.5,0,0,0-.65-.24,13.7,13.7,0,0,0-7.36,6.76.48.48,0,0,0,.19.66A.49.49,0,0,0,343.31,470.37Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.08,469.23a.52.52,0,0,0,.22-.22,14.51,14.51,0,0,1,7.75-7.08.54.54,0,1,0-.44-1,15.6,15.6,0,0,0-8.25,7.54.53.53,0,0,0,.21.73A.54.54,0,0,0,339.08,469.23Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.67,467.57a.45.45,0,0,0,.21-.2,14.12,14.12,0,0,1,7.58-6.93.54.54,0,0,0,.26-.7.53.53,0,0,0-.7-.26,15.17,15.17,0,0,0-8.06,7.37.53.53,0,0,0,.2.72A.52.52,0,0,0,335.67,467.57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.56,465.24a.47.47,0,0,0,.21-.21,14.11,14.11,0,0,1,7.58-6.92.53.53,0,0,0,.26-.7.52.52,0,0,0-.7-.26,15.17,15.17,0,0,0-8.06,7.37.54.54,0,0,0,.2.72A.54.54,0,0,0,332.56,465.24Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.49,443.84c-4,5.88-13.72,10.21-13.72,10.21s-3.63-3.92-12.46-12.48c-6.23-6-11.28-11.9-14.65-18.82-11.16-3.26-30.7-7.32-50.29-17.27-14-7.13-18.17-19.39-19.19-34.6-1.25-18.68,55.23-13,55.23-13-1.83,10.57.67,20.23-5.28,25.9,0,0,24.4,11.81,32.69,16.09,3.81,2,4.93,2,9,8.9C320.24,424.49,329.49,443.84,329.49,443.84Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.49,443.84c-4,5.88-13.72,10.21-13.72,10.21s-3.63-3.92-12.46-12.48c-6.23-6-11.28-11.9-14.65-18.82-11.16-3.26-30.7-7.32-50.29-17.27-14-7.13-18.17-19.39-19.19-34.6-1.25-18.68,55.23-13,55.23-13-1.83,10.57.67,20.23-5.28,25.9,0,0,24.4,11.81,32.69,16.09,3.81,2,4.93,2,9,8.9C320.24,424.49,329.49,443.84,329.49,443.84Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.64,452.6l.79-.43c-4.65-5.19-16.32-18.65-19.74-24.23-1.18-1.91-2.09-3.62-2.89-5.12-1.88-3.53-3.13-5.87-5.68-6.73-.55-.18-1.87-.58-3.88-1.17-10.19-3-37.28-11.07-46.41-17.08-.27-.18-.52-.37-.78-.56,3.56-3,3.74-9.22,1.56-13.26-2.33-4.33-3.67-12.64-1.84-16.48l-.79-.38c-2.13,4.48-.32,13.22,1.86,17.28,2,3.79,1.78,9.75-1.53,12.32-8.68-6.54-12.43-17-10.86-30.32l-.87-.11c-1.71,14.47,2.71,25.61,12.77,32.24,9.23,6.09,36.41,14.15,46.65,17.19,1.92.57,3.31,1,3.84,1.16,2.23.75,3.4,3,5.19,6.31.8,1.52,1.72,3.23,2.91,5.17C302.54,434.26,314.33,447.77,318.64,452.6Z",
    style: {
      fill: "#FE3E69",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--arm--inject-88",
    d: "M255.81,291c8.8-.54,16.27,4.7,17.25,11.71,1,7.26-2.64,28.87-2.64,28.87l15.89,11.17-8.42,11.68s-15.3-6.75-20.59-9.28c-8.08-3.86-6.91-6.33-6.81-16.31S254.79,296.66,255.81,291Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.85,291a21.64,21.64,0,0,1,6.81.66c1.92.62,5.87,2.3,7.89,4.94s3,4.8,2.89,10.8-1.86,18.42-1.86,18.42H258.51Z",
    style: {
      fill: "#FE3E69"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.1,313.52c-1.36-16.35-6.91-21.87-15.25-22.52a168.35,168.35,0,0,0-18.22,1.65,71.9,71.9,0,0,0-20,7.61c-4.16,2.55-5.52,8.07-5.68,19.64a260.13,260.13,0,0,0,1.93,33.39,172.27,172.27,0,0,0,5.5,28.8c11.48,3.93,57.2-9.7,56.95-24.31-1.16-3.35-3.19-7.23-4.08-14C271.1,331.86,271.52,318.66,271.1,313.52Z",
    style: {
      fill: "#FE3E69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.1,313.52c-1.36-16.35-6.91-21.87-15.25-22.52a168.56,168.56,0,0,0-18.22,1.65,71.9,71.9,0,0,0-20,7.61c-4.16,2.55-5.52,8.07-5.68,19.64a260.13,260.13,0,0,0,1.93,33.39,172.27,172.27,0,0,0,5.5,28.8c11.48,3.93,57.2-9.7,56.95-24.31-1.16-3.35-3.19-7.23-4.08-14C271.1,331.86,271.52,318.66,271.1,313.52Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.92,286.38c-.43-4.54-4.54-9.53-6.26-13.58s-2.6-6.91-2.12-10.44c.28-2.08,1.81-4.83,3.41-5.31a9.76,9.76,0,0,1,8-11.62,33,33,0,0,0,4.38-.88c1.74-.58,2.22-1.91,3.66-3,2.49-1.82,6.44-1.57,7.72,1.55,1.71-1.91,3.82-1.7,6.22-.9a4.19,4.19,0,0,1,2.85,5c3.4-1.59,6.23.94,6.39,2.88.12,1.43-.27,2.6.56,3.94.94,1.51,2.92,1.63,3.6.52.19,2-.71,3.51-2.88,3.24a4.61,4.61,0,0,1,.29,3.88,4.17,4.17,0,0,1-4,2.6,7.2,7.2,0,0,1-1.19,3,7.3,7.3,0,0,1-2.74,2.13c-3.42,1.34-7.11,1.58-10.73,2.06l-4.29.56c-.25,0-1.53,0-1.69.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.92,280.19a4.36,4.36,0,0,0,5.3.23l-1.31,14.75c2,6.49,12.71,8.35,16.77,6.85s3.73-3.87,1.44-7.6l.45-2.39a41.36,41.36,0,0,0,5.34.15c3.54-.22,6.39-2.87,7.67-6.6a39.46,39.46,0,0,0,1.53-15,13.48,13.48,0,0,1,.08-3.7,17.37,17.37,0,0,0-.51-8c-3.63-3.4-12.49-5.11-21.19-.65.6,5-1.62,8.81-5.36,10.44.07,1.35,0,4.74-2.2,4.52-1.59-.16-1.55-2.16-3-4s-5.27-2.62-6.93-.14C223.64,272.46,224.63,277.88,227.92,280.19Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.57,292c-5.52-1.06-9.71-2-12.31-6.22a34.93,34.93,0,0,1-2.88-6.85,27.36,27.36,0,0,0,1.78,8.45c1.22,2.67,4.37,5.19,13,6.58Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.17,271.2a1.6,1.6,0,0,1-1.61,1.59,1.64,1.64,0,1,1,1.61-1.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.12,265.38l-3.27,2a2,2,0,0,1,.66-2.71A1.88,1.88,0,0,1,248.12,265.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.06,267.13,259.83,265a1.86,1.86,0,0,1,2.63-.6A2,2,0,0,1,263.06,267.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.39,270.9a1.58,1.58,0,1,1-1.38-1.8A1.61,1.61,0,0,1,262.39,270.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.07,283.07a1.06,1.06,0,0,1-1.16,1,1.08,1.08,0,0,1-.92-1.21,1,1,0,1,1,2.08.24Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.7,283.78a2.19,2.19,0,0,0-1.59-1.34,1,1,0,0,0-.12.39,1.08,1.08,0,0,0,.92,1.21A1,1,0,0,0,252.7,283.78Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.08,276.64,254.59,279,253,268.27C255.07,267.57,257.63,272.52,260.08,276.64Z",
    style: {
      fill: "#f0997a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--laptop--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.07,372.54l0,.74a3,3,0,0,1-1.43,2.69l-52.2,32.46a3.05,3.05,0,0,1-3,.09l-29.55-15.73a3,3,0,0,1-1.6-2.59l0-1h0a.39.39,0,0,0,.2.33l32.46,17.34Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.89,406.86l.07,2a3.12,3.12,0,0,0,1.5-.45L331.66,376a3,3,0,0,0,1.44-2.68l0-.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.07,372.54l-32.14-17.18a1.83,1.83,0,0,0-1.81.06l-53.7,33.4a.4.4,0,0,0,0,.7l32.44,17.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.51 404.19 260.18 394.94 308.99 364.58 326.41 373.78 277.51 404.19",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.41 373.78 325.77 374.17 309.01 365.32 260.84 395.29 260.18 394.94 308.99 364.58 326.41 373.78",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.25 377.17 268.57 377.34 277.07 381.88 291.62 372.83 291.93 372.64 283.11 367.93 268.25 377.17",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.57 377.34 277.07 381.88 291.62 372.83 283.12 368.29 268.57 377.34",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,365.4c-1.76-2.46-3.94-4.63-5.54-7.2a44.16,44.16,0,0,0-5.14-4.5C304,350,302.67,350.07,296,348a28.54,28.54,0,0,1-9.73-5.22l-8.42,11.68c1,.54,1.91,1.09,2.83,1.65,1.49.91,3.43,4.22,6.81,5.48,4.47,1.67,9.72.49,10.22,1.78a9.19,9.19,0,0,0,.35,2.42,8.61,8.61,0,0,0-2.62-.67c-.82,0-2,1-1.74,1.54s.75.79,1.34,1.26c.41.32,1.8,1.44,2,1.56a8,8,0,0,0,4.18.64,1.83,1.83,0,0,0,1.37-1.2,7.37,7.37,0,0,0,1,.33,2.49,2.49,0,0,0,1.82-.12,1.51,1.51,0,0,0,.58-.86,7.78,7.78,0,0,0,2.19-.46c1-.56,1-1.78,1.17-2.75a12.42,12.42,0,0,0,.12-3.7c3,1.81,5.32,5.2,9,5.82C319.73,367.34,321.39,366.84,320,365.4Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.62,351.94c.84-14.21,1.71-27.09,3.43-37.55.95-5.78,6.27-11.29,11.84-13.51,8.15,4.51,7.66,21,7,25.05l-3.19,25.12s7.11,4.61,14.56,8.87c6.28,3.59,10.43,6.55,17.38,6.58s9.69-.52,13.44.63c2,.61,6.55,2,8.12,2.61s4.52,2.95,7.18,4.48-.24,2.92-2.1,2.6a23,23,0,0,1-5.68-2,30.47,30.47,0,0,0-4.82-1.24,27.2,27.2,0,0,1,1.59,5.28c.12,1,.48,2.15-.3,3a7.68,7.68,0,0,1-2,1.09,1.56,1.56,0,0,1-.3,1,2.52,2.52,0,0,1-1.7.65,8.5,8.5,0,0,1-1,0,1.83,1.83,0,0,1-.95,1.55,8,8,0,0,1-4.18.63c-.22-.06-1.88-.73-2.36-.91A4.08,4.08,0,0,1,257,385c-.4-.47.42-1.77,1.21-2a8.23,8.23,0,0,1,2.7-.13,9.36,9.36,0,0,1-1.05-2.21c-.86-1.09-6,.7-10.75.43-3.6-.21-6.53-3.27-8.2-3.8-10.67-3.42-18.79-5.73-29.75-10.74C201.12,362,202.19,359.32,202.62,351.94Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.76,373.8c-.69-1.27-1.7-2.76-2.76-3a12.11,12.11,0,0,1,1.82,2.8Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.15,382.93a11.46,11.46,0,0,0-.25-2.92,24.88,24.88,0,0,0-.7-2.83,12.62,12.62,0,0,0-1.11-2.73,5.29,5.29,0,0,0-2-2.13,4.05,4.05,0,0,1,.93,1.09,8.4,8.4,0,0,1,.7,1.24,19.9,19.9,0,0,1,1,2.69c.29.92.56,1.85.83,2.77A26.85,26.85,0,0,1,269.15,382.93Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.13,384.54a13.69,13.69,0,0,0-.33-2.85,22.22,22.22,0,0,0-.75-2.77,19.93,19.93,0,0,0-1.09-2.67,5.51,5.51,0,0,0-1.74-2.28,3.63,3.63,0,0,1,.78,1.17q.31.63.57,1.29c.34.88.66,1.77.95,2.66C265.12,380.89,265.69,382.68,266.13,384.54Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.19,383a4.71,4.71,0,0,1,1.2,0c.39,0,.68.2,1.18.3l-.23-.29a1.19,1.19,0,0,0,.14.56,1.62,1.62,0,0,0,.32.41,1.76,1.76,0,0,0,.86.43,3.81,3.81,0,0,1-.56-.68,1.65,1.65,0,0,1-.16-.36,1.1,1.1,0,0,1-.06-.32v-.22l-.24-.07a3.25,3.25,0,0,0-1.13-.1A2.34,2.34,0,0,0,258.19,383Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.93,300.05a20,20,0,0,0-12.29,14.34c-2,8.91-3,26.6-3,26.6s3,2.82,10.82,3.58,9.88-1.15,9.88-1.15,1.42-12.39,2.05-18.12S226.86,303.55,217.93,300.05Z",
    style: {
      fill: "#FE3E69"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M278.76,407.28a3.61,3.61,0,0,0,3.1-.34l52-32.32A3.63,3.63,0,0,0,335.5,372l4.66-34.77a3,3,0,0,0,0-.6,3.56,3.56,0,0,0-1.15-2.52l-54,33.59a2.67,2.67,0,0,0-1.24,1.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.89,406.86l.37.2a4.46,4.46,0,0,0,.5.22l5-37.63a2.67,2.67,0,0,1,1.24-1.91l54-33.59a3.41,3.41,0,0,0-.75-.54l-54.12,33.66a2.69,2.69,0,0,0-1.23,1.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.28,368.47l-.87-.46a2.69,2.69,0,0,0-.47,1.16l-5.05,37.69.37.2a4.46,4.46,0,0,0,.5.22l5-37.63A2.66,2.66,0,0,1,284.28,368.47Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.55,374.38c.31-2.33,2.6-5.49,5.11-7.05s4.3-.94,4,1.39-2.6,5.48-5.12,7S307.24,376.7,307.55,374.38Z",
    style: {
      fill: "#FE3E69"
    }
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaroga);
export default __webpack_public_path__ + "static/media/maroga.34a778d5e884fb6577c20504194a269b.svg";
export { ForwardRef as ReactComponent };